import { memo } from "react";

function SVG({
  name,
  classname = "",
  style = {},
  active = false,
}) {
  if (name === "eye") {
    return (
      <svg
        className={classname}
        width="16"
        height="13"
        viewBox="0 0 16 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 0.75C11.0081 0.75 13.0906 2.57042 14.3828 4.27539C14.7358 4.74119 14.9302 5.00414 15.0576 5.29688C15.1744 5.56538 15.25 5.90141 15.25 6.5C15.25 7.09859 15.1744 7.43461 15.0576 7.70312C14.9303 7.99587 14.7358 8.25882 14.3828 8.72461C13.0906 10.4295 11.0081 12.25 8 12.25C4.99186 12.25 2.90936 10.4295 1.61719 8.72461C1.26417 8.25882 1.06974 7.99586 0.942383 7.70312C0.825586 7.43461 0.75 7.0986 0.75 6.5C0.75 5.9014 0.825588 5.56538 0.942383 5.29688C1.06975 5.00415 1.26417 4.74119 1.61719 4.27539C2.90935 2.57043 4.99186 0.75 8 0.75Z"
          strokeOpacity="0.5"
          strokeWidth="1.5"
        />
        <path
          d="M8.00037 4.8125C8.90058 4.81272 9.64978 5.55711 9.64978 6.5C9.64978 7.44289 8.90058 8.18728 8.00037 8.1875C7.09998 8.1875 6.34998 7.44302 6.34998 6.5C6.34998 5.55698 7.09998 4.8125 8.00037 4.8125Z"
          strokeWidth="1.5"
        />
      </svg>
    );
  }
  if (name === "eyeClosed") {
    return (
      <svg
        className={classname}
        width="16"
        height="9"
        viewBox="0 0 16 9"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.55811 5.76753C8.55811 5.4593 8.30822 5.2094 7.99999 5.2094C7.69175 5.2094 7.44186 5.4593 7.44186 5.76753H8.55811ZM11.1373 4.96353C10.9692 4.70515 10.6234 4.632 10.365 4.80011C10.1067 4.96822 10.0335 5.31396 10.2017 5.57234L11.1373 4.96353ZM5.79831 5.57234C5.96643 5.31396 5.89326 4.96822 5.63489 4.80011C5.37653 4.632 5.0308 4.70515 4.86268 4.96353L5.79831 5.57234ZM3.81131 6.57935C3.64319 6.83773 3.71636 7.18347 3.97473 7.35158C4.2331 7.51969 4.57883 7.44653 4.74694 7.18816L3.81131 6.57935ZM13.6038 3.23623C13.3859 3.01826 13.0325 3.01826 12.8146 3.23623C12.5966 3.4542 12.5966 3.80753 12.8146 4.0255L13.6038 3.23623ZM13.9308 5.14176C14.1488 5.35973 14.5021 5.35973 14.7201 5.14176C14.9381 4.92379 14.9381 4.57046 14.7201 4.35249L13.9308 5.14176ZM7.44186 7.62796C7.44186 7.9362 7.69175 8.18609 7.99999 8.18609C8.30822 8.18609 8.55811 7.9362 8.55811 7.62796H7.44186ZM11.2531 7.18816C11.4212 7.44653 11.7669 7.51969 12.0252 7.35158C12.2836 7.18347 12.3567 6.83773 12.1886 6.57935L11.2531 7.18816ZM3.18544 4.0255C3.4034 3.80753 3.4034 3.4542 3.18544 3.23623C2.96748 3.01826 2.61408 3.01826 2.39612 3.23623L3.18544 4.0255ZM1.27986 4.35249C1.0619 4.57046 1.0619 4.92379 1.27986 5.14176C1.49783 5.35973 1.85122 5.35973 2.06918 5.14176L1.27986 4.35249ZM4.86268 4.96353L3.81131 6.57935L4.74694 7.18816L5.79831 5.57234L4.86268 4.96353ZM12.8146 4.0255L13.9308 5.14176L14.7201 4.35249L13.6038 3.23623L12.8146 4.0255ZM7.44186 5.76753V7.62796H8.55811V5.76753H7.44186ZM10.2017 5.57234L11.2531 7.18816L12.1886 6.57935L11.1373 4.96353L10.2017 5.57234ZM2.39612 3.23623L1.27986 4.35249L2.06918 5.14176L3.18544 4.0255L2.39612 3.23623Z"
          fillOpacity="0.5"
        />
        <path d="M1.07128 0.338416C0.94985 0.0550944 0.621737 -0.0761552 0.338416 0.0452713C0.0550945 0.166698 -0.0761553 0.494811 0.0452713 0.778132L1.07128 0.338416ZM15.9548 0.778132C16.0761 0.494811 15.9449 0.166698 15.6615 0.0452713C15.3782 -0.0761552 15.0501 0.0550944 14.9287 0.338416L15.9548 0.778132ZM8 5.20935C5.60087 5.20935 3.87827 4.01466 2.73468 2.7831C2.16304 2.16749 1.74393 1.55014 1.46809 1.08674C1.33049 0.855571 1.22942 0.664185 1.16358 0.532503C1.13068 0.466711 1.10665 0.415951 1.0913 0.382731C1.08364 0.366129 1.07815 0.353924 1.07481 0.346431C1.07314 0.342687 1.07186 0.339763 1.07128 0.338416C1.07126 0.338386 1.0713 0.338475 1.07128 0.338416C1.07135 0.338587 1.07128 0.338416 0.558274 0.558274C0.0452713 0.778132 0.0451597 0.777879 0.0452713 0.778132C0.045316 0.778244 0.0456434 0.778995 0.0457402 0.779219C0.0459262 0.779658 0.0461569 0.780186 0.0464174 0.780781C0.0469309 0.781987 0.0475931 0.783505 0.0483894 0.785336C0.0499894 0.78899 0.0521475 0.793894 0.0548637 0.800004C0.0602962 0.812223 0.067976 0.829264 0.0779331 0.850815C0.0978322 0.893911 0.126848 0.955067 0.165172 1.03171C0.24177 1.18491 0.355814 1.40049 0.508906 1.65768C0.814455 2.17101 1.27904 2.85598 1.91669 3.54263C3.19165 4.9157 5.18992 6.32561 8 6.32561V5.20935ZM10.4651 4.74856C9.74292 5.03283 8.92404 5.20935 8 5.20935V6.32561C9.07027 6.32561 10.0276 6.12037 10.8739 5.78727L10.4651 4.74856ZM15.4417 0.558274C14.9287 0.338416 14.9286 0.33852 14.9287 0.338416C14.9288 0.338297 14.9291 0.337619 14.9291 0.337701C14.929 0.33785 14.9288 0.338386 14.9283 0.339309C14.9275 0.341147 14.926 0.344511 14.9239 0.34934C14.9195 0.359007 14.9125 0.37453 14.9028 0.395486C14.8832 0.437398 14.8528 0.500936 14.8111 0.582586C14.7278 0.746006 14.6001 0.981195 14.4262 1.26018C14.0776 1.81977 13.5488 2.54668 12.8272 3.2239L13.5912 4.0378C14.4016 3.27711 14.989 2.46772 15.3736 1.8505C15.5664 1.54109 15.7096 1.27774 15.8055 1.08972C15.8535 0.995661 15.8897 0.920262 15.9145 0.867158C15.9268 0.840606 15.9364 0.819612 15.9431 0.804625C15.9464 0.797131 15.9491 0.791141 15.951 0.786705C15.952 0.784488 15.9527 0.782664 15.9534 0.781228C15.9537 0.780514 15.9539 0.779896 15.9542 0.779383C15.9543 0.779122 15.9547 0.778341 15.9548 0.778132C15.9548 0.778185 15.9548 0.778028 15.9548 0.778132C15.9548 0.778006 15.9548 0.778132 15.4417 0.558274ZM12.8272 3.2239C12.188 3.82385 11.4038 4.37908 10.4651 4.74856L10.8739 5.78727C11.9705 5.35565 12.8718 4.71299 13.5912 4.0378L12.8272 3.2239Z" />
      </svg>
    );
  }
  if (name === "google") {
    return (
      <svg
        className={classname}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.09674 10.0003C4.09674 9.35077 4.20462 8.72805 4.39717 8.14395L1.02692 5.57031C0.370072 6.90395 0 8.40668 0 10.0003C0 11.5926 0.369617 13.0944 1.02555 14.4271L4.39398 11.8485C4.20325 11.2671 4.09674 10.6467 4.09674 10.0003Z"
          fill="#FBBC05"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.0142 4.09092C11.4253 4.09092 12.6999 4.59092 13.7013 5.4091L16.6145 2.50001C14.8393 0.954548 12.5633 0 10.0142 0C6.0568 0 2.6556 2.26319 1.02692 5.57001L4.39717 8.14365C5.17373 5.78638 7.38733 4.09092 10.0142 4.09092Z"
          fill="#EB4335"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.0142 15.9092C7.38733 15.9092 5.17373 14.2137 4.39717 11.8564L1.02692 14.4296C2.6556 17.7369 6.0568 20.0001 10.0142 20.0001C12.4568 20.0001 14.7888 19.1328 16.539 17.5078L13.3399 15.0346C12.4372 15.6033 11.3006 15.9092 10.0142 15.9092Z"
          fill="#34A853"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.5732 9.99983C19.5732 9.40892 19.4822 8.77255 19.3456 8.18164H10.0142V12.0453H15.3854C15.1169 13.3626 14.3858 14.3753 13.3398 15.0344L16.5389 17.5076C18.3774 15.8012 19.5732 13.2594 19.5732 9.99983Z"
          fill="#4285F4"
        />
      </svg>
    );
  }
  if (name === "sun") {
    return (
      <svg
        className={classname}
        width="27"
        height="27"
        viewBox="0 0 27 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.5 19.75C16.9518 19.75 19.75 16.9518 19.75 13.5C19.75 10.0482 16.9518 7.25 13.5 7.25C10.0482 7.25 7.25 10.0482 7.25 13.5C7.25 16.9518 10.0482 19.75 13.5 19.75Z"
          stroke="white"
          strokeWidth="2"
        />
        <path
          d="M13.5 1V3.5"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M13.5 23.5V26"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M3.5 13.5H1"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M26 13.5H23.5"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          opacity="0.5"
          d="M23.2222 3.77832L20.4447 6.3178"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          opacity="0.5"
          d="M3.77771 3.77832L6.55522 6.3178"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          opacity="0.5"
          d="M6.55538 20.4446L3.77759 23.2224"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          opacity="0.5"
          d="M23.2222 23.2216L20.4447 20.4439"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    );
  }
  if (name === "moon") {
    return (
      <svg
        className={classname}
        width="27"
        height="27"
        viewBox="0 0 27 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.74419 12.5C1.74419 6.55977 6.55977 1.74419 12.5 1.74419V0C5.5964 0 0 5.5964 0 12.5H1.74419ZM12.5 1.74419C18.4403 1.74419 23.2558 6.55977 23.2558 12.5H25C25 5.5964 19.4036 0 12.5 0V1.74419ZM23.2558 12.5C23.2558 18.4403 18.4403 23.2558 12.5 23.2558V25C19.4036 25 25 19.4036 25 12.5H23.2558ZM8.43023 9.88372C12.1228 9.88372 15.1163 12.8772 15.1163 16.5698H16.8605C16.8605 11.9138 13.0862 8.13954 8.43023 8.13954V9.88372ZM2.70314 13.1174C3.87535 11.1776 6.00209 9.88372 8.43023 9.88372V8.13954C5.3664 8.13954 2.68523 9.77454 1.21023 12.2155L2.70314 13.1174ZM15.1163 16.5698C15.1163 18.9979 13.8224 21.1247 11.8826 22.2969L12.7845 23.7897C15.2255 22.3148 16.8605 19.6336 16.8605 16.5698H15.1163ZM12.5 23.2558C12.6029 23.2558 12.7236 23.3022 12.8112 23.3934C12.8853 23.4706 12.9026 23.5437 12.9066 23.5732C12.9115 23.6095 12.9091 23.7145 12.7845 23.7897L11.8826 22.2969C11.2974 22.6504 11.1093 23.2977 11.1781 23.8067C11.2495 24.3357 11.6667 25 12.5 25V23.2558ZM1.21023 12.2155C1.28558 12.0909 1.39058 12.0885 1.42674 12.0934C1.45628 12.0974 1.52942 12.1147 1.60663 12.1888C1.69779 12.2764 1.74419 12.3971 1.74419 12.5H0C0 13.3333 0.664303 13.7505 1.19337 13.8219C1.70233 13.8907 2.34965 13.7026 2.70314 13.1174L1.21023 12.2155Z"
          fill="#F6F6F6"
        />
      </svg>
    );
  }
  if (name === "quit") {
    return (
      <svg
        className={classname}
        width="27"
        height="29"
        viewBox="0 0 27 29"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M9.33334 4.37498H7.94445C4.67081 4.37498 3.03399 4.37498 2.01699 5.3635C1 6.35202 1 7.94301 1 11.125V17.875C1 21.057 1 22.6479 2.01699 23.6365C3.03399 24.625 4.67081 24.625 7.94445 24.625H9.33334"
          stroke="white"
          strokeWidth="2"
        />
        <path
          d="M9.33337 7.04313C9.33337 3.94648 9.33337 2.39817 10.3157 1.55173C11.298 0.70529 12.7993 0.959833 15.8023 1.46892L19.0367 2.01726C22.3624 2.58108 24.0252 2.86297 25.0127 4.04864C26 5.23429 26 6.94906 26 10.3786V18.6214C26 22.051 26 23.7657 25.0127 24.9513C24.0252 26.137 22.3624 26.4189 19.0367 26.9828L15.8023 27.531C12.7993 28.0401 11.298 28.2947 10.3157 27.4483C9.33337 26.6018 9.33337 25.0535 9.33337 21.9569V7.04313Z"
          stroke="white"
          strokeWidth="2"
        />
        <path
          opacity="0.5"
          d="M13.5 13.15V15.85"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    );
  }
  if (name === "back") {
    return (
      <svg
        className={classname}
        width="27"
        height="27"
        viewBox="0 0 27 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.375 9.75L11.625 13.5L15.375 17.25"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.5"
          d="M1 13.5C1 7.60744 1 4.66116 2.83059 2.83059C4.66116 1 7.60744 1 13.5 1C19.3925 1 22.3389 1 24.1694 2.83059C26 4.66116 26 7.60744 26 13.5C26 19.3925 26 22.3389 24.1694 24.1694C22.3389 26 19.3925 26 13.5 26C7.60744 26 4.66116 26 2.83059 24.1694C1 22.3389 1 19.3925 1 13.5Z"
          strokeWidth="2"
        />
      </svg>
    );
  }
  if (name === "arrowLeft") {
    return (
      <svg
        className={classname}
        width="9"
        height="14"
        viewBox="0 0 9 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 1L1 7L8 13"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  if (name === "dashboard") {
    return (
      <svg
        className={classname}
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.5 14.5C4.5 13.5572 4.5 13.0858 4.79289 12.7929C5.08579 12.5 5.55719 12.5 6.5 12.5H7.5C8.44281 12.5 8.91421 12.5 9.2071 12.7929C9.5 13.0858 9.5 13.5572 9.5 14.5V15.5C9.5 16.4428 9.5 16.9142 9.2071 17.2071C8.91421 17.5 8.44281 17.5 7.5 17.5C6.08579 17.5 5.37868 17.5 4.93934 17.0607C4.5 16.6213 4.5 15.9142 4.5 14.5Z"
          strokeWidth="2"
        />
        <path
          d="M4.5 7.5C4.5 6.08579 4.5 5.37868 4.93934 4.93934C5.37868 4.5 6.08579 4.5 7.5 4.5C8.44281 4.5 8.91421 4.5 9.2071 4.79289C9.5 5.08579 9.5 5.55719 9.5 6.5V7.5C9.5 8.44281 9.5 8.91421 9.2071 9.2071C8.91421 9.5 8.44281 9.5 7.5 9.5H6.5C5.55719 9.5 5.08579 9.5 4.79289 9.2071C4.5 8.91421 4.5 8.44281 4.5 7.5Z"
          strokeWidth="2"
        />
        <path
          d="M12.5 14.5C12.5 13.5572 12.5 13.0858 12.7929 12.7929C13.0858 12.5 13.5572 12.5 14.5 12.5H15.5C16.4428 12.5 16.9142 12.5 17.2071 12.7929C17.5 13.0858 17.5 13.5572 17.5 14.5C17.5 15.9142 17.5 16.6213 17.0607 17.0607C16.6213 17.5 15.9142 17.5 14.5 17.5C13.5572 17.5 13.0858 17.5 12.7929 17.2071C12.5 16.9142 12.5 16.4428 12.5 15.5V14.5Z"
          strokeWidth="2"
        />
        <path
          d="M12.5 6.5C12.5 5.55719 12.5 5.08579 12.7929 4.79289C13.0858 4.5 13.5572 4.5 14.5 4.5C15.9142 4.5 16.6213 4.5 17.0607 4.93934C17.5 5.37868 17.5 6.08579 17.5 7.5C17.5 8.44281 17.5 8.91421 17.2071 9.2071C16.9142 9.5 16.4428 9.5 15.5 9.5H14.5C13.5572 9.5 13.0858 9.5 12.7929 9.2071C12.5 8.91421 12.5 8.44281 12.5 7.5V6.5Z"
          strokeWidth="2"
        />
        <path
          opacity="0.5"
          d="M21 13C21 16.7712 21 18.6569 19.8284 19.8284C18.6569 21 16.7712 21 13 21"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          opacity="0.5"
          d="M9 21C5.22876 21 3.34315 21 2.17157 19.8284C1 18.6569 1 16.7712 1 13"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          opacity="0.5"
          d="M9 1C5.22876 1 3.34315 1 2.17157 2.17157C1 3.34315 1 5.22876 1 9"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          opacity="0.5"
          d="M13 1C16.7712 1 18.6569 1 19.8284 2.17157C21 3.34315 21 5.22876 21 9"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    );
  }
  if (name === "challenge") {
    return (
      <svg
        className={classname}
        style={style}
        width="22"
        height="18"
        viewBox="0 0 22 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 9C1 5.22876 1 3.34315 2.17157 2.17157C3.34315 1 5.22876 1 9 1H13C16.7712 1 18.6569 1 19.8284 2.17157C21 3.34315 21 5.22876 21 9C21 12.7712 21 14.6569 19.8284 15.8284C18.6569 17 16.7712 17 13 17H9C5.22876 17 3.34315 17 2.17157 15.8284C1 14.6569 1 12.7712 1 9Z"
          strokeWidth="2"
        />
        <path
          opacity="0.5"
          d="M9 13.5H5"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          opacity="0.5"
          d="M7 10.5H5"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          opacity="0.5"
          d="M1 7H21"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          opacity="0.5"
          d="M13 12C13 11.0572 13 10.5858 13.2929 10.2929C13.5858 10 14.0572 10 15 10C15.9428 10 16.4142 10 16.7071 10.2929C17 10.5858 17 11.0572 17 12C17 12.9428 17 13.4142 16.7071 13.7071C16.4142 14 15.9428 14 15 14C14.0572 14 13.5858 14 13.2929 13.7071C13 13.4142 13 12.9428 13 12Z"
          strokeWidth="2"
        />
      </svg>
    );
  }
  if (name === "purchase") {
    return (
      <svg
        className={`${classname} ${active ? "fill-white" : "fill-zi-blue-dark dark:fill-white"}`}
        style={style}
        width="22"
        height="21"
        viewBox="0 0 22 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="none"
          opacity="0.5"
          d="M6.7074 16.7998C7.59644 16.7998 8.31714 17.5162 8.31714 18.3998C8.31714 19.2834 7.59644 19.9998 6.7074 19.9998C5.81836 19.9998 5.09766 19.2834 5.09766 18.3998C5.09766 17.5162 5.81836 16.7998 6.7074 16.7998Z"
          strokeWidth="1.5"
        />
        <path
          fill="none"
          opacity="0.5"
          d="M16.3656 16.8003C17.2546 16.8003 17.9753 17.5165 17.9753 18.4003C17.9753 19.2839 17.2546 20.0002 16.3656 20.0002C15.4766 20.0002 14.7559 19.2839 14.7559 18.4003C14.7559 17.5165 15.4766 16.8003 16.3656 16.8003Z"
          strokeWidth="1.5"
        />
        <path
          stroke="none"
          d="M1.07205 0.0455051C0.652687 -0.101042 0.193214 0.118059 0.0457829 0.534862C-0.101659 0.951677 0.118779 1.40836 0.538128 1.5549L1.07205 0.0455051ZM20.8279 8.14168L21.6161 8.30323L21.6172 8.29832L20.8279 8.14168ZM4.78445 8.01075V5.10772H3.17471V8.01075H4.78445ZM1.35237 0.143455L1.07205 0.0455051L0.538128 1.5549L0.818448 1.65286L1.35237 0.143455ZM10.3965 14.9333H16.0873V13.3333H10.3965V14.9333ZM4.78445 5.10772C4.78445 4.35342 4.78555 3.72399 4.72984 3.2125C4.67218 2.68304 4.54725 2.20015 4.24464 1.76001L2.91558 2.66271C3.01244 2.8036 3.08724 2.99712 3.12945 3.38468C3.17362 3.79023 3.17471 4.31845 3.17471 5.10772H4.78445ZM0.818448 1.65286C1.5349 1.90322 2.00575 2.06914 2.35222 2.23811C2.67762 2.39681 2.82107 2.52526 2.91558 2.66271L4.24464 1.76001C3.93967 1.31643 3.53418 1.03234 3.06131 0.801727C2.60949 0.581379 2.03273 0.381212 1.35237 0.143455L0.818448 1.65286ZM3.17471 8.01075C3.17471 9.56006 3.18934 10.6773 3.33642 11.5308C3.49344 12.442 3.80695 13.0945 4.39315 13.709L5.56131 12.6082C5.21773 12.248 5.03241 11.8953 4.92305 11.2607C4.80376 10.5684 4.78445 9.59899 4.78445 8.01075H3.17471ZM10.3965 13.3333C8.876 13.3333 7.82101 13.3314 7.02616 13.2194C6.25905 13.1113 5.85379 12.9148 5.56131 12.6082L4.39315 13.709C5.03045 14.3772 5.83834 14.668 6.80015 14.8035C7.73421 14.9352 8.92392 14.9333 10.3965 14.9333V13.3333ZM3.97958 4.92813H16.9978V3.32816H3.97958V4.92813ZM20.0396 7.98019L19.5033 10.5665L21.0799 10.8895L21.6161 8.30323L20.0396 7.98019ZM16.9978 4.92813C17.9168 4.92813 18.7257 4.9292 19.364 5.00012C19.6812 5.03536 19.9186 5.08432 20.0854 5.14258C20.2586 5.20307 20.2862 5.24948 20.2723 5.23148L21.5482 4.25591C21.296 3.93013 20.9414 3.7457 20.6191 3.63308C20.2901 3.51822 19.9182 3.45175 19.5429 3.41006C18.7962 3.32709 17.887 3.32816 16.9978 3.32816V4.92813ZM21.6172 8.29832C21.7988 7.39388 21.953 6.63503 21.9908 6.02719C22.0295 5.40192 21.9579 4.78538 21.5482 4.25591L20.2723 5.23148C20.3389 5.31755 20.4124 5.47252 20.384 5.92862C20.3546 6.40215 20.2295 7.03453 20.0386 7.9851L21.6172 8.29832ZM16.0873 14.9333C16.9048 14.9333 17.5907 14.9347 18.1437 14.8674C18.7186 14.7975 19.243 14.6447 19.7007 14.2739L18.6837 13.0336C18.5494 13.1424 18.3589 13.2293 17.9482 13.2794C17.5155 13.3319 16.9451 13.3333 16.0873 13.3333V14.9333ZM19.5033 10.5665C19.3301 11.4015 19.2135 11.9566 19.0744 12.3672C18.9423 12.7568 18.8181 12.9248 18.6837 13.0336L19.7007 14.2739C20.1584 13.9031 20.4148 13.4236 20.5999 12.8781C20.7778 12.3533 20.9148 11.6853 21.0799 10.8895L19.5033 10.5665Z"
        />
      </svg>
    );
  }
  if (name === "transaction") {
    return (
      <svg
        className={classname}
        width="22"
        height="18"
        viewBox="0 0 22 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.9991 8C20.99 4.8857 20.8915 3.23467 19.8284 2.17157C18.6569 1 16.7712 1 13 1H8.99999C5.22876 1 3.34315 1 2.17157 2.17157C1 3.34315 1 5.22876 1 9C1 12.7712 1 14.6569 2.17157 15.8284C3.34315 17 5.22876 17 8.99999 17H10.5"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          opacity="0.5"
          d="M19 17V11M19 11L21 13M19 11L17 13"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.5 11V17M14.5 17L16.5 15M14.5 17L12.5 15"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.5"
          d="M9.00001 13H5.00002"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          opacity="0.4"
          d="M1 7H21"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    );
  }
  if (name === "trade") {
    return (
      <svg
        className={classname}
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 13C1 9.2288 1 7.34315 2.17157 6.17157C3.34315 5 5.22876 5 9 5H13C16.7712 5 18.6569 5 19.8284 6.17157C21 7.34315 21 9.2288 21 13C21 16.7712 21 18.6569 19.8284 19.8284C18.6569 21 16.7712 21 13 21H9C5.22876 21 3.34315 21 2.17157 19.8284C1 18.6569 1 16.7712 1 13Z"
          strokeWidth="2"
        />
        <path
          opacity="0.5"
          d="M15 5C15 3.11438 15 2.17157 14.4142 1.58579C13.8284 1 12.8856 1 11 1C9.1144 1 8.17157 1 7.58579 1.58579C7 2.17157 7 3.11438 7 5"
          strokeWidth="2"
        />
        <path
          opacity="0.5"
          d="M11 16.3333C12.1046 16.3333 13 15.5871 13 14.6667C13 13.7462 12.1046 13 11 13C9.8954 13 9 12.2538 9 11.3333C9 10.4129 9.8954 9.6667 11 9.6667M11 16.3333C9.8954 16.3333 9 15.5871 9 14.6667M11 16.3333V17M11 9.6667V9M11 9.6667C12.1046 9.6667 13 10.4129 13 11.3333"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    );
  }
  if (name === "competition") {
    return (
      <svg
        className={classname}
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.0003 15C5.24024 15 4.21986 9.2595 4.0391 4.70647C3.98882 3.43998 3.96368 2.80673 4.4394 2.22083C4.91511 1.63494 5.48448 1.53887 6.62322 1.34674C7.74728 1.15709 9.21665 1 11.0003 1C12.7838 1 14.2532 1.15709 15.3772 1.34674C16.516 1.53887 17.0853 1.63494 17.561 2.22083C18.0368 2.80673 18.0116 3.43998 17.9613 4.70647C17.7806 9.2595 16.7602 15 11.0003 15Z"
          strokeWidth="2"
        />
        <path
          opacity="0.5"
          d="M18.0001 4L18.9487 4.31621C19.9388 4.64623 20.4338 4.81124 20.7169 5.20408C21.0001 5.59692 21.0001 6.11873 21 7.16234V7.23487C21 8.09561 21 8.52598 20.7928 8.87809C20.5856 9.2302 20.2094 9.4392 19.457 9.8572L16.5001 11.5"
          strokeWidth="2"
        />
        <path
          opacity="0.5"
          d="M3.99996 4L3.05134 4.31621C2.06127 4.64623 1.56624 4.81124 1.28311 5.20408C0.999968 5.59692 0.999978 6.11873 1.00001 7.16234V7.23487C1.00004 8.09561 1.00005 8.52598 1.20724 8.87809C1.41442 9.2302 1.79064 9.4392 2.54307 9.8572L5.49997 11.5"
          strokeWidth="2"
        />
        <path
          opacity="0.5"
          d="M11.0001 16V18"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M14.5001 21H7.50004L7.83926 19.3039C7.93275 18.8365 8.34317 18.5 8.81985 18.5H13.1803C13.657 18.5 14.0674 18.8365 14.1609 19.3039L14.5001 21Z"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.5"
          d="M17.0001 21H5.00003"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    );
  }
  if (name === "invite") {
    return (
      <svg
        className={classname}
        width="22"
        height="20"
        viewBox="0 0 22 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.00002 5C2.00002 3.11438 2.00002 2.17157 2.58581 1.58579C3.17159 1 4.1144 1 6.00002 1H12C13.8856 1 14.8284 1 15.4142 1.58579C16 2.17157 16 3.11438 16 5V9.99999C16 12.8284 16 14.2426 15.1213 15.1213C14.2426 16 12.8284 16 10 16H8.00002C5.17159 16 3.75738 16 2.8787 15.1213C2.00002 14.2426 2.00002 12.8284 2.00002 9.99999V5Z"
          strokeWidth="2"
        />
        <path
          d="M16 11H17C19.2091 11 21 9.2091 21 7C21 4.79086 19.2091 3 17 3H16"
          strokeWidth="2"
        />
        <path opacity="0.5" d="M16 11H2.00002" strokeWidth="2" />
        <path
          opacity="0.5"
          d="M21 19H1"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    );
  }
  if (name === "discount") {
    return (
      <svg
        className={classname}
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M21 11H1"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          opacity="0.5"
          d="M11 1V21"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M12 11C12 13.2091 13.7909 15 16 15"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M10 11C10 13.2091 8.20914 15 6 15"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M11 9.0352C11 7.54529 12.014 6.24659 13.4594 5.88524C15.0631 5.48431 16.5158 6.93697 16.1148 8.5407C15.7535 9.9861 14.4548 11.0001 12.9649 11.0001H11V9.0352Z"
          strokeWidth="2"
        />
        <path
          d="M11.0001 9.0352C11.0001 7.54529 9.9861 6.24659 8.5407 5.88524C6.93698 5.48431 5.48431 6.93697 5.88524 8.5407C6.24659 9.9861 7.54529 11.0001 9.0352 11.0001H11.0001V9.0352Z"
          strokeWidth="2"
        />
        <path
          d="M1 11C1 6.28595 1 3.92893 2.46447 2.46447C3.92893 1 6.28595 1 11 1C15.714 1 18.0711 1 19.5355 2.46447C21 3.92893 21 6.28595 21 11C21 15.714 21 18.0711 19.5355 19.5355C18.0711 21 15.714 21 11 21C6.28595 21 3.92893 21 2.46447 19.5355C1 18.0711 1 15.714 1 11Z"
          strokeWidth="2"
        />
      </svg>
    );
  }
  if (name === "certificate") {
    return (
      <svg
        className={classname}
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M6 16.6361C3.82497 16.6243 2.64706 16.53 1.87868 15.779C1 14.9202 1 13.538 1 10.7736V6.86418C1 4.09978 1 2.71758 1.87868 1.85879C2.75736 1 4.17157 1 7 1H15C17.8284 1 19.2426 1 20.1213 1.85879C21 2.71758 21 4.09978 21 6.86418V10.7736C21 13.538 21 14.9202 20.1213 15.779C19.3915 16.4924 18.2921 16.6132 16.3197 16.6336L15.5 16.6361"
          strokeWidth="2"
          fill="none"
        />
        <path
          opacity="0.5"
          d="M8 4.90942H14"
          strokeWidth="2"
          strokeLinecap="round"
          fill="none"
        />
        <path
          opacity="0.5"
          d="M6 8.3302H16"
          strokeWidth="2"
          strokeLinecap="round"
          fill="none"
        />
        <path
          d="M9.89071 12.675C10.53 12.1427 11.4702 12.1427 12.1094 12.675C12.3833 12.9032 12.7239 13.0412 13.0827 13.0691C13.9199 13.1344 14.5847 13.7841 14.6515 14.6024C14.6802 14.9531 14.8212 15.286 15.0547 15.5537C15.5994 16.1785 15.5994 17.0974 15.0547 17.7221C14.8212 17.9898 14.6802 18.3227 14.6515 18.6734C14.5847 19.4917 13.9199 20.1414 13.0827 20.2067C12.7239 20.2347 12.3833 20.3726 12.1094 20.6008C11.4702 21.1331 10.53 21.1331 9.89071 20.6008C9.61681 20.3726 9.27621 20.2347 8.91744 20.2067C8.08022 20.1414 7.4154 19.4917 7.34859 18.6734C7.31996 18.3227 7.17889 17.9898 6.94544 17.7221C6.40069 17.0974 6.40069 16.1785 6.94544 15.5537C7.17889 15.286 7.31996 14.9531 7.34859 14.6024C7.41541 13.7841 8.08022 13.1344 8.91744 13.0691C9.27621 13.0412 9.61681 12.9032 9.89071 12.675Z"
          strokeWidth="2"
          fill="none"
        />
        <path
          d="M9.5 16.8332L10.3571 17.6151L12.5 15.6604"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </svg>
    );
  }
  if (name === "noCertificate") {
    return (
      <svg
        className={classname}
        xmlns="http://www.w3.org/2000/svg"
        width="466.1"
        height="757.339"
        viewBox="0 0 466.1 757.339"
        role="img"
        artist="Katerina Limpitsouni"
        source="https://undraw.co/"
      >
        <g transform="translate(-736 -161.332)">
          <path
            d="M445.552,511.159,440,732.183l-1.763,25.156H363.821l-2.68-48.48L339.386,524.1Z"
            transform="translate(736 161.332)"
            fill="#ed9da0"
          />
          <path
            d="M286.865,164.7c1.809-5.582,9.841-7.219,14.651-3.857s6.45,9.96,5.517,15.753-3.974,11-6.957,16.053C277.786,230.4,248.5,337.163,226.205,374.921a47.138,47.138,0,0,0,45.327,3.339,40.479,40.479,0,0,0,72.778-5.675l-10.964,25.277A62.8,62.8,0,0,0,372.894,358.3l-12.007,36.932C386.033,379.621,405,279.864,396.4,248.957a2.634,2.634,0,0,1,1.119-2.94l.034-.022a2.713,2.713,0,0,0,.754-.711c13.637-19.129,8.366-46.288-3.143-66.846-11.6-20.712-28.661-38.136-38.866-59.567C342.747,90.42,341.463,55.461,320.03,32.359c-13.6-14.659-33.577-22.1-53.451-24.308s-39.934.325-59.769,2.854l1.373-3.19c-17.07-12.452-41.9-8.7-59.366,3.189s-29.246,30.256-40.54,48.113L77.24,108.091c-10.133,16.022-49.462,86.522-53.112,105.125S24.956,253.269,40,264.8l5.716-29.707-1.8,1.556c12.776,46.47,12.706,115.223-29.04,139.306A56.856,56.856,0,0,0,68.16,363.573L41.437,393.461A71.343,71.343,0,0,0,81.86,379.923L61.409,404.174l54.622-28.037-11.362,28.8,68.3-12.822"
            transform="translate(736 161.332)"
            fill="#090814"
          />
          <path
            d="M120.125,698.862l-12.591,58.31H363.351l-9.209-30.931Z"
            transform="translate(736 161.332)"
            fill="#090814"
          />
          <path
            d="M35.159,654.991.04,698.254S-2.6,757.173,35.159,757.173s93.6-110.409,93.6-110.409L89.485,547.422,26.176,531.872l8.982,123.119Z"
            transform="translate(736 161.332)"
            fill="#ed9da0"
          />
          <path
            d="M338.97,192.128A122.579,122.579,0,1,0,174.4,301.564L190.779,459.1l125.356-94.938s-24.522-34.419-36.758-72.511a122.446,122.446,0,0,0,59.593-99.526Z"
            transform="translate(736 161.332)"
            fill="#ed9da0"
          />
          <path
            d="M294.959,325.287s-44.427,166.6-116.621,19.992L82.917,389.54s6.664,251.012,26.656,286.554c0,0-21.1,33.32,4.443,39.984s12.217-4.443,25.545,6.664,39.984-7.775,39.984-7.775,134.83,51.426,174.6,11.274V559.906s67.532-61.52,111.958-17.093c0,0-8.885-141.055-58.866-172.154s-112.275-45.372-112.275-45.372Z"
            transform="translate(736 161.332)"
            fill="#6c63ff"
          />
          <path
            d="M103.465,401.2,82.917,389.54S3.5,530.04,12.39,550.032s113.289,18.881,113.289,18.881L103.465,401.2Z"
            transform="translate(736 161.332)"
            fill="#6c63ff"
          />
          <path
            d="M205.7,10.905c19.835-2.529,39.9-5.061,59.769-2.854s39.851,9.649,53.451,24.308c21.434,23.1,22.717,58.061,36.267,86.513,10.206,21.431,27.271,38.855,38.866,59.567,11.509,20.558,16.78,47.717,3.143,66.846a2.713,2.713,0,0,1-.754.711h0a2.618,2.618,0,0,0-1.112,2.979c8.817,28.155-3.439,61.666-28.554,77.26L378.783,289.3c-6,18.4-25.153,98.553-43.548,104.559L346.2,368.584a40.479,40.479,0,0,1-72.778,5.675,47.138,47.138,0,0,1-45.327-3.339c22.29-37.758,48.581-140.516,70.871-178.274,2.983-5.053,6.023-10.259,6.957-16.053s-.707-12.391-5.517-15.753-12.842-1.725-14.651,3.857"
            transform="translate(736 161.332)"
            fill="#090814"
          />
          <path
            d="M86.186,349.4,63.595,524.975a69.259,69.259,0,0,1-6.775-4.931L71.258,347.889l14.928,1.51Z"
            transform="translate(736 161.332)"
            fill="#090814"
          />
          <path
            d="M287.184,164.239l-116.621-93.3L86.8,212.921V123.338l97.087-93.49,77.747,7.775Z"
            transform="translate(736 161.332)"
            fill="#090814"
          />
          <path
            d="M441.66,606.752,179.018,724.019a17.7,17.7,0,0,1-23.357-8.938L21.067,413.633A17.7,17.7,0,0,1,30,390.275L292.647,273.008A17.7,17.7,0,0,1,316,281.946L450.6,583.4a17.7,17.7,0,0,1-8.938,23.357Z"
            transform="translate(736 161.332)"
            fill="#d6d6e3"
          />
          <path
            d="M416.847,587.043,173.015,685.719a16.663,16.663,0,0,1-21.984-8.412L20.977,405.276a16.663,16.663,0,0,1,8.412-21.985l247.2-110.374a16.663,16.663,0,0,1,21.984,8.413L425.259,565.06a16.663,16.663,0,0,1-8.412,21.984Z"
            transform="translate(748.715 174.678)"
            fill="#fff"
          />
          <path
            d="M83.463,482.9,72.941,693.216.04,698.254,25.591,480.13c-10.084-10.76-16.117-26.807-15.271-44.465,1.48-30.9,23.408-54.95,48.978-53.725S104.4,409.2,102.915,440.1c-.846,17.658-8.386,33.055-19.452,42.8Z"
            transform="translate(736 161.332)"
            fill="#ed9da0"
          />
          <path
            d="M0,0H17.28V29s-4.039-8.471-8.359-8.471S0,29,0,29Z"
            transform="translate(1070.07 762.092) rotate(-7)"
            fill="#090814"
          />
          <path
            d="M0,0H17.281V29s-4.211-5.5-8.531-5.5S0,29,0,29Z"
            transform="translate(1089.924 759.502) rotate(-41)"
            fill="#090814"
          />
          <path
            d="M555.034,385.868h-150a9,9,0,1,1,0-18h150a9,9,0,0,1,0,18Z"
            transform="matrix(0.914, -0.407, 0.407, 0.914, 356.801, 457.531)"
            fill="#090814"
          />
          <path
            d="M438.034,344.368h-33a9,9,0,1,1,0-18h33a9,9,0,0,1,0,18Z"
            transform="matrix(0.914, -0.407, 0.407, 0.914, 356.801, 457.531)"
            fill="#6c63ff"
          />
          <path
            d="M555.034,427.368h-150a9,9,0,0,1,0-18h150a9,9,0,0,1,0,18Z"
            transform="matrix(0.914, -0.407, 0.407, 0.914, 356.801, 457.531)"
            fill="#090814"
          />
          <path
            d="M555.034,468.868h-150a9,9,0,0,1,0-18h150a9,9,0,0,1,0,18Z"
            transform="matrix(0.914, -0.407, 0.407, 0.914, 356.801, 457.531)"
            fill="#090814"
          />
          <path
            d="M35.811,0A35.811,35.811,0,1,1,0,35.811,35.811,35.811,0,0,1,35.811,0Z"
            transform="matrix(0.914, -0.407, 0.407, 0.914, 1026.098, 714.082)"
            fill="#6c63ff"
          />
          <path
            d="M538.012,561.045a3.983,3.983,0,0,1-3.186-1.594l-9.77-13.027a3.983,3.983,0,0,1,6.374-4.78l6.392,8.522,16.416-24.624a3.984,3.984,0,1,1,6.629,4.419l-19.54,29.309a3.986,3.986,0,0,1-3.2,1.773Z"
            transform="matrix(0.914, -0.407, 0.407, 0.914, 356.801, 457.531)"
            fill="#fff"
          />
        </g>
      </svg>
    );
  }
  if (name === "point") {
    return (
      <svg
        className={classname}
        width="22"
        height="21"
        viewBox="0 0 22 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M10.1448 6.02251C10.5248 5.34084 10.7148 5 10.9989 5C11.283 5 11.473 5.34084 11.853 6.02251L11.9513 6.19887C12.0592 6.39258 12.1132 6.48944 12.1974 6.55334C12.2816 6.61725 12.3864 6.64097 12.5961 6.68841L12.787 6.73161C13.5249 6.89857 13.8939 6.98205 13.9817 7.26432C14.0695 7.54659 13.8179 7.84072 13.3149 8.42899L13.1847 8.58118C13.0418 8.74834 12.9703 8.83192 12.9381 8.93532C12.906 9.03871 12.9168 9.15021 12.9384 9.37331L12.9581 9.57631C13.0341 10.3612 13.0722 10.7536 12.8424 10.9281C12.6125 11.1025 12.2671 10.9435 11.5762 10.6254L11.3975 10.5431C11.2011 10.4527 11.103 10.4075 10.9989 10.4075C10.8948 10.4075 10.7967 10.4527 10.6003 10.5431L10.4216 10.6254C9.73075 10.9435 9.38535 11.1025 9.15545 10.9281C8.92569 10.7536 8.96371 10.3612 9.03975 9.57631L9.05945 9.37331C9.08105 9.15021 9.09185 9.03871 9.05975 8.93532C9.02755 8.83192 8.95608 8.74834 8.81313 8.58118L8.68298 8.42899C8.17992 7.84072 7.9284 7.54659 8.01618 7.26432C8.10396 6.98205 8.47291 6.89857 9.21085 6.73161L9.40175 6.68841C9.61145 6.64097 9.71625 6.61725 9.80045 6.55334C9.88465 6.48944 9.93865 6.39258 10.0465 6.19887L10.1448 6.02251Z"
          strokeWidth="2"
        />
        <path
          d="M17.9989 8.00001C17.9989 11.866 14.8649 15 10.9989 15C7.13296 15 3.99895 11.866 3.99895 8.00001C3.99895 4.13402 7.13296 1 10.9989 1C14.8649 1 17.9989 4.13402 17.9989 8.00001Z"
          strokeWidth="2"
        />
        <path
          opacity="0.5"
          d="M10.9989 15.0678L7.2275 18.9728C6.68738 19.5321 6.41732 19.8117 6.18862 19.9084C5.66747 20.1289 5.08937 19.9402 4.81523 19.4602C4.69492 19.2495 4.65743 18.8695 4.58245 18.1095C4.54012 17.6804 4.51895 17.4658 4.4547 17.2861C4.31086 16.8838 4.00861 16.5708 3.62005 16.4219C3.44649 16.3554 3.23928 16.3335 2.82484 16.2896C2.09082 16.212 1.72381 16.1732 1.52033 16.0486C1.05667 15.7648 0.874428 15.1662 1.08738 14.6266C1.18083 14.3898 1.45089 14.1102 1.99101 13.5509L4.4547 11"
          strokeWidth="2"
        />
        <path
          opacity="0.5"
          d="M10.9989 15.0678L14.7704 18.9728C15.3105 19.5321 15.5805 19.8117 15.8092 19.9084C16.3304 20.1289 16.9085 19.9402 17.1826 19.4602C17.3029 19.2495 17.3404 18.8695 17.4154 18.1095C17.4577 17.6804 17.4789 17.4658 17.5431 17.2861C17.687 16.8838 17.9892 16.5708 18.3778 16.4219C18.5514 16.3554 18.7586 16.3335 19.173 16.2896C19.907 16.212 20.274 16.1732 20.4775 16.0486C20.9412 15.7648 21.1234 15.1662 20.9105 14.6266C20.817 14.3898 20.547 14.1102 20.0068 13.5509L17.5431 11"
          strokeWidth="2"
        />
      </svg>
    );
  }
  if (name === "profile") {
    return (
      <svg
        className={classname}
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M11 11C12.6569 11 14 9.65685 14 8C14 6.34315 12.6569 5 11 5C9.34315 5 8 6.34315 8 8C8 9.65685 9.34315 11 11 11Z"
          strokeWidth="2"
        />
        <path
          d="M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z"
          strokeWidth="2"
        />
        <path
          opacity="0.5"
          d="M16.9691 19C16.81 16.1085 15.9247 14 10.9999 14C6.07521 14 5.18991 16.1085 5.03076 19"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    );
  }
  if (name === "notification") {
    return (
      <svg
        className={classname}
        width="22"
        height="24"
        viewBox="0 0 22 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.4981 9.48053V8.70547C18.4981 4.44985 15.1407 1 10.9991 1C6.85751 1 3.50008 4.44985 3.50008 8.70547V9.48053C3.50008 10.4107 3.23214 11.32 2.73 12.0939L1.49952 13.9905C0.375583 15.7227 1.23362 18.0774 3.1884 18.6252C8.30216 20.0583 13.6961 20.0583 18.8098 18.6252C20.7647 18.0774 21.6227 15.7227 20.4987 13.9905L19.2682 12.0939C18.7661 11.32 18.4981 10.4107 18.4981 9.48053Z"
          strokeWidth="2"
        />
        <path
          opacity="0.5"
          d="M5.99911 19.7C6.72693 21.6225 8.69074 23 10.9991 23C13.3074 23 15.2713 21.6225 15.9991 19.7"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          opacity="0.5"
          d="M10.9991 5.40002V9.80003"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    );
  }
  if (name === "support") {
    return (
      <svg
        className={classname}
        width="22"
        height="18"
        viewBox="0 0 22 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M1 9C1 5.22876 1 3.34315 2.17157 2.17157C3.34315 1 5.22876 1 9 1H13C16.7712 1 18.6569 1 19.8284 2.17157C21 3.34315 21 5.22876 21 9C21 12.7712 21 14.6569 19.8284 15.8284C18.6569 17 16.7712 17 13 17H9C5.22876 17 3.34315 17 2.17157 15.8284C1 14.6569 1 12.7712 1 9Z"
          strokeWidth="2"
        />
        <path
          d="M5 5L7.1589 6.79908C8.99553 8.3296 9.9139 9.0949 11 9.0949C12.0861 9.0949 13.0045 8.3296 14.8411 6.79908L17 5"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    );
  }
  if (name === "rules") {
    return (
      <svg
        className={classname}
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M21 9.5V11C21 15.714 21 18.0711 19.5355 19.5355C18.0711 21 15.714 21 11 21C6.28595 21 3.92893 21 2.46447 19.5355C1 18.0711 1 15.714 1 11C1 6.28595 1 3.92893 2.46447 2.46447C3.92893 1 6.28595 1 11 1H12.5"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M18 7C19.6569 7 21 5.65685 21 4C21 2.34315 19.6569 1 18 1C16.3431 1 15 2.34315 15 4C15 5.65685 16.3431 7 18 7Z"
          strokeWidth="2"
        />
        <path d="M6 13H15" strokeWidth="2" strokeLinecap="round" />
        <path d="M6 16.5H12" strokeWidth="2" strokeLinecap="round" />
      </svg>
    );
  }
  if (name === "minimize") {
    return (
      <svg
        className={classname}
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M1 15C1 8.40033 1 5.1005 3.05026 3.05026C5.1005 1 8.40033 1 15 1C21.5996 1 24.8995 1 26.9497 3.05026C29 5.1005 29 8.40033 29 15C29 21.5996 29 24.8995 26.9497 26.9497C24.8995 29 21.5996 29 15 29C8.40033 29 5.1005 29 3.05026 26.9497C1 24.8995 1 21.5996 1 15Z"
          strokeWidth="2"
        />
        <path
          d="M12.9 17.1H8.7M12.9 17.1V21.3M12.9 17.1L8 22"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.1001 12.9H21.3001M17.1001 12.9V8.69999M17.1001 12.9L22.0001 7.99999"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  if (name === "maximize") {
    return (
      <svg
        className={classname}
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M1 15C1 8.40033 1 5.1005 3.05026 3.05026C5.1005 1 8.40033 1 15 1C21.5996 1 24.8995 1 26.9497 3.05026C29 5.1005 29 8.40033 29 15C29 21.5996 29 24.8995 26.9497 26.9497C24.8995 29 21.5996 29 15 29C8.40033 29 5.1005 29 3.05026 26.9497C1 24.8995 1 21.5996 1 15Z"
          strokeWidth="2"
        />
        <path
          d="M7.02017 22.98H11.2202M7.02017 22.98V18.78M7.02017 22.98L11.9202 18.08"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.98 7.02H18.78M22.98 7.02V11.22M22.98 7.02L18.08 11.92"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  if (name === "hamburger") {
    return (
      <svg
        className={classname}
        viewBox="0 0 1000 1000"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect y="138" width="1000" height="100" rx="50" />
        <rect y="450" width="1000" height="100" rx="50" />
        <rect y="762" width="1000" height="100" rx="50" />
      </svg>
    );
  }
  if (name === "hamburgerX") {
    return (
      <svg
        className={classname}
        viewBox="0 0 1000 1000"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="181.802"
          y="111.091"
          width="1000"
          height="100"
          rx="50"
          transform="rotate(45 181.802 111.091)"
        />
        <rect
          x="111.091"
          y="818.198"
          width="1000"
          height="100"
          rx="50"
          transform="rotate(-45 111.091 818.198)"
        />
      </svg>
    );
  }
  if (name === "profitAvailable") {
    return (
      <svg
        className={classname}
        style={style}
        viewBox="0 0 22 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.4444 3.2002C17.8611 3.21352 19.1699 3.31962 20.0237 4.16491C21 5.13154 21 6.68731 21 9.79884V16.3995C21 19.511 21 21.0667 20.0237 22.0334C19.0473 23 17.476 23 14.3333 23H7.66667C4.52397 23 2.95262 23 1.97631 22.0334C1 21.0667 1 19.511 1 16.3995V9.79884C1 6.68731 1 5.13154 1.97631 4.16491C2.83007 3.31962 4.13886 3.21352 6.55556 3.2002"
          stroke="white"
          strokeOpacity="0.5"
          strokeWidth="2"
        />
        <path
          d="M6.55566 2.65014C6.55566 1.73879 7.30185 1 8.22233 1H13.7779C14.6983 1 15.4446 1.73879 15.4446 2.65014V3.75023C15.4446 4.66159 14.6983 5.40038 13.7779 5.40038H8.22233C7.30185 5.40038 6.55566 4.66159 6.55566 3.75023V2.65014Z"
          stroke="white"
          strokeWidth="2"
        />
        <path
          d="M14.3334 13.1011H11.0001M11.0001 13.1011H7.66675M11.0001 13.1011V9.80078M11.0001 13.1011V16.4013"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    );
  }
  if (name === "profitProcess") {
    return (
      <svg
        width="22"
        height="24"
        viewBox="0 0 22 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M15.4444 3.2002C17.8611 3.21352 19.1699 3.31962 20.0237 4.16491C21 5.13154 21 6.68731 21 9.79884V16.3995C21 19.511 21 21.0667 20.0237 22.0334C19.0473 23 17.476 23 14.3333 23H7.66667C4.52397 23 2.95262 23 1.97631 22.0334C1 21.0667 1 19.511 1 16.3995V9.79884C1 6.68731 1 5.13154 1.97631 4.16491C2.83007 3.31962 4.13886 3.21352 6.55556 3.2002"
          stroke="white"
          strokeWidth="2"
        />
        <path
          d="M6.55554 2.65014C6.55554 1.73879 7.30173 1 8.22221 1H13.7778C14.6982 1 15.4444 1.73879 15.4444 2.65014V3.75023C15.4444 4.66159 14.6982 5.40038 13.7778 5.40038H8.22221C7.30173 5.40038 6.55554 4.66159 6.55554 3.75023V2.65014Z"
          stroke="white"
          strokeWidth="2"
        />
        <g clipPath="url(#clip0_930_4)">
          <circle cx="7.5" cy="13" r="1" fill="white" />
          <circle cx="11" cy="13" r="1" fill="white" />
          <circle cx="14.5" cy="13" r="1" fill="white" />
        </g>
        <defs>
          <clipPath id="clip0_930_4">
            <rect
              width="9"
              height="2"
              fill="white"
              transform="translate(6.5 12)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  }
  if (name === "profitDone") {
    return (
      <svg
        width="22"
        height="24"
        viewBox="0 0 22 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M15.4444 3.2002C17.8611 3.21352 19.1699 3.31962 20.0237 4.16491C21 5.13154 21 6.6873 21 9.79884V16.3994C21 19.5109 21 21.0667 20.0237 22.0333C19.0473 23 17.476 23 14.3333 23H7.66667C4.52397 23 2.95262 23 1.97631 22.0333C1 21.0667 1 19.5109 1 16.3994V9.79884C1 6.6873 1 5.13154 1.97631 4.16491C2.83007 3.31962 4.13886 3.21352 6.55556 3.2002"
          stroke="white"
          strokeWidth="2"
        />
        <path
          d="M7.66669 13.5411L9.57146 15.3013L14.3334 10.9009"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.55554 2.65014C6.55554 1.73879 7.30173 1 8.22221 1H13.7778C14.6982 1 15.4444 1.73879 15.4444 2.65014V3.75023C15.4444 4.66158 14.6982 5.40037 13.7778 5.40037H8.22221C7.30173 5.40037 6.55554 4.66158 6.55554 3.75023V2.65014Z"
          stroke="white"
          strokeWidth="2"
        />
      </svg>
    );
  }
  if (name === "link") {
    return (
      <svg
        className={classname}
        style={style}
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M25 13C25 18.6568 25 21.4853 23.2426 23.2426C21.4853 25 18.6568 25 13 25C7.34314 25 4.51472 25 2.75736 23.2426C1 21.4853 1 18.6568 1 13C1 7.34314 1 4.51472 2.75736 2.75736C4.51472 1 7.34314 1 13 1"
          strokeOpacity="0.5"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M17.9859 2.72118L20.8146 5.17274C22.7619 6.86034 23.7354 7.70414 23.7354 8.80005C23.7354 9.89596 22.7619 10.7398 20.8146 12.4273L17.9859 14.8789C17.1297 15.621 16.7015 15.992 16.3508 15.8318C16 15.6716 16 15.1051 16 13.9721V12.1429C12.4 12.1429 8.5 13.8144 7 16.6001C7 7.68577 12.3333 5.45719 16 5.45719V3.628C16 2.49494 16 1.92841 16.3508 1.76823C16.7015 1.60807 17.1297 1.9791 17.9859 2.72118Z"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  if (name === "copy") {
    return (
      <svg
        className={classname}
        style={style}
        width="12"
        height="13"
        viewBox="0 0 12 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M2.33301 5.8998C2.33301 4.20275 2.33301 3.35422 2.86998 2.82701C3.40695 2.2998 4.27119 2.2998 5.99967 2.2998H7.83301C9.56147 2.2998 10.4257 2.2998 10.9627 2.82701C11.4997 3.35422 11.4997 4.20275 11.4997 5.8998V8.8998C11.4997 10.5968 11.4997 11.4454 10.9627 11.9726C10.4257 12.4998 9.56147 12.4998 7.83301 12.4998H5.99967C4.27119 12.4998 3.40695 12.4998 2.86998 11.9726C2.33301 11.4454 2.33301 10.5968 2.33301 8.8998V5.8998Z" />
        <path
          opacity="0.5"
          d="M2.33333 10.7C1.32081 10.7 0.5 9.89414 0.5 8.9V5.3C0.5 3.03726 0.5 1.90589 1.21596 1.20294C1.93192 0.5 3.08424 0.5 5.38889 0.5H7.83333C8.84588 0.5 9.66667 1.30589 9.66667 2.3"
        />
      </svg>
    );
  }
  if (name === "notifs") {
    return (
      <svg
        className={classname}
        style={style}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.6113 19.0881L12.1155 18.2362L10.9147 17.5254L10.4104 18.3774L11.6113 19.0881ZM7.88446 18.2362L8.38875 19.0881L9.58949 18.3774L9.08521 17.5254L7.88446 18.2362ZM10.4104 18.3774C10.2312 18.6803 9.76884 18.6803 9.58949 18.3774L8.38875 19.0881C9.10837 20.304 10.8916 20.304 11.6113 19.0881L10.4104 18.3774ZM8.60465 1.39535H11.3953V1.91679e-07H8.60465V1.39535ZM18.6047 8.60467V9.53491H20V8.60467H18.6047ZM1.39535 9.53491V8.60467H1.91678e-07V9.53491H1.39535ZM1.91678e-07 9.53491C1.91678e-07 10.609 -0.000381234 11.4494 0.0458699 12.1273C0.0925583 12.8115 0.189051 13.3809 0.407154 13.9074L1.69629 13.3734C1.56034 13.0452 1.47982 12.6454 1.43799 12.0323C1.39573 11.413 1.39535 10.628 1.39535 9.53491H1.91678e-07ZM6.09535 15.8062C4.9275 15.786 4.31556 15.7118 3.8359 15.5131L3.30193 16.8022C4.05074 17.1123 4.90361 17.1812 6.07131 17.2013L6.09535 15.8062ZM0.407154 13.9074C0.950028 15.218 1.99131 16.2593 3.30193 16.8022L3.8359 15.5131C2.86718 15.1118 2.09754 14.3422 1.69629 13.3734L0.407154 13.9074ZM18.6047 9.53491C18.6047 10.628 18.6043 11.413 18.562 12.0323C18.5202 12.6454 18.4396 13.0452 18.3037 13.3734L19.5928 13.9074C19.811 13.3809 19.9074 12.8115 19.9541 12.1273C20.0004 11.4494 20 10.609 20 9.53491H18.6047ZM13.9287 17.2013C15.0964 17.1812 15.9493 17.1123 16.698 16.8022L16.1641 15.5131C15.6845 15.7118 15.0725 15.786 13.9047 15.8062L13.9287 17.2013ZM18.3037 13.3734C17.9024 14.3422 17.1328 15.1118 16.1641 15.5131L16.698 16.8022C18.0087 16.2593 19.05 15.218 19.5928 13.9074L18.3037 13.3734ZM11.3953 1.39535C12.9313 1.39535 14.0344 1.39609 14.8948 1.47789C15.7448 1.55871 16.2857 1.71371 16.7168 1.97794L17.446 0.788207C16.7586 0.367043 15.979 0.17934 15.0269 0.0888097C14.0851 -0.000734733 12.9044 1.91679e-07 11.3953 1.91679e-07V1.39535ZM20 8.60467C20 7.09565 20.0007 5.9149 19.9112 4.97314C19.8207 4.021 19.6329 3.24136 19.2118 2.55408L18.022 3.28315C18.2863 3.71434 18.4413 4.25521 18.5221 5.10521C18.6039 5.9656 18.6047 7.06863 18.6047 8.60467H20ZM16.7168 1.97794C17.2488 2.30393 17.6961 2.75119 18.022 3.28315L19.2118 2.55408C18.7708 1.83437 18.1657 1.22925 17.446 0.788207L16.7168 1.97794ZM8.60465 1.91679e-07C7.09564 1.91679e-07 5.91488 -0.000734733 4.97313 0.0888097C4.02099 0.17934 3.24135 0.367043 2.55407 0.788207L3.28314 1.97794C3.71433 1.71371 4.2552 1.55871 5.1052 1.47789C5.96558 1.39609 7.06861 1.39535 8.60465 1.39535V1.91679e-07ZM1.39535 8.60467C1.39535 7.06863 1.39608 5.9656 1.47789 5.10521C1.55871 4.25521 1.7137 3.71434 1.97794 3.28315L0.788205 2.55408C0.367042 3.24136 0.17934 4.021 0.0888095 4.97314C-0.000734731 5.9149 1.91678e-07 7.09565 1.91678e-07 8.60467H1.39535ZM2.55407 0.788207C1.83436 1.22925 1.22925 1.83437 0.788205 2.55408L1.97794 3.28315C2.30393 2.75119 2.75118 2.30393 3.28314 1.97794L2.55407 0.788207ZM9.08521 17.5254C8.89637 17.2064 8.73061 16.9248 8.5694 16.7036C8.39954 16.4706 8.20484 16.2609 7.93475 16.1038L7.23323 17.31C7.27733 17.3356 7.33741 17.3824 7.44172 17.5254C7.55462 17.6804 7.68219 17.8945 7.88446 18.2362L9.08521 17.5254ZM6.07131 17.2013C6.47977 17.2083 6.73848 17.2135 6.9357 17.2353C7.11999 17.2558 7.19142 17.2856 7.23323 17.31L7.93475 16.1038C7.66242 15.9453 7.37903 15.8805 7.08927 15.8484C6.81246 15.8178 6.47791 15.8128 6.09535 15.8062L6.07131 17.2013ZM12.1155 18.2362C12.3178 17.8945 12.4453 17.6804 12.5582 17.5254C12.6625 17.3824 12.7226 17.3356 12.7667 17.31L12.0652 16.1038C11.7952 16.2609 11.6004 16.4706 11.4306 16.7036C11.2694 16.9248 11.1036 17.2064 10.9147 17.5254L12.1155 18.2362ZM13.9047 15.8062C13.522 15.8128 13.1875 15.8178 12.9107 15.8484C12.6209 15.8805 12.3376 15.9453 12.0652 16.1038L12.7667 17.31C12.8086 17.2856 12.88 17.2558 13.0643 17.2353C13.2615 17.2135 13.5202 17.2083 13.9287 17.2013L13.9047 15.8062Z"
          fill="white"
        />
        <path
          opacity="0.5"
          d="M6.2793 7.20947H13.7212"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          opacity="0.5"
          d="M6.2793 10.4653H11.3956"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    );
  }
  if (name === "friend") {
    return (
      <svg
        className={classname}
        style={style}
        width="22"
        height="24"
        viewBox="0 0 22 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21 22.4499L20.2783 16.3774C20.0562 14.5083 18.4563 13.0999 16.5556 13.0999H7.66667C4.33333 13.0999 2.18574 10.0955 1.42441 7.08056L1 5.3999"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.5"
          d="M7.66602 13.1001V18.6001C7.66602 20.6743 7.66602 21.7113 8.31689 22.3557C8.96776 23.0001 10.0153 23.0001 12.1105 23.0001C14.2056 23.0001 15.2531 23.0001 15.904 22.3557C16.5549 21.7113 16.5549 20.6743 16.5549 18.6001V13.1001"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          opacity="0.9"
          d="M12.1105 9.8C14.5651 9.8 16.5549 7.83005 16.5549 5.4C16.5549 2.96995 14.5651 1 12.1105 1C9.65586 1 7.66602 2.96995 7.66602 5.4C7.66602 7.83005 9.65586 9.8 12.1105 9.8Z"
          stroke="white"
          strokeWidth="2"
        />
      </svg>
    );
  }
  if (name === "message") {
    return (
      <svg
        className={classname}
        style={style}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.6113 19.0881L12.1155 18.2362L10.9147 17.5254L10.4104 18.3774L11.6113 19.0881ZM7.88446 18.2362L8.38874 19.0881L9.58949 18.3774L9.08521 17.5254L7.88446 18.2362ZM10.4104 18.3774C10.2312 18.6803 9.76884 18.6803 9.58949 18.3774L8.38874 19.0881C9.10837 20.304 10.8916 20.304 11.6113 19.0881L10.4104 18.3774ZM8.60465 1.39535H11.3953V1.91679e-07H8.60465V1.39535ZM18.6047 8.60467V9.53491H20V8.60467H18.6047ZM1.39535 9.53491V8.60467H1.91678e-07V9.53491H1.39535ZM1.91678e-07 9.53491C1.91678e-07 10.609 -0.000381234 11.4494 0.0458699 12.1273C0.0925583 12.8115 0.189051 13.3809 0.407154 13.9074L1.69629 13.3734C1.56034 13.0452 1.47982 12.6454 1.43799 12.0323C1.39573 11.413 1.39535 10.628 1.39535 9.53491H1.91678e-07ZM6.09535 15.8062C4.9275 15.786 4.31556 15.7118 3.8359 15.5131L3.30193 16.8022C4.05074 17.1123 4.90361 17.1812 6.07131 17.2013L6.09535 15.8062ZM0.407154 13.9074C0.950028 15.218 1.99131 16.2593 3.30193 16.8022L3.8359 15.5131C2.86718 15.1118 2.09754 14.3422 1.69629 13.3734L0.407154 13.9074ZM18.6047 9.53491C18.6047 10.628 18.6043 11.413 18.562 12.0323C18.5202 12.6454 18.4396 13.0452 18.3037 13.3734L19.5928 13.9074C19.811 13.3809 19.9074 12.8115 19.9541 12.1273C20.0004 11.4494 20 10.609 20 9.53491H18.6047ZM13.9287 17.2013C15.0964 17.1812 15.9493 17.1123 16.698 16.8022L16.1641 15.5131C15.6845 15.7118 15.0725 15.786 13.9047 15.8062L13.9287 17.2013ZM18.3037 13.3734C17.9024 14.3422 17.1328 15.1118 16.1641 15.5131L16.698 16.8022C18.0087 16.2593 19.05 15.218 19.5928 13.9074L18.3037 13.3734ZM11.3953 1.39535C12.9313 1.39535 14.0344 1.39609 14.8948 1.47789C15.7448 1.55871 16.2857 1.71371 16.7168 1.97794L17.446 0.788207C16.7586 0.367043 15.979 0.17934 15.0269 0.0888097C14.0851 -0.000734733 12.9044 1.91679e-07 11.3953 1.91679e-07V1.39535ZM20 8.60467C20 7.09565 20.0007 5.9149 19.9112 4.97314C19.8207 4.021 19.6329 3.24136 19.2118 2.55408L18.022 3.28315C18.2863 3.71434 18.4413 4.25521 18.5221 5.10521C18.6039 5.9656 18.6047 7.06863 18.6047 8.60467H20ZM16.7168 1.97794C17.2488 2.30393 17.6961 2.75119 18.022 3.28315L19.2118 2.55408C18.7708 1.83437 18.1657 1.22925 17.446 0.788207L16.7168 1.97794ZM8.60465 1.91679e-07C7.09564 1.91679e-07 5.91488 -0.000734733 4.97313 0.0888097C4.02099 0.17934 3.24135 0.367043 2.55407 0.788207L3.28314 1.97794C3.71434 1.71371 4.2552 1.55871 5.1052 1.47789C5.96558 1.39609 7.06861 1.39535 8.60465 1.39535V1.91679e-07ZM1.39535 8.60467C1.39535 7.06863 1.39608 5.9656 1.47789 5.10521C1.55871 4.25521 1.7137 3.71434 1.97794 3.28315L0.788205 2.55408C0.367042 3.24136 0.17934 4.021 0.0888095 4.97314C-0.000734731 5.9149 1.91678e-07 7.09565 1.91678e-07 8.60467H1.39535ZM2.55407 0.788207C1.83436 1.22925 1.22925 1.83437 0.788205 2.55408L1.97794 3.28315C2.30393 2.75119 2.75118 2.30393 3.28314 1.97794L2.55407 0.788207ZM9.08521 17.5254C8.89637 17.2064 8.7306 16.9248 8.5694 16.7036C8.39954 16.4706 8.20484 16.2609 7.93475 16.1038L7.23323 17.31C7.27733 17.3356 7.33741 17.3824 7.44172 17.5254C7.55462 17.6804 7.68219 17.8945 7.88446 18.2362L9.08521 17.5254ZM6.07131 17.2013C6.47977 17.2083 6.73848 17.2135 6.9357 17.2353C7.11999 17.2558 7.19142 17.2856 7.23323 17.31L7.93475 16.1038C7.66242 15.9453 7.37903 15.8805 7.08927 15.8484C6.81246 15.8178 6.47791 15.8128 6.09535 15.8062L6.07131 17.2013ZM12.1155 18.2362C12.3178 17.8945 12.4453 17.6804 12.5582 17.5254C12.6625 17.3824 12.7226 17.3356 12.7667 17.31L12.0652 16.1038C11.7952 16.2609 11.6004 16.4706 11.4306 16.7036C11.2694 16.9248 11.1036 17.2064 10.9147 17.5254L12.1155 18.2362ZM13.9047 15.8062C13.522 15.8128 13.1875 15.8178 12.9107 15.8484C12.6209 15.8805 12.3376 15.9453 12.0652 16.1038L12.7667 17.31C12.8086 17.2856 12.88 17.2558 13.0643 17.2353C13.2615 17.2135 13.5202 17.2083 13.9287 17.2013L13.9047 15.8062Z"
          fill="white"
        />
        <path
          opacity="0.5"
          d="M6.27905 7.20923H13.7209"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          opacity="0.5"
          d="M6.27905 10.4651H11.3953"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    );
  }
  if (name === "hyperlink") {
    return (
      <svg
        className={classname}
        style={style}
        width="22"
        height="14"
        viewBox="0 0 22 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.99988 7H13.9999"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          opacity="0.5"
          d="M8.00001 13H7.00001C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7.00001 1H8.00001"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          opacity="0.5"
          d="M14 1H15C18.3137 1 21 3.68629 21 7C21 10.3137 18.3137 13 15 13H14"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    );
  }
  if (name === "tick") {
    return (
      <svg
        className={classname}
        style={style}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="currentColor"
        stroke="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
          stroke="none"
        />
        <path
          d="M6.5 10.5L8.5 12.5L13.5 7.5"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </svg>
    );
  }
  if (name === "stall") {
    return (
      <svg
        className={classname}
        style={style}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="currentColor"
        stroke="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
          stroke="none"
        />
        <path
          d="M13 10H7"
          strokeWidth="2"
          strokeLinecap="round"
          fill="none"
        />
      </svg>
    );
  }
  if (name === "star") {
    return (
      <svg
        className={classname}
        style={style}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="currentColor"
        stroke="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10Z"
          stroke="none"
        />
        <path
          d="M10 6.5C10.7241 6.5 11.2064 6.502 11.5654 6.56055C11.8984 6.61485 12.0568 6.70754 12.1748 6.85059C12.3043 7.0077 12.3978 7.24205 12.4482 7.69727C12.4994 8.15867 12.5 8.76942 12.5 9.63867V11.6367C12.5 12.2658 12.4998 12.7037 12.4717 13.0195C12.4578 13.175 12.4389 13.2794 12.418 13.3496C12.3975 13.4182 12.3812 13.4336 12.3848 13.4297C12.3488 13.4695 12.3132 13.4859 12.2861 13.4941C12.2598 13.4816 12.196 13.4464 12.082 13.3496C11.8751 13.1738 11.6098 12.8926 11.2168 12.4756C11.0537 12.3025 10.907 12.1467 10.7754 12.0312C10.6399 11.9123 10.4757 11.7954 10.2637 11.7441C10.0899 11.7022 9.91009 11.7022 9.73633 11.7441C9.52428 11.7954 9.36012 11.9123 9.22461 12.0312C9.09303 12.1467 8.94629 12.3025 8.7832 12.4756C8.39027 12.8927 8.12485 13.1738 7.91797 13.3496C7.80285 13.4474 7.7387 13.4819 7.71289 13.4941C7.68596 13.4857 7.65084 13.4691 7.61523 13.4297C7.6188 13.4336 7.60247 13.4182 7.58203 13.3496C7.56112 13.2794 7.54217 13.175 7.52832 13.0195C7.50019 12.7036 7.5 12.2658 7.5 11.6367V9.63867C7.5 8.76942 7.50062 8.15867 7.55176 7.69727C7.60224 7.24205 7.69567 7.0077 7.8252 6.85059C7.94322 6.70754 8.10163 6.61485 8.43457 6.56055C8.79357 6.502 9.27586 6.5 10 6.5Z"
          fill="none"
        />
      </svg>
    );
  }
  if (name === "danger") {
    return (
      <svg
        className={classname}
        style={style}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
          stroke="none"
        />
        <path
          d="M10 5V11"
          fill="none"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M10 14V14.0001"
          fill="none"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    );
  }
  if (name === "failed") {
    return (
      <svg
        className={classname}
        style={style}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="currentColor"
        stroke="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
          stroke="none"
        />
        <path
          d="M12.5 7.50002L7.50002 12.5M7.5 7.5L12.5 12.5"
          strokeWidth="2"
          strokeLinecap="round"
          fill="none"
        />
      </svg>
    );
  }
  if (name === "info") {
    return (
      <svg
        className={classname}
        width="27"
        height="27"
        viewBox="0 0 27 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M13.5 19.75V12.25" strokeWidth="2" strokeLinecap="round" />
        <path
          opacity="0.5"
          d="M1 13.5C1 7.60744 1 4.66116 2.83059 2.83059C4.66116 1 7.60744 1 13.5 1C19.3925 1 22.3389 1 24.1694 2.83059C26 4.66116 26 7.60744 26 13.5C26 19.3925 26 22.3389 24.1694 24.1694C22.3389 26 19.3925 26 13.5 26C7.60744 26 4.66116 26 2.83059 24.1694C1 22.3389 1 19.3925 1 13.5Z"
          strokeWidth="2"
        />
        <path d="M13.5 8.2501V8.25" strokeWidth="2.5" strokeLinecap="round" />
      </svg>
    );
  }
  if (name === "mission") {
    return (
      <svg
        className={classname}
        width="24"
        height="27"
        viewBox="0 0 24 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M16.8889 3.50244C19.5472 3.51758 20.9869 3.63814 21.926 4.59861C23 5.69694 23 7.4647 23 11.0002V18.5001C23 22.0356 23 23.8034 21.926 24.9017C20.8521 26 19.1236 26 15.6667 26H8.33333C4.87636 26 3.14788 26 2.07394 24.9017C1 23.8034 1 22.0356 1 18.5001V11.0002C1 7.4647 1 5.69694 2.07394 4.59861C3.01307 3.63814 4.45274 3.51758 7.11111 3.50244"
          strokeWidth="2"
        />
        <path
          d="M7.11108 15.9998H16.8889"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M5.88892 11.625H18.1111"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M8.33331 20.3748H15.6666"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M7.11108 2.87498C7.11108 1.83945 7.93189 1 8.94442 1H15.0555C16.068 1 16.8889 1.83945 16.8889 2.87498V4.12497C16.8889 5.1605 16.068 5.99995 15.0555 5.99995H8.94442C7.93189 5.99995 7.11108 5.1605 7.11108 4.12497V2.87498Z"
          strokeWidth="2"
        />
      </svg>
    );
  }
  if (name === "stats") {
    return (
      <svg
        className={classname}
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M1 11C1 6.28595 1 3.92893 2.46447 2.46447C3.92893 1 6.28595 1 11 1C15.714 1 18.0711 1 19.5355 2.46447C21 3.92893 21 6.28595 21 11C21 15.714 21 18.0711 19.5355 19.5355C18.0711 21 15.714 21 11 21C6.28595 21 3.92893 21 2.46447 19.5355C1 18.0711 1 15.714 1 11Z"
          strokeWidth="2"
        />
        <path d="M6 17V8" strokeWidth="2" strokeLinecap="round" />
        <path d="M11 17V5" strokeWidth="2" strokeLinecap="round" />
        <path d="M16 17V12" strokeWidth="2" strokeLinecap="round" />
      </svg>
    );
  }
  if (name === "balance") {
    return (
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M2 11C2 14.7712 2 18.6569 3.31802 19.8284C4.63604 21 6.75736 21 11 21C15.2426 21 17.364 21 18.682 19.8284C20 18.6569 20 14.7712 20 11"
          stroke="white"
          strokeWidth="2"
        />
        <path
          d="M13.6603 13.2019L19.6676 11.3997C20.2631 11.2211 20.5609 11.1317 20.7498 10.9176C20.7866 10.8759 20.8199 10.8312 20.8492 10.784C21 10.5415 21 10.2307 21 9.6089C21 7.15877 21 5.9337 20.327 5.10659C20.1977 4.94763 20.0524 4.80233 19.8934 4.67298C19.0663 4 17.8412 4 15.3911 4H6.60893C4.15877 4 2.9337 4 2.10659 4.67298C1.94763 4.80233 1.80233 4.94763 1.67298 5.10659C1 5.9337 1 7.15877 1 9.6089C1 10.2307 1 10.5415 1.15078 10.784C1.18015 10.8312 1.21341 10.8759 1.25021 10.9176C1.43915 11.1317 1.7369 11.2211 2.3324 11.3997L8.33968 13.2019"
          stroke="white"
          strokeWidth="2"
        />
        <path
          opacity="0.5"
          d="M5.5 4C6.32344 3.97913 7.15925 3.45491 7.43944 2.68032C7.44806 2.65649 7.4569 2.62999 7.47457 2.57697L7.50023 2.5C7.54241 2.37344 7.56351 2.31014 7.58608 2.254C7.87427 1.53712 8.54961 1.05037 9.3208 1.00366C9.3812 1 9.4479 1 9.5814 1H12.4191C12.5525 1 12.6192 1 12.6796 1.00366C13.4508 1.05037 14.1262 1.53712 14.4144 2.254C14.4369 2.31014 14.458 2.37343 14.5002 2.5L14.5259 2.57697C14.5435 2.62968 14.5524 2.65656 14.561 2.68032C14.8412 3.45491 15.6766 3.97913 16.5 4"
          stroke="white"
          strokeWidth="2"
        />
        <path
          d="M13 11.5H9C8.72386 11.5 8.5 11.7239 8.5 12V14.1615C8.5 14.3659 8.62448 14.5498 8.8143 14.6257L9.5144 14.9058C10.4681 15.2872 11.5319 15.2872 12.4856 14.9058L13.1857 14.6257C13.3755 14.5498 13.5 14.3659 13.5 14.1615V12C13.5 11.7239 13.2761 11.5 13 11.5Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    );
  }
  if (name === "pnl") {
    return (
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M1 11C1 6.28595 1 3.92893 2.46447 2.46447C3.92893 1 6.28595 1 11 1C15.714 1 18.0711 1 19.5355 2.46447C21 3.92893 21 6.28595 21 11C21 15.714 21 18.0711 19.5355 19.5355C18.0711 21 15.714 21 11 21C6.28595 21 3.92893 21 2.46447 19.5355C1 18.0711 1 15.714 1 11Z"
          stroke="white"
          strokeWidth="2"
        />
        <path
          d="M6 13L8.29289 10.7071C8.68342 10.3166 9.3166 10.3166 9.7071 10.7071L11.2929 12.2929C11.6834 12.6834 12.3166 12.6834 12.7071 12.2929L16 9M16 9V11.5M16 9H13.5"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  if (name === "pnlloss") {
    return (
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M1 11C1 6.28595 1 3.92893 2.46447 2.46447C3.92893 1 6.28595 1 11 1C15.714 1 18.0711 1 19.5355 2.46447C21 3.92893 21 6.28595 21 11C21 15.714 21 18.0711 19.5355 19.5355C18.0711 21 15.714 21 11 21C6.28595 21 3.92893 21 2.46447 19.5355C1 18.0711 1 15.714 1 11Z"
          stroke="white"
          strokeWidth="2"
        />
        <path
          d="M6 9L8.29289 11.2929C8.68342 11.6834 9.3166 11.6834 9.7071 11.2929L11.2929 9.7071C11.6834 9.3166 12.3166 9.3166 12.7071 9.7071L16 13M16 13V10.5M16 13H13.5"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  if (name === "days") {
    return (
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.66663 20.6667H14.6666"
          stroke="white"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.5"
          d="M3.66663 17.6667H17.6666"
          stroke="white"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.666626 14.6667H20.6666"
          stroke="white"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.5"
          d="M10.6666 4.66675C7.35292 4.66675 4.66663 7.35304 4.66663 10.6667C4.66663 12.1884 5.23308 13.5777 6.16663 14.6354H15.1666C16.1001 13.5777 16.6666 12.1884 16.6666 10.6667C16.6666 7.35304 13.9803 4.66675 10.6666 4.66675Z"
          stroke="white"
          strokeWidth="1.33333"
        />
        <path
          d="M10.9723 10.6619V14.2224H10.361V10.6619L10.6666 10.3562L10.9723 10.6619ZM9.47229 10.2927L9.1969 10.5681L8.76526 10.1365L9.47229 9.42944V10.2927ZM12.568 10.1365L12.1364 10.5681L11.861 10.2927V9.42944L12.568 10.1365Z"
          stroke="white"
          strokeWidth="0.888889"
        />
        <path
          opacity="0.5"
          d="M10.6666 0.666748V1.66675"
          stroke="white"
          strokeWidth="1.33333"
          strokeLinecap="round"
        />
        <path
          opacity="0.5"
          d="M20.6666 10.6667H19.6666"
          stroke="white"
          strokeWidth="1.33333"
          strokeLinecap="round"
        />
        <path
          opacity="0.5"
          d="M1.66663 10.6667H0.666626"
          stroke="white"
          strokeWidth="1.33333"
          strokeLinecap="round"
        />
        <path
          opacity="0.5"
          d="M17.7374 3.59644L17.3446 3.98927"
          stroke="white"
          strokeWidth="1.33333"
          strokeLinecap="round"
        />
        <path
          opacity="0.5"
          d="M3.98842 3.98903L3.59558 3.59619"
          stroke="white"
          strokeWidth="1.33333"
          strokeLinecap="round"
        />
      </svg>
    );
  }
  if (name === "clock") {
    return (
      <svg
        className={classname}
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13 8.19995V13L16 16"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.5"
          d="M1 13C1 7.34314 1 4.51472 2.75736 2.75736C4.51472 1 7.34314 1 13 1C18.6568 1 21.4853 1 23.2426 2.75736C25 4.51472 25 7.34314 25 13C25 18.6568 25 21.4853 23.2426 23.2426C21.4853 25 18.6568 25 13 25C7.34314 25 4.51472 25 2.75736 23.2426C1 21.4853 1 18.6568 1 13Z"
          strokeWidth="2"
        />
      </svg>
    );
  }
  if (name === "stats2") {
    return (
      <svg
        className={classname}
        width="25"
        height="27"
        viewBox="0 0 25 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M1 26H24"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1 12.25C1 11.0715 1 10.4822 1.37425 10.1161C1.74851 9.75 2.35085 9.75 3.55555 9.75C4.76026 9.75 5.3626 9.75 5.73686 10.1161C6.11111 10.4822 6.11111 11.0715 6.11111 12.25V19.75C6.11111 20.9285 6.11111 21.5178 5.73686 21.8839C5.3626 22.25 4.76026 22.25 3.55555 22.25C2.35085 22.25 1.74851 22.25 1.37425 21.8839C1 21.5178 1 20.9285 1 19.75V12.25Z"
          strokeWidth="1.5"
        />
        <path
          d="M9.94446 7.25C9.94446 6.07149 9.94446 5.48224 10.3187 5.11611C10.693 4.75 11.2953 4.75 12.5 4.75C13.7047 4.75 14.307 4.75 14.6813 5.11611C15.0556 5.48224 15.0556 6.07149 15.0556 7.25V19.75C15.0556 20.9285 15.0556 21.5178 14.6813 21.8839C14.307 22.25 13.7047 22.25 12.5 22.25C11.2953 22.25 10.693 22.25 10.3187 21.8839C9.94446 21.5178 9.94446 20.9285 9.94446 19.75V7.25Z"
          strokeWidth="1.5"
        />
        <path
          d="M18.8889 3.5C18.8889 2.32149 18.8889 1.73224 19.2632 1.36611C19.6374 1 20.2398 1 21.4445 1C22.6492 1 23.2515 1 23.6258 1.36611C24 1.73224 24 2.32149 24 3.5V19.75C24 20.9285 24 21.5178 23.6258 21.8839C23.2515 22.25 22.6492 22.25 21.4445 22.25C20.2398 22.25 19.6374 22.25 19.2632 21.8839C18.8889 21.5178 18.8889 20.9285 18.8889 19.75V3.5Z"
          strokeWidth="1.5"
        />
      </svg>
    );
  }
  if (name === "archive") {
    return (
      <svg
        className={classname}
        width="27"
        height="25"
        viewBox="0 0 27 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.75 12.4999C9.75 11.9046 9.75 11.6069 9.84515 11.372C9.97201 11.059 10.2154 10.8102 10.5217 10.6805C10.7514 10.5833 11.0426 10.5833 11.625 10.5833H15.375C15.9574 10.5833 16.2486 10.5833 16.4784 10.6805C16.7846 10.8102 17.028 11.059 17.1549 11.372C17.25 11.6069 17.25 11.9046 17.25 12.4999C17.25 13.0952 17.25 13.393 17.1549 13.6278C17.028 13.9409 16.7846 14.1897 16.4784 14.3193C16.2486 14.4166 15.9574 14.4166 15.375 14.4166H11.625C11.0426 14.4166 10.7514 14.4166 10.5217 14.3193C10.2154 14.1897 9.97201 13.9409 9.84515 13.6278C9.75 13.393 9.75 13.0952 9.75 12.4999Z"
          strokeWidth="2"
        />
        <path
          opacity="0.5"
          d="M24.125 6.11108V13.7777C24.125 18.5965 24.125 21.006 22.6605 22.5029C21.1961 24 18.839 24 14.125 24H12.875C8.16095 24 5.80394 24 4.33946 22.5029C2.875 21.006 2.875 18.5965 2.875 13.7777V6.11108"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M1 3.55555C1 2.35085 1 1.74851 1.36611 1.37425C1.73224 1 2.32149 1 3.5 1H23.5C24.6785 1 25.2677 1 25.6339 1.37425C26 1.74851 26 2.35085 26 3.55555C26 4.76026 26 5.3626 25.6339 5.73686C25.2677 6.11111 24.6785 6.11111 23.5 6.11111H3.5C2.32149 6.11111 1.73224 6.11111 1.36611 5.73686C1 5.3626 1 4.76026 1 3.55555Z"
          strokeWidth="2"
        />
      </svg>
    );
  }
  if (name === "lock") {
    return (
      <svg
        className={classname}
        width="38"
        height="38"
        viewBox="0 0 38 38"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 26.1999C1 21.1088 1 18.5632 2.58162 16.9816C4.16325 15.3999 6.70883 15.3999 11.8 15.3999H26.2C31.2911 15.3999 33.8367 15.3999 35.4183 16.9816C37 18.5632 37 21.1088 37 26.1999C37 31.291 37 33.8366 35.4183 35.4182C33.8367 36.9999 31.2911 36.9999 26.2 36.9999H11.8C6.70883 36.9999 4.16325 36.9999 2.58162 35.4182C1 33.8366 1 31.291 1 26.1999Z"
          strokeWidth="2"
        />
        <path
          d="M19.0001 22.6001V29.8001"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M8.20007 15.4V11.8C8.20007 5.83532 13.0354 1 19.0001 1C24.9647 1 29.8001 5.83532 29.8001 11.8V15.4"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    );
  }
  if (name === "deposit") {
    return (
      <svg
        className={classname}
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M8.6665 16.6665C13.0848 16.6665 16.6665 13.0848 16.6665 8.6665C16.6665 4.24823 13.0848 0.666504 8.6665 0.666504C4.24823 0.666504 0.666504 4.24823 0.666504 8.6665C0.666504 13.0848 4.24823 16.6665 8.6665 16.6665Z"
          stroke="#15A946"
          strokeWidth="1.33333"
        />
        <path
          d="M6.2666 11.0666L11.0666 6.2666M11.0666 6.2666H7.4666M11.0666 6.2666V9.8666"
          stroke="#15A946"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  if (name === "withdraw") {
    return (
      <svg
        className={classname}
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M8.6665 0.666504C4.24823 0.666504 0.666504 4.24823 0.666504 8.6665C0.666504 13.0848 4.24823 16.6665 8.6665 16.6665C13.0848 16.6665 16.6665 13.0848 16.6665 8.6665C16.6665 4.24823 13.0848 0.666504 8.6665 0.666504Z"
          strokeWidth="1.33333"
        />
        <path
          d="M11.0664 6.26641L6.26641 11.0664M6.26641 11.0664H9.86641M6.26641 11.0664V7.46641"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  if (name === "select") {
    return (
      <svg
        className={classname}
        width="12"
        height="6"
        viewBox="0 0 12 6"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 1L6 5L11 1"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  if (name === "payout") {
    return (
      <svg
        className={classname}
        width="17"
        height="15"
        viewBox="0 0 17 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M13.8334 7.08824C15.341 6.85872 16.5 5.47881 16.5 3.81088C16.5 1.98234 15.1071 0.5 13.3889 0.5H3.61111C1.8929 0.5 0.5 1.98234 0.5 3.81088C0.5 5.47881 1.65898 6.85872 3.16666 7.08824"
          stroke="white"
        />
        <path
          d="M8.50002 2.9707V8.73541M8.50002 8.73541L10.1 6.81387M8.50002 8.73541L6.90002 6.81387"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.90002 6.26482C2.90002 4.71196 2.90002 3.93553 3.36866 3.45312C3.83728 2.9707 4.59153 2.9707 6.10002 2.9707H10.9C12.4085 2.9707 13.1627 2.9707 13.6314 3.45312C14.1 3.93553 14.1 4.71196 14.1 6.26482V11.206C14.1 12.7588 14.1 13.5353 13.6314 14.0177C13.1627 14.5001 12.4085 14.5001 10.9 14.5001H6.10002C4.59153 14.5001 3.83728 14.5001 3.36866 14.0177C2.90002 13.5353 2.90002 12.7588 2.90002 11.206V6.26482Z"
          stroke="white"
        />
        <path
          opacity="0.5"
          d="M2.90002 12.0293H14.1"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  if (name === "edit") {
    return (
      <svg
        className={classname}
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M12.7216 2.16406C12.7216 2.16406 12.7864 3.26705 13.7597 4.24027C14.7329 5.21349 15.8359 5.27837 15.8359 5.27837M7.47996 11.8701L6.12988 10.52"
          strokeWidth="2"
        />
        <path
          d="M12.7214 2.16405L13.2405 1.64499C14.1005 0.785002 15.4948 0.785002 16.3548 1.64499C17.2148 2.50499 17.2148 3.89932 16.3548 4.75931L15.8357 5.27836L11.0639 10.0502C10.7407 10.3734 10.5791 10.535 10.4008 10.6741C10.1907 10.838 9.96325 10.9786 9.72261 11.0933C9.51861 11.1905 9.30181 11.2627 8.86813 11.4073L7.47981 11.8701L6.58148 12.1695C6.36809 12.2406 6.13281 12.1851 5.97376 12.0261C5.8147 11.867 5.75917 11.6318 5.83029 11.4183L6.12974 10.52L6.59252 9.13168C6.73706 8.698 6.80933 8.4812 6.90656 8.2772C7.02124 8.03656 7.1618 7.80912 7.32575 7.59896C7.46477 7.42072 7.62637 7.25915 7.94957 6.93595L12.7214 2.16405Z"
          strokeWidth="2"
        />
        <path
          opacity="0.5"
          d="M17 9C17 13.4182 13.4182 17 9 17C4.58172 17 1 13.4182 1 9C1 4.58172 4.58172 1 9 1"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    );
  }
  if (name === "check") {
    return (
      <svg
        className={classname}
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z"
          strokeWidth="2"
        />
        <path
          d="M6.20001 9.4L7.80001 11L11.8 7"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  if (name === "checkMark") {
    return (
      <svg className={classname} width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 3.4L2.6 5L6.59999 1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    );
  }
  if (name === "close") {
    return (
      <svg
        className={classname}
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z"
          strokeWidth="2"
        />
        <path
          d="M11 7.00002L6.99995 11M6.99994 7L11 11"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    );
  }
  if (name === "closeX") {
    return (
      <svg
        className={classname}
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 7.00002L6.99995 11M6.99994 7L11 11"
          strokeWidth="1"
          strokeLinecap="round"
        />
      </svg>
    );
  }
  if (name === "profilePicture") {
    return (
      <svg
        className={classname}
        width="100"
        height="100"
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="0.5" y="0.5" width="99" height="99" rx="49.5" />
        <path
          d="M50.0002 49.8C56.9038 49.8 62.5002 44.2483 62.5002 37.4C62.5002 30.5517 56.9038 25 50.0002 25C43.0967 25 37.5002 30.5517 37.5002 37.4C37.5002 44.2483 43.0967 49.8 50.0002 49.8Z"
          strokeWidth="4"
        />
        <path
          opacity="0.5"
          d="M75 73.0501C75 80.7545 75 87.0001 50 87.0001C25 87.0001 25 80.7545 25 73.0501C25 65.3457 36.1929 59.1001 50 59.1001C63.8072 59.1001 75 65.3457 75 73.0501Z"
          strokeWidth="4"
        />
      </svg>
    );
  }
  if (name === "upload") {
    return (
      <svg
        className={classname}
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21 11C21 15.714 21 18.0711 19.5355 19.5355C18.0711 21 15.714 21 11 21C6.28595 21 3.92893 21 2.46447 19.5355C1 18.0711 1 15.714 1 11C1 6.28595 1 3.92893 2.46447 2.46447C3.92893 1 6.28595 1 11 1"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          opacity="0.5"
          d="M1 11.5001L2.75159 9.96748C3.66286 9.17018 5.03628 9.21588 5.89249 10.0721L10.1822 14.3618C10.8694 15.0491 11.9512 15.1428 12.7464 14.5839L13.0446 14.3744C14.1888 13.5702 15.7369 13.6634 16.7765 14.599L20 17.5001"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M16 1V10M16 1L19 4M16 1L13 4"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  if (name === "plus") {
    return (
      <svg
        className={classname}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M1 10C1 5.75736 1 3.63604 2.31802 2.31802C3.63604 1 5.75736 1 10 1C14.2426 1 16.364 1 17.6819 2.31802C19 3.63604 19 5.75736 19 10C19 14.2426 19 16.364 17.6819 17.6819C16.364 19 14.2426 19 10 19C5.75736 19 3.63604 19 2.31802 17.6819C1 16.364 1 14.2426 1 10Z"
          strokeWidth="2"
        />
        <path
          d="M12.7 10H9.99999M9.99999 10H7.29999M9.99999 10V7.30005M9.99999 10V12.7"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    );
  }
  if (name === "minus") {
    return (
      <svg
        className={classname}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M1 10C1 5.75736 1 3.63604 2.31802 2.31802C3.63604 1 5.75736 1 10 1C14.2426 1 16.364 1 17.6819 2.31802C19 3.63604 19 5.75736 19 10C19 14.2426 19 16.364 17.6819 17.6819C16.364 19 14.2426 19 10 19C5.75736 19 3.63604 19 2.31802 17.6819C1 16.364 1 14.2426 1 10Z"
          strokeWidth="2"
        />
        <path d="M12.7 10H7.30005" strokeWidth="2" strokeLinecap="round" />
      </svg>
    );
  }
  if (name === "line") {
    return (
      <svg
        className={classname}
        viewBox="0 0 101 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.500061 15.5C0.500061 15.5 22.8858 0.5 50.5001 0.5C78.1143 0.5 100.5 15.5 100.5 15.5"
          stroke="url(#paint0_linear_962_66)"
          strokeLinecap="round"
          strokeDasharray="2 2"
        />
        <defs>
          <linearGradient
            id="paint0_linear_962_66"
            x1="0.500061"
            y1="8"
            x2="100.5"
            y2="8"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#ffffff" />
            <stop offset="1" stopColor="#ffffff" stopOpacity="0" />
          </linearGradient>
        </defs>
      </svg>
    );
  }
  if (name === "lineMirrored") {
    return (
      <svg
        className={classname}
        viewBox="0 0 101 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.500061 0.5C0.500061 0.5 22.8858 15.5 50.5001 15.5C78.1143 15.5 100.5 0.5 100.5 0.5"
          stroke="url(#paint0_linear_962_66)"
          strokeLinecap="round"
          strokeDasharray="2 2"
        />
        <defs>
          <linearGradient
            id="paint0_linear_962_66"
            x1="0.500061"
            y1="8"
            x2="100.5"
            y2="8"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#ffffff" />
            <stop offset="1" stopColor="#ffffff" stopOpacity="0" />
          </linearGradient>
        </defs>
      </svg>
    );
  }
  if (name === "inviteMail") {
    return (
      <svg
        className={classname}
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13 25C6.37264 25 0.999999 19.6274 0.999999 13C0.999999 6.37258 6.37264 1 13 1C19.6274 1 25 6.37258 25 13C25 14.9196 24.5493 16.7339 23.7478 18.343C23.5349 18.7706 23.464 19.2593 23.5875 19.7207L24.3022 22.392C24.6125 23.5516 23.5516 24.6124 22.392 24.3022L19.7207 23.5875C19.2593 23.464 18.7705 23.5349 18.343 23.7478C16.734 24.5493 14.9196 25 13 25Z"
          strokeWidth="2"
          fill="none"
        />
        <path
          opacity="0.5"
          d="M13 10.0009L13.6431 10.6306C13.4737 10.8035 13.242 10.9009 13 10.9009C12.7579 10.9009 12.5262 10.8035 12.3569 10.6306L13 10.0009ZM14.7826 15.8458C15.4805 15.252 16.1811 14.5643 16.7004 13.8532C17.2303 13.1274 17.5 12.4745 17.5 11.9313H19.3C19.3 13.0301 18.7784 14.0596 18.1541 14.9147C17.5192 15.7842 16.7026 16.5755 15.9489 17.2168L14.7826 15.8458ZM17.5 11.9313C17.5 10.602 16.9065 9.90202 16.296 9.67372C15.6754 9.44166 14.6859 9.56553 13.6431 10.6306L12.3569 9.37128C13.744 7.95464 15.4545 7.43736 16.9264 7.98773C18.4084 8.54188 19.3 10.0479 19.3 11.9313H17.5ZM10.0511 17.2168C9.29739 16.5755 8.48079 15.7842 7.84587 14.9147C7.22151 14.0596 6.69999 13.0301 6.69999 11.9313H8.49999C8.49999 12.4745 8.76975 13.1275 9.29955 13.8532C9.81891 14.5644 10.5195 15.252 11.2174 15.8458L10.0511 17.2168ZM6.69999 11.9313C6.69999 10.0479 7.59159 8.54187 9.07359 7.98773C10.5455 7.43736 12.256 7.95464 13.6431 9.37128L12.3569 10.6306C11.3141 9.56553 10.3246 9.44166 9.70395 9.67372C9.09339 9.90202 8.49999 10.602 8.49999 11.9313H6.69999ZM15.9489 17.2168C15.0135 18.0125 14.2686 18.6928 13 18.6928V16.8928C13.4968 16.8928 13.7406 16.7321 14.7826 15.8458L15.9489 17.2168ZM11.2174 15.8458C12.2593 16.7321 12.5032 16.8928 13 16.8928V18.6928C11.7313 18.6928 10.9865 18.0125 10.0511 17.2168L11.2174 15.8458Z"
          stroke="none"
        />
      </svg>
    );
  }
  if (name === "signUp") {
    return (
      <svg
        className={classname}
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M13 25C6.37257 25 1.00003 19.6275 1.00003 13C1.00003 6.37258 6.37257 1 13 1"
          fill="none"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M25 13H10M10 13L14.5 8.5M10 13L14.5 17.5"
          fill="none"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  if (name === "gift") {
    return (
      <svg
        className={classname}
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M24.6667 12.6667H0.666687"
          strokeWidth="1.33333"
          strokeLinecap="round"
        />
        <path
          opacity="0.5"
          d="M12.6666 0.666748V24.6667"
          strokeWidth="1.33333"
          strokeLinecap="round"
        />
        <path
          d="M13.8666 12.6667C13.8666 15.3177 16.0157 17.4667 18.6666 17.4667"
          strokeWidth="1.33333"
          strokeLinecap="round"
        />
        <path
          d="M11.4669 12.6667C11.4669 15.3177 9.3179 17.4667 6.66693 17.4667"
          strokeWidth="1.33333"
          strokeLinecap="round"
        />
        <path
          d="M12.6666 10.309C12.6666 8.52115 13.8834 6.96271 15.6179 6.52909C17.5423 6.04797 19.2856 7.79117 18.8044 9.71564C18.3708 11.4501 16.8124 12.6669 15.0245 12.6669H12.6666V10.309Z"
          strokeWidth="1.33333"
        />
        <path
          d="M12.667 10.309C12.667 8.52115 11.4502 6.96271 9.71576 6.52909C7.7913 6.04797 6.0481 7.79117 6.52921 9.71564C6.96283 11.4501 8.52127 12.6669 10.3092 12.6669H12.667V10.309Z"
          strokeWidth="1.33333"
        />
        <path
          d="M0.666687 12.6667C0.666687 7.00989 0.666687 4.18146 2.42405 2.42411C4.1814 0.666748 7.00983 0.666748 12.6667 0.666748C18.3235 0.666748 21.152 0.666748 22.9093 2.42411C24.6667 4.18146 24.6667 7.00989 24.6667 12.6667C24.6667 18.3235 24.6667 21.1521 22.9093 22.9093C21.152 24.6667 18.3235 24.6667 12.6667 24.6667C7.00983 24.6667 4.1814 24.6667 2.42405 22.9093C0.666687 21.1521 0.666687 18.3235 0.666687 12.6667Z"
          strokeWidth="1.33333"
        />
      </svg>
    );
  }
  if (name === "sale") {
    return (
      <svg
        className={classname}
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M10.1109 2.44033C10.8452 1.81459 11.2122 1.50173 11.5961 1.31827C12.4839 0.893912 13.516 0.893912 14.4039 1.31827C14.7878 1.50173 15.1548 1.81459 15.8891 2.44033C16.1813 2.68937 16.3275 2.81389 16.4836 2.91848C16.8413 3.15825 17.243 3.32466 17.6654 3.40806C17.8498 3.44446 18.0411 3.45973 18.424 3.49027C19.3856 3.56701 19.8664 3.60538 20.2676 3.74707C21.1954 4.07481 21.9252 4.80461 22.253 5.73245C22.3947 6.13361 22.433 6.61444 22.5098 7.5761C22.5403 7.95885 22.5555 8.15022 22.592 8.33453C22.6753 8.75702 22.8417 9.15875 23.0816 9.51649C23.1861 9.67254 23.3106 9.81866 23.5597 10.1109C24.1854 10.8451 24.4984 11.2124 24.6818 11.5961C25.1061 12.4839 25.1061 13.516 24.6818 14.4039C24.4984 14.7877 24.1854 15.1548 23.5597 15.8891C23.3106 16.1813 23.1861 16.3274 23.0816 16.4836C22.8417 16.8413 22.6753 17.243 22.592 17.6656C22.5555 17.8498 22.5403 18.0412 22.5098 18.4239C22.433 19.3856 22.3947 19.8664 22.253 20.2676C21.9252 21.1954 21.1954 21.9252 20.2676 22.253C19.8664 22.3947 19.3856 22.433 18.424 22.5098C18.0411 22.5403 17.8498 22.5556 17.6654 22.5919C17.243 22.6754 16.8413 22.8417 16.4836 23.0816C16.3275 23.1861 16.1813 23.3106 15.8891 23.5597C15.1548 24.1854 14.7878 24.4983 14.4039 24.6818C13.516 25.1061 12.4839 25.1061 11.5961 24.6818C11.2122 24.4983 10.8452 24.1854 10.1109 23.5597C9.81866 23.3106 9.67253 23.1861 9.51648 23.0816C9.15876 22.8417 8.75702 22.6754 8.33453 22.5919C8.15022 22.5556 7.95885 22.5403 7.5761 22.5098C6.61444 22.433 6.1336 22.3947 5.73245 22.253C4.80461 21.9252 4.0748 21.1954 3.74708 20.2676C3.60539 19.8664 3.56701 19.3856 3.49027 18.4239C3.45973 18.0412 3.44446 17.8498 3.40807 17.6656C3.32466 17.243 3.15826 16.8413 2.91849 16.4836C2.8139 16.3274 2.68937 16.1813 2.44033 15.8891C1.81459 15.1548 1.50173 14.7877 1.31826 14.4039C0.893915 13.516 0.893915 12.4839 1.31826 11.5961C1.50173 11.2122 1.81459 10.8451 2.44033 10.1109C2.68937 9.81866 2.8139 9.67254 2.91849 9.51649C3.15826 9.15875 3.32466 8.75702 3.40807 8.33453C3.44446 8.15022 3.45973 7.95885 3.49027 7.5761C3.56701 6.61444 3.60539 6.13361 3.74708 5.73245C4.0748 4.80461 4.80461 4.07481 5.73245 3.74707C6.1336 3.60538 6.61444 3.56701 7.5761 3.49027C7.95885 3.45973 8.15022 3.44446 8.33453 3.40806C8.75702 3.32466 9.15876 3.15825 9.51648 2.91848C9.67254 2.81389 9.81866 2.68937 10.1109 2.44033Z"
          fill="none"
          strokeWidth="2"
        />
        <path
          d="M9.09344 16.9073L16.9065 9.09424"
          fill="none"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M17.5576 16.256C17.5576 16.9752 16.9746 17.5582 16.2554 17.5582C15.5362 17.5582 14.9532 16.9752 14.9532 16.256C14.9532 15.5368 15.5362 14.9539 16.2554 14.9539C16.9746 14.9539 17.5576 15.5368 17.5576 16.256Z"
          stroke="none"
        />
        <path
          d="M11.0467 9.74529C11.0467 10.4645 10.4638 11.0475 9.74456 11.0475C9.02539 11.0475 8.44238 10.4645 8.44238 9.74529C8.44238 9.02613 9.02539 8.44312 9.74456 8.44312C10.4638 8.44312 11.0467 9.02613 11.0467 9.74529Z"
          stroke="none"
        />
      </svg>
    );
  }
  if (name === "cart") {
    return (
      <svg
        className={classname}
        width="24"
        height="23"
        viewBox="0 0 24 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M7.31724 18.4392C8.2871 18.4392 9.07332 19.2255 9.07332 20.1953C9.07332 21.1651 8.2871 21.9514 7.31724 21.9514C6.34738 21.9514 5.56116 21.1651 5.56116 20.1953C5.56116 19.2255 6.34738 18.4392 7.31724 18.4392Z"
          strokeWidth="2"
          fill="none"
        />
        <path
          opacity="0.5"
          d="M17.8537 18.4392C18.8236 18.4392 19.6098 19.2253 19.6098 20.1953C19.6098 21.1651 18.8236 21.9514 17.8537 21.9514C16.8839 21.9514 16.0977 21.1651 16.0977 20.1953C16.0977 19.2253 16.8839 18.4392 17.8537 18.4392Z"
          strokeWidth="2"
          fill="none"
        />
        <path
          d="M1.16951 0.0499449C0.712023 -0.1109 0.210779 0.129577 0.0499449 0.587048C-0.1109 1.04453 0.129577 1.54577 0.587048 1.70661L1.16951 0.0499449ZM22.7214 8.93605L23.5812 9.11336L23.5824 9.10797L22.7214 8.93605ZM5.2194 8.79235V5.60607H3.46332V8.79235H5.2194ZM1.47531 0.157452L1.16951 0.0499449L0.587048 1.70661L0.892852 1.81413L1.47531 0.157452ZM11.3416 16.3903H17.5498V14.6342H11.3416V16.3903ZM5.2194 5.60607C5.2194 4.77818 5.2206 4.08734 5.15982 3.52594C5.09692 2.94482 4.96064 2.41481 4.63052 1.93173L3.18063 2.92251C3.2863 3.07715 3.3679 3.28954 3.41394 3.71492C3.46213 4.16004 3.46332 4.73979 3.46332 5.60607H5.2194ZM0.892852 1.81413C1.67444 2.08892 2.18809 2.27102 2.56606 2.45648C2.92104 2.63066 3.07753 2.77165 3.18063 2.92251L4.63052 1.93173C4.29782 1.44487 3.85547 1.13306 3.33961 0.879951C2.84671 0.638103 2.21752 0.418406 1.47531 0.157452L0.892852 1.81413ZM3.46332 8.79235C3.46332 10.4928 3.47928 11.719 3.63973 12.6558C3.81103 13.656 4.15304 14.3721 4.79252 15.0466L6.06689 13.8384C5.69207 13.443 5.4899 13.0559 5.3706 12.3594C5.24046 11.5995 5.2194 10.5356 5.2194 8.79235H3.46332ZM11.3416 14.6342C9.6829 14.6342 8.53202 14.6321 7.6649 14.5092C6.82805 14.3905 6.38596 14.1749 6.06689 13.8384L4.79252 15.0466C5.48777 15.7799 6.3691 16.0992 7.41834 16.2478C8.43732 16.3924 9.73519 16.3903 11.3416 16.3903V14.6342ZM4.34136 5.40897H18.543V3.65288H4.34136V5.40897ZM21.8613 8.75881L21.2763 11.5975L22.9962 11.952L23.5812 9.11336L21.8613 8.75881ZM18.543 5.40897C19.5457 5.40897 20.428 5.41014 21.1244 5.48798C21.4704 5.52666 21.7294 5.58039 21.9113 5.64434C22.1003 5.71073 22.1304 5.76167 22.1153 5.74191L23.5071 4.67115C23.232 4.31359 22.8452 4.11116 22.4935 3.98756C22.1347 3.86148 21.7289 3.78854 21.3195 3.74277C20.5049 3.65171 19.5131 3.65288 18.543 3.65288V5.40897ZM23.5824 9.10797C23.7805 8.11528 23.9487 7.2824 23.9899 6.61525C24.0322 5.92898 23.9541 5.25229 23.5071 4.67115L22.1153 5.74191C22.1879 5.83637 22.268 6.00647 22.2371 6.50707C22.2051 7.0268 22.0686 7.72088 21.8603 8.76419L23.5824 9.10797ZM17.5498 16.3903C18.4415 16.3903 19.1899 16.3918 19.7931 16.318C20.4203 16.2413 20.9923 16.0735 21.4916 15.6666L20.3822 14.3053C20.2357 14.4247 20.0279 14.5201 19.5798 14.575C19.1078 14.6327 18.4856 14.6342 17.5498 14.6342V16.3903ZM21.2763 11.5975C21.0874 12.514 20.9602 13.1232 20.8084 13.5738C20.6643 14.0015 20.5288 14.1859 20.3822 14.3053L21.4916 15.6666C21.9909 15.2596 22.2707 14.7333 22.4726 14.1346C22.6667 13.5586 22.8162 12.8254 22.9962 11.952L21.2763 11.5975Z"
          stroke="none"
        />
        <path
          opacity="0.5"
          d="M11.4148 10.0099L12.7528 11.4147L16.0977 7.90259"
          fill="none"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  if (name === "test") {
    return (
      <svg
        className={classname}
        width="26"
        height="24"
        viewBox="0 0 26 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.00006 4L2.45721 5.8L7.60006 1"
          fill="none"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.5"
          d="M1.00006 12.3999L2.45721 14.1999L7.60006 9.3999"
          fill="none"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.00006 20.8L2.45721 22.6L7.60006 17.8"
          fill="none"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.0001 20.2H13.0001"
          fill="none"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          opacity="0.5"
          d="M25.0001 11.8H13.0001"
          fill="none"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M25.0001 3.3999H13.0001"
          fill="none"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    );
  }
  if (name === "saleForCoupon") {
    return (
      <svg
        className={classname}
        width="34"
        height="30"
        viewBox="0 0 34 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.37402 21.9478C3.37402 19.3442 5.66963 17.1032 8.63672 17.103C11.6007 17.103 13.8972 19.3432 13.8975 21.9468C13.8975 24.5551 11.6006 26.7954 8.63672 26.7954C7.22426 26.7953 5.91031 26.2886 4.92285 25.3843V25.3833C3.91358 24.4606 3.37415 23.2418 3.37402 21.9478Z"
          strokeWidth="2"
        />
        <path
          d="M3.25482 7.25L3.2558 7.24902C3.27986 7.2047 3.32839 7.19583 3.36029 7.21387L3.36127 7.21484L30.8554 22.6895L30.8593 22.6914C30.8774 22.7015 30.8939 22.7188 30.9023 22.748C30.9107 22.7777 30.9069 22.8086 30.8915 22.8369C30.8638 22.8859 30.8159 22.8902 30.787 22.874L30.7851 22.8721L3.29095 7.39844L3.28705 7.39648C3.26895 7.38638 3.25338 7.36831 3.24506 7.33887C3.23672 7.3091 3.23941 7.27828 3.25482 7.25Z"
          strokeWidth="2"
        />
        <path
          d="M20.3062 8.05249C20.3062 6.75882 20.8445 5.54174 21.855 4.61597C22.8424 3.7118 24.1564 3.2049 25.5689 3.20483C28.5329 3.20487 30.8297 5.44424 30.8297 8.05249C30.8295 10.6602 28.5332 12.8982 25.5689 12.8982C22.6017 12.8981 20.3064 10.6599 20.3062 8.05249Z"
          strokeWidth="2"
        />
        <path
          d="M23.9266 8.06909C23.9266 7.62486 24.4571 6.92761 25.5604 6.92749C26.6654 6.92749 27.198 7.62609 27.1981 8.06909C27.1981 8.51065 26.6672 9.20776 25.5604 9.20776C24.4553 9.20764 23.9266 8.51185 23.9266 8.06909Z"
          strokeWidth="2"
        />
        <path
          d="M6.92102 22.0674C6.92117 21.6267 7.45081 20.9288 8.55481 20.9287C9.66249 20.9287 10.1914 21.6272 10.1915 22.0674C10.1915 22.5111 9.66175 23.209 8.55481 23.209C7.52026 23.2089 6.989 22.5959 6.92688 22.1533L6.92102 22.0674Z"
          strokeWidth="2"
        />
      </svg>
    );
  }
  if (name === "share") {
    return (
      <svg
        className={classname}
        width="15"
        height="18"
        viewBox="0 0 15 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.33338 8.55547C5.33338 9.78276 4.36332 10.7777 3.16669 10.7777C1.97006 10.7777 1 9.78276 1 8.55547C1 7.32819 1.97006 6.33325 3.16669 6.33325C4.36332 6.33325 5.33338 7.32819 5.33338 8.55547Z"
          strokeWidth="2"
        />
        <path
          opacity="0.5"
          d="M9.94455 13.2682L5.33331 10.1467"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          opacity="0.5"
          d="M10.0314 4.41309L5.42017 7.53456"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M14 14.7779C14 16.0052 13.0299 17.0001 11.8333 17.0001C10.6367 17.0001 9.66663 16.0052 9.66663 14.7779C9.66663 13.5506 10.6367 12.5557 11.8333 12.5557C13.0299 12.5557 14 13.5506 14 14.7779Z"
          strokeWidth="2"
        />
        <path
          d="M14 3.22222C14 4.44952 13.0299 5.44444 11.8333 5.44444C10.6367 5.44444 9.66663 4.44952 9.66663 3.22222C9.66663 1.99492 10.6367 1 11.8333 1C13.0299 1 14 1.99492 14 3.22222Z"
          strokeWidth="2"
        />
      </svg>
    );
  }
  if (name === "infoCircle") {
    return (
      <svg
        className={classname}
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M8.5 16.5C12.9183 16.5 16.5 12.9183 16.5 8.5C16.5 4.08172 12.9183 0.5 8.5 0.5C4.08172 0.5 0.5 4.08172 0.5 8.5C0.5 12.9183 4.08172 16.5 8.5 16.5Z"
          fill="none"
        />
        <path d="M8.49997 12.5V7.69995Z" stroke="none" />
        <path d="M8.49997 12.5V7.69995" fill="none" strokeLinecap="round" />
        <path
          d="M8.50001 4.5001C8.94184 4.5001 9.30001 4.85827 9.30001 5.3001C9.30001 5.74193 8.94184 6.1001 8.50001 6.1001C8.05818 6.1001 7.70001 5.74193 7.70001 5.3001C7.70001 4.85827 8.05818 4.5001 8.50001 4.5001Z"
          stroke="none"
        />
      </svg>
    );
  }
  if (name === "download") {
    return (
      <svg
        className={classname}
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M1 11.6667C1 14.1809 1 15.4379 1.78105 16.219C2.5621 17.0001 3.81917 17.0001 6.33333 17.0001H11.6667C14.1808 17.0001 15.4379 17.0001 16.2189 16.219C17 15.4379 17 14.1809 17 11.6667"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.00001 1V12.5556M9.00001 12.5556L12.5556 8.66667M9.00001 12.5556L5.44446 8.66667"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  if (name === "btc") {
    return (
      <svg
        className={classname}
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
          fill="#F7931A"
        />
        <path
          d="M11.5946 7.01C11.7516 5.962 10.9531 5.3985 9.86211 5.0225L10.2161 3.6025L9.35211 3.3875L9.00711 4.77C8.78011 4.713 8.54711 4.66 8.31461 4.607L8.66211 3.2155L7.79811 3L7.44411 4.4195C7.25611 4.3765 7.07111 4.3345 6.89211 4.2895L6.89311 4.285L5.70111 3.9875L5.47111 4.9105C5.47111 4.9105 6.11261 5.0575 6.09911 5.0665C6.44911 5.154 6.51211 5.3855 6.50161 5.5695L6.09861 7.187C6.12261 7.193 6.15361 7.202 6.18861 7.2155L6.09711 7.193L5.53211 9.459C5.48911 9.565 5.38061 9.7245 5.13561 9.664C5.14461 9.6765 4.50761 9.5075 4.50761 9.5075L4.07861 10.4965L5.20361 10.777C5.41261 10.8295 5.61761 10.8845 5.81911 10.936L5.46161 12.372L6.32511 12.587L6.67911 11.167C6.91511 11.2305 7.14411 11.2895 7.36811 11.3455L7.01511 12.7595L7.87911 12.9745L8.23661 11.5415C9.71061 11.8205 10.8186 11.708 11.2851 10.375C11.6611 9.302 11.2666 8.6825 10.4911 8.279C11.0561 8.149 11.4811 7.7775 11.5946 7.01ZM9.61961 9.779C9.35311 10.8525 7.54561 10.272 6.95961 10.1265L7.43461 8.224C8.02061 8.3705 9.89911 8.66 9.61961 9.779ZM9.88711 6.9945C9.64361 7.971 8.13961 7.4745 7.65211 7.353L8.08211 5.628C8.56961 5.7495 10.1411 5.976 9.88711 6.9945Z"
          fill="white"
        />
      </svg>
    );
  }
  if (name === "bnb") {
    return (
      <svg
        className={classname}
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
          fill="#F3BA2F"
        />
        <path
          d="M6.058 7.202L8 5.26L9.943 7.203L11.073 6.073L8 3L4.928 6.072L6.058 7.202ZM3 8L4.13 6.87L5.26 8L4.13 9.13L3 8ZM6.058 8.798L8 10.74L9.943 8.797L11.073 9.9265L8 13L4.928 9.928L4.9265 9.9265L6.058 8.798ZM10.74 8L11.87 6.87L13 8L11.87 9.13L10.74 8ZM9.146 7.999H9.147V8L8 9.147L6.8545 8.002L6.8525 8L6.8545 7.9985L7.055 7.7975L7.1525 7.7L8 6.853L9.1465 7.9995L9.146 7.999Z"
          fill="white"
        />
      </svg>
    );
  }
  if (name === "sol") {
    return (
      <svg
        className={classname}
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
          fill="#66F9A1"
        />
        <path
          d="M4.96252 9.8435C5.0178 9.78896 5.09236 9.75842 5.17002 9.7585H12.353C12.382 9.75811 12.4104 9.7664 12.4346 9.7823C12.4588 9.79821 12.4777 9.821 12.4888 9.84774C12.5 9.87447 12.5028 9.90394 12.4971 9.93232C12.4913 9.96071 12.4772 9.98672 12.4565 10.007L11.0375 11.4145C10.9823 11.4692 10.9077 11.5 10.83 11.5H3.64702C3.61806 11.5002 3.58969 11.4918 3.56553 11.4759C3.54138 11.4599 3.52253 11.4371 3.51142 11.4104C3.5003 11.3836 3.49742 11.3542 3.50314 11.3258C3.50886 11.2974 3.52292 11.2714 3.54352 11.251L4.96252 9.8435ZM4.96252 4.585C5.0178 4.53046 5.09236 4.49992 5.17002 4.5H12.353C12.4835 4.5 12.549 4.657 12.4565 4.749L11.0375 6.1565C10.9822 6.21104 10.9077 6.24158 10.83 6.2415H3.64702C3.61816 6.24165 3.58992 6.23321 3.56587 6.21726C3.54182 6.20132 3.52306 6.17858 3.51197 6.15194C3.50087 6.12531 3.49795 6.09598 3.50357 6.06767C3.50918 6.03937 3.52309 6.01338 3.54352 5.993L4.96252 4.585ZM11.0375 7.1975C10.9822 7.14296 10.9077 7.11242 10.83 7.1125H3.64702C3.61806 7.11225 3.58969 7.12065 3.56553 7.13662C3.54138 7.15259 3.52253 7.17541 3.51142 7.20215C3.5003 7.22889 3.49742 7.25834 3.50314 7.28672C3.50886 7.31511 3.52292 7.34115 3.54352 7.3615L4.96252 8.769C5.01752 8.8235 5.09252 8.854 5.17002 8.854H12.353C12.382 8.85425 12.4103 8.84585 12.4345 8.82988C12.4587 8.81391 12.4775 8.79109 12.4886 8.76435C12.4997 8.73761 12.5026 8.70816 12.4969 8.67978C12.4912 8.65139 12.4771 8.62535 12.4565 8.605L11.0375 7.1975Z"
          fill="white"
        />
      </svg>
    );
  }
  if (name === "eth") {
    return (
      <svg
        className={classname}
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
          fill="#627EEA"
        />
        <path
          d="M8.24902 2V6.435L11.9975 8.11L8.24902 2Z"
          fill="white"
          fillOpacity="0.602"
        />
        <path d="M8.249 2L4.5 8.11L8.249 6.435V2Z" fill="white" />
        <path
          d="M8.24902 10.984V13.9975L12 8.80798L8.24902 10.984Z"
          fill="white"
          fillOpacity="0.602"
        />
        <path
          d="M8.249 13.9975V10.9835L4.5 8.80798L8.249 13.9975Z"
          fill="white"
        />
        <path
          d="M8.24902 10.2865L11.9975 8.11004L8.24902 6.43604V10.2865Z"
          fill="white"
          fillOpacity="0.2"
        />
        <path
          d="M4.5 8.11004L8.249 10.2865V6.43604L4.5 8.11004Z"
          fill="white"
          fillOpacity="0.602"
        />
      </svg>
    );
  }
  if (name === "xrp") {
    return (
      <svg
        className={classname}
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
          fill="#23292F"
        />
        <path
          d="M11.535 4H12.98L9.9725 6.9785C9.44668 7.49656 8.73816 7.78696 8 7.78696C7.26184 7.78696 6.55332 7.49656 6.0275 6.9785L3.0175 4H4.465L6.75 6.2615C7.08275 6.58993 7.53147 6.77408 7.999 6.77408C8.46653 6.77408 8.91525 6.58993 9.248 6.2615L11.535 4ZM4.4475 12.2815H3L6.0275 9.285C6.55332 8.76694 7.26184 8.47654 8 8.47654C8.73816 8.47654 9.44668 8.76694 9.9725 9.285L13 12.281H11.5525L9.25 10C8.91725 9.67157 8.46853 9.48742 8.001 9.48742C7.53347 9.48742 7.08475 9.67157 6.752 10L4.447 12.2815H4.4475Z"
          fill="white"
        />
      </svg>
    );
  }
  if (name === "usdt") {
    return (
      <svg
        className={classname}
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
          fill="#26A17B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.96102 8.69155V8.69055C8.90602 8.69455 8.62252 8.71155 7.99002 8.71155C7.48502 8.71155 7.12952 8.69655 7.00452 8.69055V8.69205C5.06052 8.60655 3.60952 8.26805 3.60952 7.86305C3.60952 7.45855 5.06052 7.12005 7.00452 7.03305V8.35505C7.13152 8.36405 7.49552 8.38555 7.99852 8.38555C8.60202 8.38555 8.90452 8.36055 8.96102 8.35555V7.03405C10.901 7.12055 12.3485 7.45905 12.3485 7.86305C12.3485 8.26805 10.901 8.60555 8.96102 8.69155ZM8.96102 6.89655V5.71355H11.668V3.90955H4.29752V5.71355H7.00452V6.89605C4.80452 6.99705 3.15002 7.43305 3.15002 7.95505C3.15002 8.47705 4.80452 8.91255 7.00452 9.01405V12.805H8.96102V9.01305C11.1575 8.91205 12.808 8.47655 12.808 7.95505C12.808 7.43355 11.1575 6.99805 8.96102 6.89655Z"
          fill="white"
        />
      </svg>
    );
  }
  if (name === "ilustKYCDone") {
    return (
      <svg
        className={classname}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 680.83858 584.23207"
        role="img"
        artist="Katerina Limpitsouni"
        source="https://undraw.co/"
      >
        <path
          id="b9ccae5a-ffdd-4f5c-9c1e-05af9f0f3372-3202"
          dataName="Path 438"
          d="M310.70569,694.02818a24.21459,24.21459,0,0,0,23.38269-4.11877c8.18977-6.87441,10.758-18.196,12.8467-28.68191l6.17973-31.01657-12.9377,8.90837c-9.30465,6.40641-18.81826,13.01866-25.26011,22.29785s-9.25223,21.94707-4.07792,31.988"
          transform="translate(-259.58071 -157.88396)"
          fill="#e6e6e6"
        />
        <path
          id="f4ad1d06-bd03-4ced-a5c4-c19a65ab4ee5-3203"
          dataName="Path 439"
          d="M312.7034,733.73874c-1.62839-11.86368-3.30382-23.88078-2.15884-35.87167,1.01467-10.64932,4.26373-21.04881,10.87831-29.57938a49.20592,49.20592,0,0,1,12.62466-11.44039c1.26215-.79648,2.42409,1.20354,1.16733,1.997a46.77949,46.77949,0,0,0-18.50446,22.32562c-4.02857,10.24607-4.67545,21.41582-3.98154,32.3003.41944,6.58218,1.31074,13.1212,2.20588,19.65251a1.19817,1.19817,0,0,1-.808,1.42251,1.16348,1.16348,0,0,1-1.42253-.808Z"
          transform="translate(-259.58071 -157.88396)"
          fill="#f2f2f2"
        />
        <path
          id="baf785f8-b4c6-42cf-85bd-8a16037845f7-3204"
          dataName="Path 442"
          d="M324.42443,714.70229a17.82513,17.82513,0,0,0,15.53141,8.01862c7.8644-.37318,14.41806-5.85973,20.31713-11.07027l17.452-15.4088-11.54987-.55281c-8.30619-.39784-16.82672-.771-24.73813,1.79338s-15.20758,8.72639-16.654,16.91541"
          transform="translate(-259.58071 -157.88396)"
          fill="#e6e6e6"
        />
        <path
          id="a14e4330-7125-4e03-a856-d6453c34f6cc-3205"
          dataName="Path 443"
          d="M308.10042,740.55843c7.83972-13.87142,16.93234-29.28794,33.1808-34.21552a37.02609,37.02609,0,0,1,13.95545-1.441c1.48189.128,1.11179,2.41174-.367,2.28454a34.39833,34.39833,0,0,0-22.27164,5.89215c-6.27994,4.27453-11.16975,10.21755-15.30781,16.51907-2.53511,3.86051-4.80576,7.88445-7.07642,11.903C309.48824,742.78513,307.36641,741.85759,308.10042,740.55843Z"
          transform="translate(-259.58071 -157.88396)"
          fill="#f2f2f2"
        />
        <path
          id="ac20a106-7eb8-4a45-8835-674ef3bf3222-3206"
          dataName="Path 141"
          d="M935.3957,569.31654H503.18092a5.03014,5.03014,0,0,1-5.02359-5.02359V162.90754a5.03017,5.03017,0,0,1,5.02359-5.02358H935.3957a5.03017,5.03017,0,0,1,5.02359,5.02358V564.292a5.02922,5.02922,0,0,1-5.02359,5.02359Z"
          transform="translate(-259.58071 -157.88396)"
          fill="#fff"
        />
        <path
          id="a8878079-c7cd-406f-a434-8b15b914b9b4-3207"
          dataName="Path 141"
          d="M935.3957,569.31654H503.18092a5.03014,5.03014,0,0,1-5.02359-5.02359V162.90754a5.03017,5.03017,0,0,1,5.02359-5.02358H935.3957a5.03017,5.03017,0,0,1,5.02359,5.02358V564.292a5.02922,5.02922,0,0,1-5.02359,5.02359ZM503.18092,159.88944a3.01808,3.01808,0,0,0-3.01152,3.01151V564.292a3.01808,3.01808,0,0,0,3.01152,3.01152H935.3957a3.01717,3.01717,0,0,0,3.01153-3.01152V162.90754a3.01809,3.01809,0,0,0-3.01153-3.01151Z"
          transform="translate(-259.58071 -157.88396)"
          fill="#cacaca"
        />
        <path
          id="af64f961-e9a2-4c53-a333-5060c7f850d2-3208"
          dataName="Path 142"
          d="M707.41023,262.18528a3.41053,3.41053,0,0,0,0,6.82105H894.55305a3.41053,3.41053,0,0,0,0-6.82105Z"
          transform="translate(-259.58071 -157.88396)"
          fill="#e4e4e4"
        />
        <path
          id="baad4cfb-158d-4439-9cc3-22475bf47b22-3209"
          dataName="Path 143"
          d="M707.41023,282.65037a3.41054,3.41054,0,0,0,0,6.82106h95.54019a3.41054,3.41054,0,0,0,0-6.82106Z"
          transform="translate(-259.58071 -157.88396)"
          fill="#e4e4e4"
        />
        <path
          id="f3456279-91e5-49ad-aa43-9838b26fb6ca-3210"
          dataName="Path 142"
          d="M543.84146,392.7046a3.41054,3.41054,0,0,0,0,6.82106h350.8937a3.41054,3.41054,0,0,0,0-6.82106Z"
          transform="translate(-259.58071 -157.88396)"
          fill="#e4e4e4"
        />
        <path
          id="a3288adf-49f8-485f-8ae9-1e4f1a13d849-3211"
          dataName="Path 143"
          d="M543.84146,413.1697a3.41054,3.41054,0,0,0,0,6.82106H803.13254a3.41054,3.41054,0,0,0,0-6.82106Z"
          transform="translate(-259.58071 -157.88396)"
          fill="#e4e4e4"
        />
        <path
          id="e63a5b48-5a7d-40a2-b9b0-6adec326348a-3212"
          dataName="Path 142"
          d="M543.84146,433.17177a3.41054,3.41054,0,0,0,0,6.82106h350.8937a3.41054,3.41054,0,0,0,0-6.82106Z"
          transform="translate(-259.58071 -157.88396)"
          fill="#e4e4e4"
        />
        <path
          id="a1c669b4-dfc3-4cfa-a7be-66b71399844d-3213"
          dataName="Path 143"
          d="M543.84146,453.63687a3.41054,3.41054,0,0,0,0,6.82106H803.13254a3.41054,3.41054,0,0,0,0-6.82106Z"
          transform="translate(-259.58071 -157.88396)"
          fill="#e4e4e4"
        />
        <path
          id="bfec50d1-ffb1-4de6-a9ef-a1085e40e016-3214"
          dataName="Path 142"
          d="M543.84146,474.17177a3.41054,3.41054,0,0,0,0,6.82106h350.8937a3.41054,3.41054,0,0,0,0-6.82106Z"
          transform="translate(-259.58071 -157.88396)"
          fill="#e4e4e4"
        />
        <path
          id="bc9696ec-ec99-41d5-9116-3ad9737a38ac-3215"
          dataName="Path 143"
          d="M543.84146,494.63687a3.41054,3.41054,0,0,0,0,6.82106H803.13254a3.41054,3.41054,0,0,0,0-6.82106Z"
          transform="translate(-259.58071 -157.88396)"
          fill="#e4e4e4"
        />
        <path
          d="M599.41943,324.82812a49,49,0,1,1,48.99952-49A49.05567,49.05567,0,0,1,599.41943,324.82812Z"
          transform="translate(-259.58071 -157.88396)"
          fill="#6c63ff"
        />
        <path
          d="M450.67833,510.10041a12.24754,12.24754,0,0,0-14.953-11.36231l-16.19641-22.82521-16.27138,6.45945,23.32519,31.91237a12.31392,12.31392,0,0,0,24.09559-4.1843Z"
          transform="translate(-259.58071 -157.88396)"
          fill="#a0616a"
        />
        <path
          d="M419.11211,508.40888l-49.00774-63.57777L388.46714,387.12c1.34563-14.50936,10.425-18.56089,10.81135-18.72645l.5893-.25281,15.979,42.6119-11.73235,31.28625,28.79671,48.4319Z"
          transform="translate(-259.58071 -157.88396)"
          fill="#3f3d56"
        />
        <path
          d="M589.30794,312.41993a12.24758,12.24758,0,0,0-10.17219,15.78672l-21.50463,17.91269,7.69816,15.72326,30.01343-25.72272a12.31392,12.31392,0,0,0-6.03477-23.69995Z"
          transform="translate(-259.58071 -157.88396)"
          fill="#a0616a"
        />
        <path
          d="M590.06206,344.02244l-59.59835,53.77665-58.95815-13.84578c-14.57-.21979-19.31136-8.9587-19.50629-9.33113l-.29761-.568,41.2489-19.22578,32.0997,9.27828,46.06046-32.45509Z"
          transform="translate(-259.58071 -157.88396)"
          fill="#3f3d56"
        />
        <polygon
          points="227.248 568.437 243.261 568.436 250.878 506.672 227.245 506.673 227.248 568.437"
          fill="#a0616a"
        />
        <path
          d="M483.39733,721.74476h50.32614a0,0,0,0,1,0,0V741.189a0,0,0,0,1,0,0h-36.207a14.11914,14.11914,0,0,1-14.11914-14.11914v-5.32505A0,0,0,0,1,483.39733,721.74476Z"
          transform="translate(757.57348 1305.02654) rotate(179.99738)"
          fill="#2f2e41"
        />
        <polygon
          points="163.247 568.437 179.26 568.436 186.878 506.672 163.245 506.673 163.247 568.437"
          fill="#a0616a"
        />
        <path
          d="M419.397,721.74476H469.7231a0,0,0,0,1,0,0V741.189a0,0,0,0,1,0,0h-36.207A14.11914,14.11914,0,0,1,419.397,727.06981v-5.32505a0,0,0,0,1,0,0Z"
          transform="translate(629.57273 1305.02946) rotate(179.99738)"
          fill="#2f2e41"
        />
        <polygon
          points="157.552 342.991 158.858 434.42 160.165 554.584 188.899 551.972 203.267 386.094 221.553 551.972 251.218 551.972 254.206 384.788 243.757 348.216 157.552 342.991"
          fill="#2f2e41"
        />
        <path
          d="M473.37417,513.1531c-31.26533.00239-60.04471-14.14839-60.43319-14.34263l-.32273-.16136-2.62373-62.96637c-.76082-2.22509-15.74263-46.13091-18.28-60.08625-2.57083-14.13882,34.68842-26.54742,39.213-27.99853l1.02678-11.37405,41.75366-4.49918,5.292,14.5536,14.97942,5.6168a7.40924,7.40924,0,0,1,4.59212,8.7043l-8.32539,33.85619,20.33325,112.01266-4.37755.18946C495.709,511.39658,484.38425,513.1525,473.37417,513.1531Z"
          transform="translate(-259.58071 -157.88396)"
          fill="#3f3d56"
        />
        <circle
          cx="454.46738"
          cy="294.45965"
          r="30.06284"
          transform="matrix(0.87745, -0.47966, 0.47966, 0.87745, -345.12824, 96.19037)"
          fill="#a0616a"
        />
        <path
          d="M430.1166,323.56132c5.72926,6.10289,16.36927,2.82672,17.1158-5.51069a10.07153,10.07153,0,0,0-.01268-1.94523c-.38544-3.69311-2.519-7.046-2.008-10.94542a5.73974,5.73974,0,0,1,1.05046-2.687c4.56548-6.11359,15.28263,2.73444,19.59138-2.8,2.642-3.39359-.46364-8.73664,1.56381-12.52956,2.67591-5.006,10.60183-2.53654,15.57222-5.27809,5.53017-3.05032,5.1994-11.53517,1.55907-16.6961-4.43955-6.294-12.22348-9.65241-19.91044-10.13643s-15.32094,1.59394-22.4974,4.39069c-8.15392,3.17767-16.23969,7.56925-21.25749,14.739-6.10218,8.71919-6.68942,20.44132-3.6376,30.63677C419.10222,311.0013,425.43805,318.57766,430.1166,323.56132Z"
          transform="translate(-259.58071 -157.88396)"
          fill="#2f2e41"
        />
        <path
          d="M641.58071,741.9626h-381a1,1,0,0,1,0-2h381a1,1,0,0,1,0,2Z"
          transform="translate(-259.58071 -157.88396)"
          fill="#cacaca"
        />
        <path
          d="M596.58984,294.33545a3.488,3.488,0,0,1-2.38134-.93555l-16.15723-15.00732a3.49994,3.49994,0,0,1,4.76367-5.12891l13.68555,12.71192,27.07666-27.07618a3.5,3.5,0,1,1,4.94922,4.9502l-29.46094,29.46094A3.49275,3.49275,0,0,1,596.58984,294.33545Z"
          transform="translate(-259.58071 -157.88396)"
          fill="#fff"
        />
      </svg>
    );
  }
  if (name === "ilustKYCFillProfile") {
    return (
      <svg
        className={classname}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 883.39724 517.98652"
        role="img"
        artist="Katerina Limpitsouni"
        source="https://undraw.co/"
      >
        <path
          d="M1025.19862,628.55459H384.36012a16.51867,16.51867,0,0,1-16.5-16.5V216.90078A12.10185,12.10185,0,0,1,379.948,204.8124H1029.4015a12.31112,12.31112,0,0,1,12.29712,12.29737V612.05459A16.51868,16.51868,0,0,1,1025.19862,628.55459Z"
          transform="translate(-158.30138 -191.00674)"
          fill="#f2f2f2"
        />
        <path
          d="M1001.82133,605.18776H404.57658c-8.755,0-15.87756-6.66992-15.87756-14.86817v-344.105c0-6.08008,5.27795-11.02685,11.76562-11.02685h605.27368c6.59522,0,11.9607,5.02832,11.9607,11.20849V590.31959C1017.699,598.51784,1010.57622,605.18776,1001.82133,605.18776Z"
          transform="translate(-158.30138 -191.00674)"
          fill="#fff"
        />
        <path
          d="M1041.46888,215.95693H367.62855v-8.40039a16.57376,16.57376,0,0,1,16.56006-16.5498h640.72021a16.57368,16.57368,0,0,1,16.56006,16.5498Z"
          transform="translate(-158.30138 -191.00674)"
          fill="#ccc"
        />
        <circle cx="239.42253" cy="12.5" r="4.28342" fill="#fff" />
        <circle cx="255.68134" cy="12.5" r="4.28342" fill="#fff" />
        <circle cx="271.94014" cy="12.5" r="4.28342" fill="#fff" />
        <path
          d="M499.90173,541.18719H351.06323a17.5199,17.5199,0,0,1-17.5-17.5V347.53338A13.10308,13.10308,0,0,1,346.65112,334.445H504.10461a13.31242,13.31242,0,0,1,13.29712,13.29737V523.68719A17.51982,17.51982,0,0,1,499.90173,541.18719Z"
          transform="translate(-158.30138 -191.00674)"
          fill="#fff"
        />
        <path
          d="M499.90173,541.18719H351.06323a17.5199,17.5199,0,0,1-17.5-17.5V347.53338A13.10308,13.10308,0,0,1,346.65112,334.445H504.10461a13.31242,13.31242,0,0,1,13.29712,13.29737V523.68719A17.51982,17.51982,0,0,1,499.90173,541.18719ZM346.65112,336.445a11.10062,11.10062,0,0,0-11.08789,11.08838V523.68719a15.51744,15.51744,0,0,0,15.5,15.5h148.8385a15.51752,15.51752,0,0,0,15.5-15.5V347.74237A11.31,11.31,0,0,0,504.10461,336.445Z"
          transform="translate(-158.30138 -191.00674)"
          fill="#3f3d56"
        />
        <circle cx="267.1811" cy="225.33418" r="30.72361" fill="#6c63ff" />
        <path
          d="M474.703,490.01488H376.262v-.31351a34.21088,34.21088,0,0,1,34.17218-34.17217h30.09659A34.21089,34.21089,0,0,1,474.703,489.70137Z"
          transform="translate(-158.30138 -191.00674)"
          fill="#6c63ff"
        />
        <path
          d="M339.65689,474.39632a10.05577,10.05577,0,0,1-14.16116-6.10061l-35.70082-1.55895,10.8896-15.04162,32.23261,3.78644a10.11028,10.11028,0,0,1,6.73977,18.91474Z"
          transform="translate(-158.30138 -191.00674)"
          fill="#ffb8b8"
        />
        <path
          d="M240.5384,460.14316l-19.63257-37.811a31.3182,31.3182,0,0,1,2.564-33.03857c.69946-.9336,1.44165-1.8418,2.20605-2.69874A30.39792,30.39792,0,0,1,250.75324,376.504a31.40231,31.40231,0,0,1,24.11206,14.08106l9.42823,14.252c.96508.86182,13.94287,12.8374,9.11523,28.42041l-.83008,14.94287a4.52344,4.52344,0,0,1-3.4751,4.1333l-43.553,10.11866a4.49435,4.49435,0,0,1-5.01221-2.30909Z"
          transform="translate(-158.30138 -191.00674)"
          fill="#6c63ff"
        />
        <path
          d="M226.76908,531.89964a10.05577,10.05577,0,0,1,1.56841-15.33935L219.108,482.0379l17.61677,5.87226,6.06366,31.88276a10.11027,10.11027,0,0,1-16.01932,12.10672Z"
          transform="translate(-158.30138 -191.00674)"
          fill="#ffb8b8"
        />
        <path
          d="M222.442,515.56553a4.4626,4.4626,0,0,1-2.46118-3.31592l-6.07739-58.96a50.33629,50.33629,0,0,1-.35889-14.48975l7.28516-44.11865a10.06808,10.06808,0,0,1,10.7334-8.86182h0a10.08789,10.08789,0,0,1,9.301,11.23975L234.91633,447.669l6.81128,59.69141a4.47622,4.47622,0,0,1-2.34937,4.47852l-12.88452,3.67968a4.44955,4.44955,0,0,1-4.05176.04688Z"
          transform="translate(-158.30138 -191.00674)"
          fill="#6c63ff"
        />
        <polygon
          points="161.751 504.359 173.796 502.075 170.717 454.528 152.94 457.9 161.751 504.359"
          fill="#ffb8b8"
        />
        <path
          d="M316.23434,692.016l23.721-4.49868.001-.00018a15.386,15.386,0,0,1,17.98342,12.25056l.09314.49125-38.83826,7.36553Z"
          transform="translate(-158.30138 -191.00674)"
          fill="#2f2e41"
        />
        <polygon
          points="55.162 504.734 67.422 504.733 73.254 457.445 55.16 457.446 55.162 504.734"
          fill="#ffb8b8"
        />
        <path
          d="M210.33626,691.73774l24.1438-.001h.001A15.38605,15.38605,0,0,1,249.86751,707.123v.5l-39.53052.00146Z"
          transform="translate(-158.30138 -191.00674)"
          fill="#2f2e41"
        />
        <circle cx="91.03279" cy="150.33062" r="24.56103" fill="#ffb8b8" />
        <path
          d="M211.44489,676.73545a4.52272,4.52272,0,0,1-1.19507-3.4043l16.71753-151.751c-.14379-1.4209-2.4143-27.1875,16.009-60.15625l.1018-.18213,49.36792-13.68994,5.45874,23.02636,36.58277,200.21094a4.486,4.486,0,0,1-3.80542,4.94336l-12.7334,1.91016a4.50191,4.50191,0,0,1-4.98608-3.18457L269.8509,539.42881a1.50036,1.50036,0,0,0-2.87769-.01367L231.60505,674.92393a4.52284,4.52284,0,0,1-4.32153,3.24414H214.73689A4.51522,4.51522,0,0,1,211.44489,676.73545Z"
          transform="translate(-158.30138 -191.00674)"
          fill="#2f2e41"
        />
        <path
          d="M315.78278,471.6627l-53.19238-9.12061A17.40944,17.40944,0,0,1,248.42829,448.92l-11.10693-52.4585a14.30958,14.30958,0,0,1,13.41284-17.26171h0a14.38357,14.38357,0,0,1,14.79614,12.604l5.574,46.7583,46.9248,12.19238a4.49882,4.49882,0,0,1,3.03418,4.26514l-.02,12.21924a4.49624,4.49624,0,0,1-5.2605,4.42383Z"
          transform="translate(-158.30138 -191.00674)"
          fill="#6c63ff"
        />
        <path
          d="M270.22711,335.63581c3.90962-.80832,7.711-3.40948,8.7554-7.26275.91236-3.36611-.43741-6.99535-2.55031-9.77a19.73745,19.73745,0,0,0-23.64558-5.57725c.37737-1.98479-1.11552-3.94291-2.95263-4.78364a13.75273,13.75273,0,0,0-5.95486-.79972c-6.38994.08932-13.193.30274-18.47651,3.89776-4.21305,2.86667-6.88794,7.58032-8.27374,12.48409s-1.61217,10.04939-1.8301,15.14056c-.38195,8.92283,3.11413,27.70321,3.11413,27.70321s12.36326,3.39891,17.7795,4.97366c5.82024,1.69221,15.64048,3.38443,21.46072,5.07664,1.48969.43312,3.4846.67631,4.23322-.68249.59765-1.08479-.09354-2.4061-.78855-3.43124-3.06038-4.514-6.56636-8.77139-8.92068-13.69069s-3.456-10.76465-1.43463-15.82988S266.3175,336.44412,270.22711,335.63581Z"
          transform="translate(-158.30138 -191.00674)"
          fill="#2f2e41"
        />
        <path
          d="M655.86638,508.46168h319.8385a16,16,0,0,0,16-16V347.91383a16,16,0,0,0-16-16H655.86638a16,16,0,0,0-16,16V492.46168A16,16,0,0,0,655.86638,508.46168Z"
          transform="translate(-158.30138 -191.00674)"
          fill="#f2f2f2"
        />
        <path
          d="M940.78569,428.18776h-255a8,8,0,1,1,0-16h255a8,8,0,0,1,0,16Z"
          transform="translate(-158.30138 -191.00674)"
          fill="#fff"
        />
        <path
          d="M940.78569,462.18776h-255a8,8,0,1,1,0-16h255a8,8,0,0,1,0,16Z"
          transform="translate(-158.30138 -191.00674)"
          fill="#fff"
        />
        <path
          d="M895.78569,394.18776h-210a8,8,0,1,1,0-16h210a8,8,0,0,1,0,16Z"
          transform="translate(-158.30138 -191.00674)"
          fill="#fff"
        />
        <path
          d="M398.30138,708.99326h-239a1,1,0,0,1,0-2h239a1,1,0,1,1,0,2Z"
          transform="translate(-158.30138 -191.00674)"
          fill="#ccc"
        />
      </svg>
    );
  }
  if (name === "ilustKYCProcess") {
    return (
      <svg
        className={classname}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 649.3779 727.77798"
        role="img"
        artist="Katerina Limpitsouni"
        source="https://undraw.co/"
      >
        <path
          d="M648.20033,259.05824h-3.99878V149.51291A63.40187,63.40187,0,0,0,580.79976,86.111H348.713a63.40184,63.40184,0,0,0-63.402,63.4017V750.48713A63.40181,63.40181,0,0,0,348.71284,813.889H580.79945a63.40185,63.40185,0,0,0,63.402-63.40167V337.0345h3.99884Z"
          transform="translate(-285.31105 -86.11101)"
          fill="#e6e6e6"
        />
        <path
          d="M583.3578,102.606h-30.295a22.49485,22.49485,0,0,1-20.82715,30.99053H399.2762a22.49484,22.49484,0,0,1-20.82715-30.99061H350.15346a47.34781,47.34781,0,0,0-47.34784,47.34774V750.04628a47.34781,47.34781,0,0,0,47.34777,47.34784H583.3578a47.34781,47.34781,0,0,0,47.34784-47.34778h0V149.95371A47.34777,47.34777,0,0,0,583.3578,102.606Z"
          transform="translate(-285.31105 -86.11101)"
          fill="#fff"
        />
        <path
          id="f3818c68-126c-4685-b4e0-2450731ccc2a-4346"
          dataName="a2804879-ded6-4045-b20f-1f1dde9b938b"
          d="M611.46248,573.92982h-279.619a5.184,5.184,0,0,1-5.178-5.178v-69.361a5.184,5.184,0,0,1,5.178-5.178h279.619a5.184,5.184,0,0,1,5.178,5.178v69.362A5.184,5.184,0,0,1,611.46248,573.92982Zm-279.619-77.646a3.11,3.11,0,0,0-3.107,3.107v69.362a3.11,3.11,0,0,0,3.107,3.107h279.619a3.11,3.11,0,0,0,3.107-3.107v-69.362a3.11,3.11,0,0,0-3.107-3.107Z"
          transform="translate(-285.31105 -86.11101)"
          fill="#e6e6e6"
        />
        <circle
          id="abdb74b7-e321-430b-89c2-b563f66442fc"
          dataName="b9ad11c9-d8a0-4df6-8741-900b9ec46a35"
          cx="82.77841"
          cy="447.95985"
          r="21.74799"
          fill="#e6e6e6"
        />
        <path
          id="addd02b1-b85b-481a-baea-1b0ba5ed9f4a-4347"
          dataName="bd261eec-7ae0-49b0-bf26-57ff03972605"
          d="M418.31746,519.57286a3.625,3.625,0,0,0,0,7.249h170.878a3.625,3.625,0,0,0,.13989-7.24866l-.02087-.00033q-.05943-.001-.119,0Z"
          transform="translate(-285.31105 -86.11101)"
          fill="#e6e6e6"
        />
        <path
          id="a42dc2a4-5fb2-4ea8-b2b3-ce81bc256782-4348"
          dataName="e80b4447-8c34-435b-ba6c-5300a190ab24"
          d="M418.31746,541.32087a3.625,3.625,0,0,0,0,7.249h170.878a3.625,3.625,0,0,0,.119-7.249q-.05943-.00092-.119,0Z"
          transform="translate(-285.31105 -86.11101)"
          fill="#e6e6e6"
        />
        <path
          id="b84687c4-e3b4-4975-8361-bf73c33c9ee5-4349"
          dataName="e55fcb7d-3a3b-45d8-b167-72fb2263dd92"
          d="M611.46248,689.91981h-279.619a5.184,5.184,0,0,1-5.178-5.178v-69.361a5.184,5.184,0,0,1,5.178-5.178h279.619a5.184,5.184,0,0,1,5.178,5.178v69.362A5.184,5.184,0,0,1,611.46248,689.91981Zm-279.619-77.646a3.11,3.11,0,0,0-3.107,3.107v69.362a3.11,3.11,0,0,0,3.107,3.107h279.619a3.11,3.11,0,0,0,3.107-3.107v-69.362a3.11,3.11,0,0,0-3.107-3.107Z"
          transform="translate(-285.31105 -86.11101)"
          fill="#e6e6e6"
        />
        <circle
          id="fe3713e7-4e14-41f8-af1d-48b338e5371c"
          dataName="a50d232f-7710-43e4-8fa9-6ef0443fc454"
          cx="82.77841"
          cy="563.94987"
          r="21.74799"
          fill="#e6e6e6"
        />
        <path
          id="e34cf46a-1d6c-4c41-b5e1-331fa5bf8d4c-4350"
          dataName="e49b4965-a9e9-4371-9134-194e44e65c31"
          d="M418.31746,635.56288a3.625,3.625,0,0,0,0,7.249h170.878a3.625,3.625,0,0,0,.119-7.249q-.05943-.001-.119,0Z"
          transform="translate(-285.31105 -86.11101)"
          fill="#e6e6e6"
        />
        <path
          id="e105039f-b7a6-49c8-8f81-87505f1b0ae5-4351"
          dataName="abc4586a-ac92-4255-aae6-84f53baad571"
          d="M418.31746,657.31086a3.625,3.625,0,0,0,0,7.249h170.878a3.625,3.625,0,0,0,.119-7.249q-.05943-.00092-.119,0Z"
          transform="translate(-285.31105 -86.11101)"
          fill="#e6e6e6"
        />
        <path
          id="ad9187ec-89e0-4b9d-a4fb-dc654c09bafe-4352"
          dataName="a9e593af-a319-4e97-9065-f0c2c04624d5"
          d="M465.76845,429.99485a98.343,98.343,0,0,1-98.384-98.30194v-.08206c0-.206,0-.423.012-.629.3-53.879,44.432-97.756,98.372-97.756a98.384,98.384,0,0,1,.0224,196.768h-.0224Zm0-194.7a96.519,96.519,0,0,0-96.3,95.749c-.011.22-.011.4-.011.564a96.325,96.325,0,1,0,96.337-96.313h-.026Z"
          transform="translate(-285.31105 -86.11101)"
          fill="#e6e6e6"
        />
        <circle cx="315.11393" cy="422.84174" r="40" fill="#fff" />
        <path
          d="M586.53265,526.94884c-.06861,0-.13721-.00049-.20606-.00195h-21.5a10.39761,10.39761,0,0,1-.0083-20.79248h21.51807c.10547-.00195.22021-.00195.334,0a10.39771,10.39771,0,0,1-.13769,20.79443Z"
          transform="translate(-285.31105 -86.11101)"
          fill="#6c63ff"
        />
        <rect
          x="325.3453"
          y="725.34374"
          width="324.03261"
          height="2.24072"
          fill="#3f3d56"
        />
        <path
          d="M630.6207,621.842a6.56111,6.56111,0,0,1-.62973-1.259l-5.16339-13.82657a6.50779,6.50779,0,0,1,3.81532-8.36324l115.24228-43.03187a6.50621,6.50621,0,0,1,8.363,3.81491l5.16283,13.82751a6.49951,6.49951,0,0,1-3.81558,8.36283l-115.2412,43.03174a6.5067,6.5067,0,0,1-7.73351-2.55634Z"
          transform="translate(-285.31105 -86.11101)"
          fill="#6c63ff"
        />
        <path
          d="M743.51834,551.78826l-46.86323,18.68723a6,6,0,0,0-4.093,7.1996l5.43852,21.77515a6,6,0,0,0,8.37642,3.97481l46.99241-22.1188a6.0109,6.0109,0,0,0,3.52446-7.717l-5.64883-18.27558A6.01072,6.01072,0,0,0,743.51834,551.78826Z"
          transform="translate(-285.31105 -86.11101)"
          fill="#2f2e41"
        />
        <path
          d="M829.28044,687.45a6.50671,6.50671,0,0,1-6.89226-4.34039l-40.114-116.289a6.49951,6.49951,0,0,1,4.02482-8.26416l13.95295-4.81352a6.50408,6.50408,0,0,1,8.26373,4.02536l40.11465,116.2899a6.50779,6.50779,0,0,1-4.02531,8.26422l-13.95257,4.8125A6.56115,6.56115,0,0,1,829.28044,687.45Z"
          transform="translate(-285.31105 -86.11101)"
          fill="#6c63ff"
        />
        <path
          d="M811.5058,555.77814l15.39577,48.04524a6,6,0,0,1-2.95088,7.73816l-20.26024,9.657a6,6,0,0,1-8.39566-3.934l-12.83035-50.328a6.0109,6.0109,0,0,1,3.71178-7.62871l17.694-7.26835A6.01071,6.01071,0,0,1,811.5058,555.77814Z"
          transform="translate(-285.31105 -86.11101)"
          fill="#2f2e41"
        />
        <path
          d="M764.89068,812.11413H750.13141a6.50753,6.50753,0,0,1-6.5-6.5V682.59948a6.50753,6.50753,0,0,1,6.5-6.5h14.75927a6.50753,6.50753,0,0,1,6.5,6.5V805.61413A6.50753,6.50753,0,0,1,764.89068,812.11413Z"
          transform="translate(-285.31105 -86.11101)"
          fill="#2f2e41"
        />
        <path
          d="M794.08307,812.11413H779.3233a6.50753,6.50753,0,0,1-6.5-6.5V682.59948a6.50753,6.50753,0,0,1,6.5-6.5h14.75977a6.50753,6.50753,0,0,1,6.5,6.5V805.61413A6.50753,6.50753,0,0,1,794.08307,812.11413Z"
          transform="translate(-285.31105 -86.11101)"
          fill="#2f2e41"
        />
        <path
          d="M806.2467,697.06158H739.1842a7.00787,7.00787,0,0,1-7-7V581.11725a40.53125,40.53125,0,0,1,81.0625,0V690.06158A7.00786,7.00786,0,0,1,806.2467,697.06158Z"
          transform="translate(-285.31105 -86.11101)"
          fill="#ccc"
        />
        <path
          d="M816.34118,723.711h-34V531.55621l.6316.17236a45.38181,45.38181,0,0,1,33.3684,43.6875Z"
          transform="translate(-285.31105 -86.11101)"
          fill="#2f2e41"
        />
        <path
          d="M760.32629,723.711h-34V575.41607a45.38226,45.38226,0,0,1,33.36841-43.6875l.63159-.17236Z"
          transform="translate(-285.31105 -86.11101)"
          fill="#2f2e41"
        />
        <circle cx="486.89704" cy="378.42061" r="53.51916" fill="#6c63ff" />
        <path
          d="M832.71545,452.21s3-83-36-56c0,0-22.5-75.5-77.5,37.5l-16,16s72-10,139,21Z"
          transform="translate(-285.31105 -86.11101)"
          fill="#2f2e41"
        />
        <path
          d="M773.02436,491.03636c-3.30591-.09179-7.42029-.20654-10.59-2.522a8.13272,8.13272,0,0,1-3.20008-6.07275,5.47091,5.47091,0,0,1,1.86035-4.49317c1.65552-1.39892,4.073-1.727,6.67823-.96142l-2.69922-19.72559,1.98144-.27148,3.17322,23.18994-1.65466-.75928c-1.91834-.87988-4.55164-1.32764-6.188.05518a3.51513,3.51513,0,0,0-1.15271,2.8955,6.14685,6.14685,0,0,0,2.38123,4.52783c2.46667,1.80176,5.74621,2.03418,9.46582,2.13819Z"
          transform="translate(-285.31105 -86.11101)"
          fill="#2f2e41"
        />
        <rect
          x="459.19183"
          y="372.85162"
          width="10.77161"
          height="2"
          fill="#2f2e41"
        />
        <rect
          x="493.19183"
          y="372.85162"
          width="10.77161"
          height="2"
          fill="#2f2e41"
        />
        <path
          d="M652.88209,626.94393a6.00014,6.00014,0,0,1-7.96794-2.91753l-34.511-74.38406a6,6,0,0,1,10.88547-5.0504l34.511,74.38406A6.00012,6.00012,0,0,1,652.88209,626.94393Z"
          transform="translate(-285.31105 -86.11101)"
          fill="#3f3d56"
        />
        <path
          d="M617.425,546.90538a4,4,0,0,1-4-4V491.95275h-50a4,4,0,0,1,0-8h54a4,4,0,0,1,4,4v54.95263A4,4,0,0,1,617.425,546.90538Z"
          transform="translate(-285.31105 -86.11101)"
          fill="#6c63ff"
        />
        <path
          d="M618.371,552.55988a48,48,0,1,1,23.34031-63.74348A48.05437,48.05437,0,0,1,618.371,552.55988Zm-35.35277-76.19831a36,36,0,1,0,47.80761,17.50523A36.04072,36.04072,0,0,0,583.01827,476.36157Z"
          transform="translate(-285.31105 -86.11101)"
          fill="#3f3d56"
        />
      </svg>
    );
  }
  if (name === "noAccount") {
    return (
      <svg
        className={classname}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 567.1704 517.30967"
        role="img"
        artist="Katerina Limpitsouni"
        source="https://undraw.co/"
      >
        <rect
          x="326.03543"
          y="307.38928"
          width="495"
          height="45"
          transform="translate(-385.45426 -17.88532) rotate(-16.24392)"
          fill="#2878A3"
        />
        <path
          d="M386.40028,575.96948,316.35377,335.55639a7.0001,7.0001,0,0,1,4.76257-8.67871L784.8346,191.76928a7.00645,7.00645,0,0,1,8.67871,4.76221l62.05591,212.98877-1.92016.55957L791.59315,197.09106a5.00865,5.00865,0,0,0-6.19922-3.40186L321.67579,328.7976a5.00029,5.00029,0,0,0-3.40186,6.19922l70.04651,240.41309Z"
          transform="translate(-316.07106 -191.48811)"
          fill="#2878A3"
        />
        <path
          d="M752.93324,410.51a6.51233,6.51233,0,0,1-6.24341-4.6831l-11.74854-40.32324a6.50734,6.50734,0,0,1,4.42212-8.0586l40.32349-11.74853a6.50722,6.50722,0,0,1,8.05859,4.42285L799.494,390.44262a6.50733,6.50733,0,0,1-4.42212,8.05859l-40.32349,11.74854A6.47854,6.47854,0,0,1,752.93324,410.51Z"
          transform="translate(-316.07106 -191.48811)"
          fill="#6c63ff"
        />
        <path
          d="M385.31751,336.3a11.691,11.691,0,0,0-.43017-1.22,11.99972,11.99972,0,0,0-22.90967,6.67,11.37989,11.37989,0,0,0,.29,1.26,12.01924,12.01924,0,0,0,11.52978,8.64,11.74908,11.74908,0,0,0,3.3501-.48A12.01262,12.01262,0,0,0,385.31751,336.3Zm-8.73,12.95a10.01322,10.01322,0,0,1-12.3999-6.8,11.435,11.435,0,0,1-.28027-1.26,9.99681,9.99681,0,0,1,19.04-5.54,8.33837,8.33837,0,0,1,.45019,1.21A10.00446,10.00446,0,0,1,376.58753,349.25006Z"
          transform="translate(-316.07106 -191.48811)"
          fill="#6c63ff"
        />
        <path
          d="M355.88508,344.87a11.00221,11.00221,0,0,1,4.20834-12.0571,11,11,0,1,0,5.81753,19.96694A11.00221,11.00221,0,0,1,355.88508,344.87Z"
          transform="translate(-316.07106 -191.48811)"
          fill="#6c63ff"
        />
        <path
          d="M666.7472,394.43005a6.04249,6.04249,0,0,0-7.44971-4.2L592.90736,408.8l-7.14991,2h44.89991l7.1499-2,24.75-6.92A6.04864,6.04864,0,0,0,666.7472,394.43005Z"
          transform="translate(-316.07106 -191.48811)"
          fill="#ccc"
        />
        <path
          d="M619.77747,380.56005a6.04513,6.04513,0,0,0-7.45019-4.19l-99.61963,27.86a6.06838,6.06838,0,0,0-4.37012,6.57h25.79l7.15967-2,74.30029-20.78A6.05544,6.05544,0,0,0,619.77747,380.56005Z"
          transform="translate(-316.07106 -191.48811)"
          fill="#ccc"
        />
        <path
          d="M876.24147,408.79777H393.241a7.00787,7.00787,0,0,0-7,7v286a7.00755,7.00755,0,0,0,7,7H876.24147a7.00786,7.00786,0,0,0,7-7v-286A7.00818,7.00818,0,0,0,876.24147,408.79777Zm5,293a5.00181,5.00181,0,0,1-5,5H393.241a5.0018,5.0018,0,0,1-5-5v-286a5.00213,5.00213,0,0,1,5-5H876.24147a5.00213,5.00213,0,0,1,5,5Z"
          transform="translate(-316.07106 -191.48811)"
          fill="#2878A3"
        />
        <path
          d="M440.23744,447.8a12,12,0,1,1,12-12A12.01375,12.01375,0,0,1,440.23744,447.8Zm0-22a10,10,0,1,0,10,10A10.0113,10.0113,0,0,0,440.23744,425.8Z"
          transform="translate(-316.07106 -191.48811)"
          fill="#6c63ff"
        />
        <path
          d="M421.58526,435.8a11.00221,11.00221,0,0,1,7.413-10.39858,11,11,0,1,0,0,20.79717A11.00222,11.00222,0,0,1,421.58526,435.8Z"
          transform="translate(-316.07106 -191.48811)"
          fill="#6c63ff"
        />
        <path
          d="M488.88112,577.57805a9.01031,9.01031,0,0,1-9-9v-27a9,9,0,0,1,18,0v27A9.01032,9.01032,0,0,1,488.88112,577.57805Z"
          transform="translate(-316.07106 -191.48811)"
          fill="#6c63ff"
        />
        <path
          d="M512.88112,577.57805a9.01031,9.01031,0,0,1-9-9v-27a9,9,0,0,1,18,0v27A9.01032,9.01032,0,0,1,512.88112,577.57805Z"
          transform="translate(-316.07106 -191.48811)"
          fill="#6c63ff"
        />
        <path
          d="M536.88112,577.57805a9.01031,9.01031,0,0,1-9-9v-27a9,9,0,0,1,18,0v27A9.01032,9.01032,0,0,1,536.88112,577.57805Z"
          transform="translate(-316.07106 -191.48811)"
          fill="#6c63ff"
        />
        <path
          d="M573.88112,577.57805a9.01031,9.01031,0,0,1-9-9v-27a9,9,0,0,1,18,0v27A9.01032,9.01032,0,0,1,573.88112,577.57805Z"
          transform="translate(-316.07106 -191.48811)"
          fill="#6c63ff"
        />
        <path
          d="M597.88112,577.57805a9.01031,9.01031,0,0,1-9-9v-27a9,9,0,0,1,18,0v27A9.01032,9.01032,0,0,1,597.88112,577.57805Z"
          transform="translate(-316.07106 -191.48811)"
          fill="#6c63ff"
        />
        <path
          d="M621.88112,577.57805a9.01031,9.01031,0,0,1-9-9v-27a9,9,0,0,1,18,0v27A9.01032,9.01032,0,0,1,621.88112,577.57805Z"
          transform="translate(-316.07106 -191.48811)"
          fill="#6c63ff"
        />
        <path
          d="M658.88112,577.57805a9.01031,9.01031,0,0,1-9-9v-27a9,9,0,0,1,18,0v27A9.01032,9.01032,0,0,1,658.88112,577.57805Z"
          transform="translate(-316.07106 -191.48811)"
          fill="#6c63ff"
        />
        <path
          d="M682.88112,577.57805a9.01031,9.01031,0,0,1-9-9v-27a9,9,0,0,1,18,0v27A9.01032,9.01032,0,0,1,682.88112,577.57805Z"
          transform="translate(-316.07106 -191.48811)"
          fill="#6c63ff"
        />
        <path
          d="M706.88112,577.57805a9.01031,9.01031,0,0,1-9-9v-27a9,9,0,0,1,18,0v27A9.01032,9.01032,0,0,1,706.88112,577.57805Z"
          transform="translate(-316.07106 -191.48811)"
          fill="#6c63ff"
        />
        <path
          d="M743.88112,577.57805a9.01031,9.01031,0,0,1-9-9v-27a9,9,0,0,1,18,0v27A9.01032,9.01032,0,0,1,743.88112,577.57805Z"
          transform="translate(-316.07106 -191.48811)"
          fill="#6c63ff"
        />
        <path
          d="M767.88112,577.57805a9.01031,9.01031,0,0,1-9-9v-27a9,9,0,0,1,18,0v27A9.01032,9.01032,0,0,1,767.88112,577.57805Z"
          transform="translate(-316.07106 -191.48811)"
          fill="#6c63ff"
        />
        <path
          d="M791.88112,577.57805a9.01031,9.01031,0,0,1-9-9v-27a9,9,0,0,1,18,0v27A9.01032,9.01032,0,0,1,791.88112,577.57805Z"
          transform="translate(-316.07106 -191.48811)"
          fill="#6c63ff"
        />
        <path
          d="M549.89914,677.745H420.45883a6.04736,6.04736,0,1,1,0-12.09472H549.89914a6.04736,6.04736,0,1,1,0,12.09472Z"
          transform="translate(-316.07106 -191.48811)"
          fill="#e6e6e6"
        />
        <path
          d="M508.39914,651.745H461.95883a6.04736,6.04736,0,1,1,0-12.09472h46.44031a6.04736,6.04736,0,1,1,0,12.09472Z"
          transform="translate(-316.07106 -191.48811)"
          fill="#e6e6e6"
        />
        <rect
          x="71.81005"
          y="277.08994"
          width="493"
          height="2"
          fill="#2878A3"
        />
      </svg>
    );
  }
  if (name === "noData") {
    return (
      <svg
        className={classname}
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 451.277 451.277"
        fill="#000000"
      >
        <g id="SVGRepo_bgCarrier" strokeWidth="0" />

        <g
          id="SVGRepo_tracerCarrier"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        <g id="SVGRepo_iconCarrier">
          {" "}
          <circle fill="#2a404f" cx="225.638" cy="225.638" r="225.638" />{" "}
          <path
            opacity="0.1"
            enableBackground="new"
            d="M352.857,183.414c-0.799-1.222-1.881-2.257-3.056-3.055l-28.254-28.207 l-0.376-0.424c-0.235-0.283-0.47-0.517-0.752-0.752c-2.069-1.928-4.889-3.104-7.945-3.104H198.046l-19.51-19.51l0,0.001 c-2.164-2.477-5.338-4.091-8.885-4.091h-61.492c-6.535,0-11.8,5.265-11.8,11.8v179.163c0,3.667,1.739,7.052,4.513,9.214 L227.7,451.244c106.335-0.957,195.049-75.443,217.849-175.091l-92.598-92.599L352.857,183.414z"
          />{" "}
          <path
            fill="#F6C358"
            d="M181.452,136.062L181.452,136.062c0-6.514-5.281-11.796-11.796-11.796h-61.505 c-6.514,0-11.796,5.281-11.796,11.796v179.152c0,6.514,5.281,11.796,11.796,11.796h204.314c6.514,0,11.796-5.281,11.796-11.796 V159.654c0-6.514-5.281-11.796-11.796-11.796H193.248C186.733,147.858,181.452,142.577,181.452,136.062z"
          />{" "}
          <path
            fill="#FCD462"
            d="M343.12,178.273H139.536c-5.41,0-10.126,3.68-11.442,8.927L96.715,312.345 c-1.867,7.447,3.764,14.665,11.441,14.665h203.584c5.41,0,10.126-3.68,11.442-8.927l31.379-125.146 C356.429,185.491,350.797,178.273,343.12,178.273z"
          />{" "}
          <path
            fill="#FFFFFF"
            d="M197.102,269.816h-65.035c-2.242,0-4.059,1.909-4.059,4.262v34.417c0,2.354,1.817,4.262,4.059,4.262 h65.035c2.242,0,4.06-1.908,4.06-4.262v-34.417C201.162,271.724,199.344,269.816,197.102,269.816z"
          />{" "}
          <g>
            {" "}
            <rect
              x="135.491"
              y="276.357"
              fill="#EBF0F3"
              width="58.184"
              height="4.7"
            />{" "}
            <rect
              x="135.491"
              y="288.922"
              fill="#EBF0F3"
              width="58.184"
              height="4.7"
            />{" "}
            <rect
              x="135.491"
              y="301.512"
              fill="#EBF0F3"
              width="58.184"
              height="4.7"
            />{" "}
          </g>{" "}
        </g>
      </svg>
    );
  }
  if (name === "trash") {
    return (
      <svg
        className={classname}
        width="800px"
        height="800px"
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M2.75 6.16667C2.75 5.70644 3.09538 5.33335 3.52143 5.33335L6.18567 5.3329C6.71502 5.31841 7.18202 4.95482 7.36214 4.41691C7.36688 4.40277 7.37232 4.38532 7.39185 4.32203L7.50665 3.94993C7.5769 3.72179 7.6381 3.52303 7.72375 3.34536C8.06209 2.64349 8.68808 2.1561 9.41147 2.03132C9.59457 1.99973 9.78848 1.99987 10.0111 2.00002H13.4891C13.7117 1.99987 13.9056 1.99973 14.0887 2.03132C14.8121 2.1561 15.4381 2.64349 15.7764 3.34536C15.8621 3.52303 15.9233 3.72179 15.9935 3.94993L16.1083 4.32203C16.1279 4.38532 16.1333 4.40277 16.138 4.41691C16.3182 4.95482 16.8778 5.31886 17.4071 5.33335H19.9786C20.4046 5.33335 20.75 5.70644 20.75 6.16667C20.75 6.62691 20.4046 7 19.9786 7H3.52143C3.09538 7 2.75 6.62691 2.75 6.16667Z" />
        <path d="M11.6068 21.9998H12.3937C15.1012 21.9998 16.4549 21.9998 17.3351 21.1366C18.2153 20.2734 18.3054 18.8575 18.4855 16.0256L18.745 11.945C18.8427 10.4085 18.8916 9.6402 18.45 9.15335C18.0084 8.6665 17.2628 8.6665 15.7714 8.6665H8.22905C6.73771 8.6665 5.99204 8.6665 5.55047 9.15335C5.10891 9.6402 5.15777 10.4085 5.25549 11.945L5.515 16.0256C5.6951 18.8575 5.78515 20.2734 6.66534 21.1366C7.54553 21.9998 8.89927 21.9998 11.6068 21.9998Z" />
      </svg>
    );
  }
  if (name === "calculator") {
    return (
      <svg
        className={classname}
        style={style}
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.21447 19.2855C3.67893 20.75 6.03595 20.75 10.75 20.75C15.464 20.75 17.8211 20.75 19.2855 19.2855C20.75 17.8211 20.75 15.464 20.75 10.75C20.75 6.03595 20.75 3.67893 19.2855 2.21447C17.8211 0.75 15.464 0.75 10.75 0.75C6.03595 0.75 3.67893 0.75 2.21447 2.21447C0.75 3.67893 0.75 6.03595 0.75 10.75C0.75 15.464 0.75 17.8211 2.21447 19.2855Z"
          strokeWidth="1.5"
        />
        <path
          opacity="0.5"
          d="M16.75 7.25H12.75M16.75 13.25H12.75M16.75 16.25H12.75M8.75 7.25001H6.75M6.75 7.25001H4.75M6.75 7.25001V5.25M6.75 7.25001V9.25002M8.25 13.25L6.75001 14.75M6.75001 14.75L5.25001 16.25M6.75001 14.75L5.25 13.25M6.75001 14.75L8.24999 16.25"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    );
  }
  if (name === "calendar") {
    return (
      <svg
        className={classname}
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.5 8.10019C0.5 5.08323 0.5 3.57476 1.43726 2.6375C2.37452 1.70026 3.88301 1.70026 6.9 1.70026H10.1C13.117 1.70026 14.6255 1.70026 15.5627 2.6375C16.5 3.57476 16.5 5.08323 16.5 8.10019V9.70018C16.5 12.7171 16.5 14.2257 15.5627 15.1628C14.6255 16.1001 13.117 16.1001 10.1 16.1001H6.9C3.88301 16.1001 2.37452 16.1001 1.43726 15.1628C0.5 14.2257 0.5 12.7171 0.5 9.70018V8.10019Z"
          fill="none"
        />
        <path
          opacity="0.5"
          d="M4.5 1.69999V0.5"
          fill="none"
          strokeLinecap="round"
        />
        <path
          opacity="0.5"
          d="M12.5 1.69999V0.5"
          fill="none"
          strokeLinecap="round"
        />
        <path
          opacity="0.5"
          d="M0.900391 5.70001H16.1004"
          fill="none"
          strokeLinecap="round"
        />
        <path
          d="M13.2992 12.0999C13.2992 12.5417 12.9411 12.8999 12.4992 12.8999C12.0574 12.8999 11.6992 12.5417 11.6992 12.0999C11.6992 11.658 12.0574 11.2999 12.4992 11.2999C12.9411 11.2999 13.2992 11.658 13.2992 12.0999Z"
          stroke="none"
        />
        <path
          d="M13.2992 8.90015C13.2992 9.34199 12.9411 9.70014 12.4992 9.70014C12.0574 9.70014 11.6992 9.34199 11.6992 8.90015C11.6992 8.45832 12.0574 8.10016 12.4992 8.10016C12.9411 8.10016 13.2992 8.45832 13.2992 8.90015Z"
          stroke="none"
        />
        <path
          d="M9.29922 12.0999C9.29922 12.5417 8.94106 12.8999 8.49922 12.8999C8.05738 12.8999 7.69922 12.5417 7.69922 12.0999C7.69922 11.658 8.05738 11.2999 8.49922 11.2999C8.94106 11.2999 9.29922 11.658 9.29922 12.0999Z"
          stroke="none"
        />
        <path
          d="M9.29922 8.90015C9.29922 9.34199 8.94106 9.70014 8.49922 9.70014C8.05738 9.70014 7.69922 9.34199 7.69922 8.90015C7.69922 8.45832 8.05738 8.10016 8.49922 8.10016C8.94106 8.10016 9.29922 8.45832 9.29922 8.90015Z"
          stroke="none"
        />
        <path
          d="M5.29922 12.0999C5.29922 12.5417 4.94104 12.8999 4.49922 12.8999C4.05739 12.8999 3.69922 12.5417 3.69922 12.0999C3.69922 11.658 4.05739 11.2999 4.49922 11.2999C4.94104 11.2999 5.29922 11.658 5.29922 12.0999Z"
          stroke="none"
        />
        <path
          d="M5.29922 8.90015C5.29922 9.34199 4.94104 9.70014 4.49922 9.70014C4.05739 9.70014 3.69922 9.34199 3.69922 8.90015C3.69922 8.45832 4.05739 8.10016 4.49922 8.10016C4.94104 8.10016 5.29922 8.45832 5.29922 8.90015Z"
          stroke="none"
        />
      </svg>
    );
  }
  if (name === "add") {
    return (
      <svg
        className={classname}
        width="10"
        height="10"
        viewBox="0 0 10 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 5H5M5 5H1M5 5V1M5 5V9"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    );
  }
  if (name === "arrowLong") {
    return (
      <svg
        className={classname}
        width="22"
        height="11"
        viewBox="0 0 22 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 5.49998H21M21 5.49998L16 1M21 5.49998L16 10"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  if (name === "send") {
    return (
      <svg
        className={classname}
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.03714 17.4036L2.97746 11.2245C1.17806 5.82641 0.27842 3.12737 1.70318 1.70265C3.12782 0.277937 5.82686 1.17761 11.2249 2.97697L17.4041 5.03669C21.7609 6.48895 23.9393 7.21508 24.5583 8.27989C25.1472 9.29285 25.1472 10.5439 24.5583 11.5569C23.9393 12.6218 21.7609 13.3479 17.4041 14.8001C16.7046 15.0333 16.3548 15.1499 16.0625 15.3456C15.7791 15.5352 15.5357 15.7787 15.3461 16.062C15.1504 16.3544 15.0337 16.7042 14.8006 17.4036C13.3483 21.7605 12.6222 23.9388 11.5573 24.5578C10.5444 25.1468 9.29331 25.1468 8.28038 24.5578C7.2155 23.9388 6.48938 21.7605 5.03714 17.4036Z"
          stroke="white"
          strokeWidth="2"
        />
        <path
          opacity="0.5"
          d="M6.05286 6.05273L11.1055 11.0497"
          stroke="#F6F6F6"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    );
  }
  if (name === "noChat") {
    return (
      <svg
        className={classname}
        xmlns="http://www.w3.org/2000/svg"
        width="891.29496"
        height="745.19434"
        viewBox="0 0 891.29496 745.19434"
        role="img"
        artist="Katerina Limpitsouni"
        source="https://undraw.co/"
      >
        <ellipse
          cx="418.64354"
          cy="727.19434"
          rx="352"
          ry="18"
          fill="#f2f2f2"
        />
        <path
          d="M778.64963,250.35008h-3.99878V140.80476a63.40187,63.40187,0,0,0-63.4018-63.40193H479.16232a63.40188,63.40188,0,0,0-63.402,63.4017v600.9744a63.40189,63.40189,0,0,0,63.4018,63.40192H711.24875a63.40187,63.40187,0,0,0,63.402-63.40168V328.32632h3.99878Z"
          transform="translate(-154.35252 -77.40283)"
          fill="#3f3d56"
        />
        <path
          d="M761.156,141.24713v600.09a47.35072,47.35072,0,0,1-47.35,47.35h-233.2a47.35084,47.35084,0,0,1-47.35-47.35v-600.09a47.3509,47.3509,0,0,1,47.35-47.35h28.29a22.50659,22.50659,0,0,0,20.83,30.99h132.96a22.50672,22.50672,0,0,0,20.83-30.99h30.29A47.35088,47.35088,0,0,1,761.156,141.24713Z"
          transform="translate(-154.35252 -77.40283)"
          fill="#fff"
        />
        <path
          d="M686.03027,400.0032q-2.32543,1.215-4.73047,2.3-2.18994.99-4.4497,1.86c-.5503.21-1.10987.42-1.66992.63a89.52811,89.52811,0,0,1-13.6001,3.75q-3.43506.675-6.96,1.06-2.90991.33-5.87989.47c-1.41015.07-2.82031.1-4.24023.1a89.84124,89.84124,0,0,1-16.75977-1.57c-1.44043-.26-2.85009-.57-4.26025-.91a88.77786,88.77786,0,0,1-19.66992-7.26c-.56006-.28-1.12012-.58-1.68018-.87-.83008-.44-1.63965-.9-2.4497-1.38.38964-.54.81005-1.07,1.23974-1.59a53.03414,53.03414,0,0,1,78.87012-4.1,54.27663,54.27663,0,0,1,5.06006,5.86C685.25977,398.89316,685.6499,399.44321,686.03027,400.0032Z"
          transform="translate(-154.35252 -77.40283)"
          fill="#6c63ff"
        />
        <circle cx="492.14325" cy="234.76352" r="43.90974" fill="#2f2e41" />
        <circle
          cx="642.49883"
          cy="327.46205"
          r="32.68086"
          transform="translate(-232.6876 270.90663) rotate(-28.66315)"
          fill="#a0616a"
        />
        <path
          d="M676.8388,306.90589a44.44844,44.44844,0,0,1-25.402,7.85033,27.23846,27.23846,0,0,0,10.796,4.44154,89.62764,89.62764,0,0,1-36.61.20571,23.69448,23.69448,0,0,1-7.66395-2.63224,9.699,9.699,0,0,1-4.73055-6.3266c-.80322-4.58859,2.77227-8.75743,6.488-11.567a47.85811,47.85811,0,0,1,40.21662-8.03639c4.49246,1.16124,8.99288,3.12327,11.91085,6.731s3.78232,9.16981,1.00224,12.88488Z"
          transform="translate(-154.35252 -77.40283)"
          fill="#2f2e41"
        />
        <path
          d="M644.5,230.17319a89.98675,89.98675,0,0,0-46.83984,166.83l.58007.34q.72.43506,1.43995.84c.81005.48,1.61962.94,2.4497,1.38.56006.29,1.12012.59,1.68018.87a88.77786,88.77786,0,0,0,19.66992,7.26c1.41016.34,2.81982.65,4.26025.91a89.84124,89.84124,0,0,0,16.75977,1.57c1.41992,0,2.83008-.03,4.24023-.1q2.97-.135,5.87989-.47,3.52513-.39,6.96-1.06a89.52811,89.52811,0,0,0,13.6001-3.75c.56005-.21,1.11962-.42,1.66992-.63q2.26464-.87,4.4497-1.86,2.40015-1.08,4.73047-2.3a90.7919,90.7919,0,0,0,37.03955-35.97c.04-.07995.09034-.16.13038-.24a89.30592,89.30592,0,0,0,9.6499-26.41,90.051,90.051,0,0,0-88.3501-107.21Zm77.06006,132.45c-.08008.14-.1499.28-.23.41a88.17195,88.17195,0,0,1-36.48,35.32q-2.29542,1.2-4.66992,2.25c-1.31006.59-2.64991,1.15-4,1.67-.57032.22-1.14991.44-1.73.64a85.72126,85.72126,0,0,1-11.73,3.36,84.69473,84.69473,0,0,1-8.95019,1.41c-1.8501.2-3.73.34-5.62012.41-1.21.05-2.42969.08-3.6499.08a86.762,86.762,0,0,1-16.21973-1.51,85.62478,85.62478,0,0,1-9.63037-2.36,88.46592,88.46592,0,0,1-13.98974-5.67c-.52-.27-1.04-.54-1.5503-.82-.73-.39-1.46972-.79-2.18994-1.22-.54-.3-1.08008-.62-1.60986-.94-.31006-.18-.62012-.37-.93018-.56a88.06851,88.06851,0,1,1,123.18018-32.47Z"
          transform="translate(-154.35252 -77.40283)"
          fill="#3f3d56"
        />
        <path
          d="M624.2595,268.86254c-.47244-4.968-6.55849-8.02647-11.3179-6.52583s-7.88411,6.2929-8.82863,11.19308a16.0571,16.0571,0,0,0,2.16528,12.12236c2.40572,3.46228,6.82664,5.623,10.95,4.74406,4.70707-1.00334,7.96817-5.59956,8.90127-10.32105s.00667-9.58929-.91854-14.31234Z"
          transform="translate(-154.35252 -77.40283)"
          fill="#2f2e41"
        />
        <path
          d="M691.24187,275.95964c-.47245-4.968-6.5585-8.02646-11.3179-6.52582s-7.88412,6.29289-8.82864,11.19307a16.05711,16.05711,0,0,0,2.16529,12.12236c2.40571,3.46228,6.82663,5.623,10.95,4.74406,4.70707-1.00334,7.96817-5.59955,8.90127-10.32105s.00667-9.58929-.91853-14.31234Z"
          transform="translate(-154.35252 -77.40283)"
          fill="#2f2e41"
        />
        <path
          d="M488.93638,356.14169a4.47525,4.47525,0,0,1-3.30664-1.46436L436.00767,300.544a6.02039,6.02039,0,0,0-4.42627-1.94727H169.3618a15.02615,15.02615,0,0,1-15.00928-15.00927V189.025a15.02615,15.02615,0,0,1,15.00928-15.00928H509.087A15.02615,15.02615,0,0,1,524.0963,189.025v94.5625A15.02615,15.02615,0,0,1,509.087,298.59676h-9.63135a6.01157,6.01157,0,0,0-6.00464,6.00489v47.0332a4.474,4.474,0,0,1-2.87011,4.1958A4.52563,4.52563,0,0,1,488.93638,356.14169Z"
          transform="translate(-154.35252 -77.40283)"
          fill="#fff"
        />
        <path
          d="M488.93638,356.14169a4.47525,4.47525,0,0,1-3.30664-1.46436L436.00767,300.544a6.02039,6.02039,0,0,0-4.42627-1.94727H169.3618a15.02615,15.02615,0,0,1-15.00928-15.00927V189.025a15.02615,15.02615,0,0,1,15.00928-15.00928H509.087A15.02615,15.02615,0,0,1,524.0963,189.025v94.5625A15.02615,15.02615,0,0,1,509.087,298.59676h-9.63135a6.01157,6.01157,0,0,0-6.00464,6.00489v47.0332a4.474,4.474,0,0,1-2.87011,4.1958A4.52563,4.52563,0,0,1,488.93638,356.14169ZM169.3618,176.01571A13.024,13.024,0,0,0,156.35252,189.025v94.5625a13.024,13.024,0,0,0,13.00928,13.00927H431.5814a8.02436,8.02436,0,0,1,5.90039,2.59571l49.62208,54.1333a2.50253,2.50253,0,0,0,4.34716-1.69092v-47.0332a8.0137,8.0137,0,0,1,8.00464-8.00489H509.087a13.024,13.024,0,0,0,13.00928-13.00927V189.025A13.024,13.024,0,0,0,509.087,176.01571Z"
          transform="translate(-154.35252 -77.40283)"
          fill="#3f3d56"
        />
        <circle cx="36.81601" cy="125.19345" r="13.13371" fill="#6c63ff" />
        <path
          d="M493.76439,275.26947H184.68447a7.00465,7.00465,0,1,1,0-14.00929H493.76439a7.00465,7.00465,0,0,1,0,14.00929Z"
          transform="translate(-154.35252 -77.40283)"
          fill="#e6e6e6"
        />
        <path
          d="M393.07263,245.49973H184.68447a7.00465,7.00465,0,1,1,0-14.00929H393.07263a7.00464,7.00464,0,0,1,0,14.00929Z"
          transform="translate(-154.35252 -77.40283)"
          fill="#e6e6e6"
        />
        <path
          d="M709.41908,676.83065a4.474,4.474,0,0,1-2.87011-4.1958v-47.0332a6.01157,6.01157,0,0,0-6.00464-6.00489H690.913a15.02615,15.02615,0,0,1-15.00928-15.00927V510.025A15.02615,15.02615,0,0,1,690.913,495.01571H1030.6382a15.02615,15.02615,0,0,1,15.00928,15.00928v94.5625a15.02615,15.02615,0,0,1-15.00928,15.00927H768.4186a6.02039,6.02039,0,0,0-4.42627,1.94727l-49.62207,54.1333a4.47525,4.47525,0,0,1-3.30664,1.46436A4.52563,4.52563,0,0,1,709.41908,676.83065Z"
          transform="translate(-154.35252 -77.40283)"
          fill="#fff"
        />
        <path
          d="M709.41908,676.83065a4.474,4.474,0,0,1-2.87011-4.1958v-47.0332a6.01157,6.01157,0,0,0-6.00464-6.00489H690.913a15.02615,15.02615,0,0,1-15.00928-15.00927V510.025A15.02615,15.02615,0,0,1,690.913,495.01571H1030.6382a15.02615,15.02615,0,0,1,15.00928,15.00928v94.5625a15.02615,15.02615,0,0,1-15.00928,15.00927H768.4186a6.02039,6.02039,0,0,0-4.42627,1.94727l-49.62207,54.1333a4.47525,4.47525,0,0,1-3.30664,1.46436A4.52563,4.52563,0,0,1,709.41908,676.83065ZM690.913,497.01571A13.024,13.024,0,0,0,677.9037,510.025v94.5625A13.024,13.024,0,0,0,690.913,617.59676h9.63135a8.0137,8.0137,0,0,1,8.00464,8.00489v47.0332a2.50253,2.50253,0,0,0,4.34716,1.69092l49.62208-54.1333a8.02436,8.02436,0,0,1,5.90039-2.59571h262.2196a13.024,13.024,0,0,0,13.00928-13.00927V510.025a13.024,13.024,0,0,0-13.00928-13.00928Z"
          transform="translate(-154.35252 -77.40283)"
          fill="#3f3d56"
        />
        <path
          d="M603.53027,706.11319a89.06853,89.06853,0,0,1-93.65039,1.49,54.12885,54.12885,0,0,1,9.40039-12.65,53.43288,53.43288,0,0,1,83.90967,10.56994C603.2998,705.71316,603.41992,705.91318,603.53027,706.11319Z"
          transform="translate(-154.35252 -77.40283)"
          fill="#6c63ff"
        />
        <circle cx="398.44256" cy="536.68841" r="44.20157" fill="#2f2e41" />
        <circle
          cx="556.81859"
          cy="629.4886"
          r="32.89806"
          transform="translate(-416.96496 738.72884) rotate(-61.33685)"
          fill="#ffb8b8"
        />
        <path
          d="M522.25039,608.79582a44.74387,44.74387,0,0,0,25.57085,7.9025,27.41946,27.41946,0,0,1-10.8677,4.47107,90.22316,90.22316,0,0,0,36.85334.20707,23.852,23.852,0,0,0,7.71488-2.64973,9.76352,9.76352,0,0,0,4.762-6.36865c.80855-4.61909-2.7907-8.81563-6.53113-11.64387a48.17616,48.17616,0,0,0-40.4839-8.08981c-4.52231,1.169-9.05265,3.144-11.99,6.77579s-3.80746,9.23076-1.0089,12.97052Z"
          transform="translate(-154.35252 -77.40283)"
          fill="#2f2e41"
        />
        <path
          d="M555.5,721.17319a89.97205,89.97205,0,1,1,48.5708-14.21875A89.87958,89.87958,0,0,1,555.5,721.17319Zm0-178a88.00832,88.00832,0,1,0,88,88A88.09957,88.09957,0,0,0,555.5,543.17319Z"
          transform="translate(-154.35252 -77.40283)"
          fill="#3f3d56"
        />
        <circle cx="563.81601" cy="445.19345" r="13.13371" fill="#6c63ff" />
        <path
          d="M1020.76439,595.26947H711.68447a7.00465,7.00465,0,1,1,0-14.00929h309.07992a7.00464,7.00464,0,0,1,0,14.00929Z"
          transform="translate(-154.35252 -77.40283)"
          fill="#e6e6e6"
        />
        <path
          d="M920.07263,565.49973H711.68447a7.00465,7.00465,0,1,1,0-14.00929H920.07263a7.00465,7.00465,0,0,1,0,14.00929Z"
          transform="translate(-154.35252 -77.40283)"
          fill="#e6e6e6"
        />
        <ellipse
          cx="554.64354"
          cy="605.66091"
          rx="24.50394"
          ry="2.71961"
          fill="#f2f2f2"
        />
        <ellipse
          cx="335.64354"
          cy="285.66091"
          rx="24.50394"
          ry="2.71961"
          fill="#f2f2f2"
        />
      </svg>
    );
  }
  if (name === "nowPayment") {
    return (
      <div>
        <svg
          className={`w-28 fill-neutral-700 dark:fill-[#FEFEFE] ${classname}`}
          viewBox="0 0 163 21"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.386 13.815l-.506.161V1.05h1.84V16h-1.84L2.174 3.258l.506-.161V16H.84V1.05h1.84l9.706 12.765zm12.278 2.415c-1.365 0-2.607-.314-3.726-.943-1.104-.644-1.986-1.541-2.645-2.691-.66-1.15-.99-2.507-.99-4.071 0-1.564.33-2.921.99-4.071.659-1.165 1.54-2.062 2.645-2.691 1.119-.629 2.361-.943 3.726-.943 1.364 0 2.599.314 3.703.943 1.119.629 2.008 1.526 2.668 2.691.659 1.15.989 2.507.989 4.071 0 1.564-.33 2.921-.99 4.071a7.137 7.137 0 01-2.667 2.691c-1.104.629-2.339.943-3.703.943zm0-1.725c1.042 0 1.978-.222 2.806-.667.828-.46 1.487-1.135 1.978-2.024.49-.89.736-1.986.736-3.289 0-1.303-.246-2.392-.736-3.266-.491-.89-1.15-1.564-1.978-2.024-.828-.46-1.764-.69-2.806-.69-1.028 0-1.963.23-2.806.69-.828.46-1.488 1.135-1.978 2.024-.491.874-.736 1.963-.736 3.266s.245 2.4.736 3.289c.49.89 1.15 1.564 1.978 2.024.843.445 1.778.667 2.806.667zM38.924 16l-5.38-14.95h1.978l4.623 12.972h-.552L44.03 1.05h1.978l4.439 12.972h-.552L54.519 1.05h1.932L51.115 16h-1.932L44.767 2.568h.506L40.857 16h-1.932z"
            fill="#64ACFF"
          />
          <path d="M60.78 10.71V8.985h4.692c.92 0 1.663-.284 2.23-.851.584-.583.875-1.334.875-2.254 0-.95-.291-1.702-.874-2.254-.568-.567-1.311-.851-2.231-.851h-4.324V16h-1.84V1.05h6.164c.69 0 1.334.107 1.932.322.598.215 1.12.529 1.564.943.46.414.813.92 1.058 1.518.26.598.39 1.28.39 2.047 0 .767-.13 1.449-.39 2.047a4.11 4.11 0 01-1.058 1.518 4.496 4.496 0 01-1.564.943 5.676 5.676 0 01-1.932.322H60.78zm16.675 5.52a4.46 4.46 0 01-2.507-.759c-.751-.521-1.357-1.227-1.817-2.116-.445-.905-.667-1.932-.667-3.082s.23-2.177.69-3.082c.46-.905 1.08-1.618 1.863-2.139a4.77 4.77 0 012.668-.782c1.073 0 1.886.276 2.438.828.567.537.95 1.257 1.15 2.162.215.905.322 1.909.322 3.013 0 .583-.061 1.219-.184 1.909a7.501 7.501 0 01-.644 1.955 3.997 3.997 0 01-1.242 1.518c-.537.383-1.227.575-2.07.575zm.46-1.748c.782 0 1.426-.192 1.932-.575.521-.383.905-.89 1.15-1.518.245-.644.368-1.35.368-2.116 0-.843-.13-1.58-.391-2.208-.245-.644-.629-1.142-1.15-1.495-.506-.368-1.142-.552-1.91-.552-1.15 0-2.038.406-2.667 1.219-.629.797-.943 1.81-.943 3.036 0 .813.153 1.541.46 2.185a3.96 3.96 0 001.288 1.495 3.386 3.386 0 001.863.529zm3.45-9.982h1.84V16h-1.68l-.045-.414a35.32 35.32 0 00-.07-.966 11.69 11.69 0 01-.045-.92V4.5zm4.403 0h1.978l4.117 11.04-1.61.46-4.485-11.5zm10.695 0l-6.417 16.1h-2.001l2.783-6.21 3.68-9.89h1.955zm2.552 0h1.84V16h-1.84V4.5zm5.796-.23c.613 0 1.165.092 1.656.276.491.184.905.452 1.242.805.337.353.598.782.782 1.288.184.49.276 1.05.276 1.679V16h-1.84V8.778c0-.89-.207-1.556-.621-2.001-.414-.445-1.035-.667-1.863-.667-.629 0-1.211.161-1.748.483a3.964 3.964 0 00-1.334 1.334c-.337.552-.544 1.196-.621 1.932l-.023-1.334c.077-.644.23-1.227.46-1.748a4.95 4.95 0 01.897-1.334 3.817 3.817 0 011.242-.874c.475-.2.974-.299 1.495-.299zm7.728 0c.613 0 1.165.092 1.656.276.491.184.905.452 1.242.805.337.353.598.782.782 1.288.184.49.276 1.05.276 1.679V16h-1.84V8.778c0-.89-.207-1.556-.621-2.001-.414-.445-1.035-.667-1.863-.667-.629 0-1.211.161-1.748.483a3.964 3.964 0 00-1.334 1.334c-.337.552-.544 1.196-.621 1.932l-.023-1.334c.077-.644.23-1.227.46-1.748a4.95 4.95 0 01.897-1.334 3.817 3.817 0 011.242-.874c.475-.2.974-.299 1.495-.299zm15.68 8.027h1.725a4.735 4.735 0 01-.828 2.024 4.501 4.501 0 01-1.656 1.403c-.675.337-1.457.506-2.346.506-1.074 0-2.04-.253-2.898-.759a5.765 5.765 0 01-2.047-2.116c-.491-.905-.736-1.932-.736-3.082s.237-2.177.713-3.082a5.592 5.592 0 012.001-2.139c.843-.521 1.794-.782 2.852-.782 1.119 0 2.062.253 2.829.759.782.49 1.357 1.219 1.725 2.185.383.95.537 2.124.46 3.519h-8.74c.076.751.283 1.41.621 1.978a3.706 3.706 0 001.334 1.334c.552.307 1.18.46 1.886.46.782 0 1.441-.2 1.978-.598.552-.414.928-.95 1.127-1.61zm-3.151-6.302c-.951 0-1.748.276-2.392.828-.644.552-1.074 1.303-1.288 2.254h6.739c-.062-1.012-.391-1.779-.989-2.3a3.003 3.003 0 00-2.07-.782zm7.917-1.495h1.84V16h-1.84V4.5zm5.796-.23c.614 0 1.166.092 1.656.276.491.184.905.452 1.242.805.338.353.598.782.782 1.288.184.49.276 1.05.276 1.679V16h-1.84V8.778c0-.89-.207-1.556-.621-2.001-.414-.445-1.035-.667-1.863-.667-.628 0-1.211.161-1.748.483a3.973 3.973 0 00-1.334 1.334c-.337.552-.544 1.196-.621 1.932l-.023-1.334c.077-.644.23-1.227.46-1.748.246-.521.545-.966.897-1.334a3.817 3.817 0 011.242-.874c.476-.2.974-.299 1.495-.299zm6.735.23h6.762v1.725h-6.762V4.5zm2.461-2.99h1.84V16h-1.84V1.51zm6.523 10.787h1.702c.046.66.291 1.196.736 1.61.46.414 1.119.621 1.978.621.521 0 .927-.069 1.219-.207.306-.138.529-.322.667-.552.138-.245.207-.514.207-.805 0-.353-.092-.629-.276-.828a1.856 1.856 0 00-.713-.529 8.32 8.32 0 00-1.012-.391 222.72 222.72 0 01-1.38-.529c-.46-.2-.897-.43-1.311-.69a3.474 3.474 0 01-.966-.989c-.246-.399-.368-.874-.368-1.426 0-.46.092-.89.276-1.288a2.97 2.97 0 01.782-1.058 3.86 3.86 0 011.219-.713 4.643 4.643 0 011.564-.253c.766 0 1.41.153 1.932.46.536.307.943.744 1.219 1.311.291.552.444 1.196.46 1.932h-1.587c-.108-.69-.33-1.188-.667-1.495-.322-.322-.79-.483-1.403-.483-.629 0-1.112.138-1.449.414-.338.276-.506.644-.506 1.104 0 .337.122.621.368.851.245.215.559.414.943.598.398.169.82.345 1.265.529.444.184.874.368 1.288.552.414.184.782.399 1.104.644.322.245.575.552.759.92.199.353.299.797.299 1.334 0 .644-.154 1.219-.46 1.725-.292.49-.729.874-1.311 1.15-.568.276-1.265.414-2.093.414-.752 0-1.396-.092-1.932-.276a4.319 4.319 0 01-1.311-.759 4.13 4.13 0 01-.828-1.012 3.648 3.648 0 01-.368-1.035 2.77 2.77 0 01-.046-.851z" />
        </svg>
      </div>
    );
  }
  if (name === "cryptoWallet") {
    return (
      <div>
        <svg className={`w-7 fill-zi-text-light dark:fill-cyan-600 ${classname}`} version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <g>
          <g>
            <path d="M494.558,261.046h-0.563V143.455c0-14.581-11.863-26.444-26.444-26.444h-4.731l-10.772-56.656
              c-0.87-4.577-3.47-8.541-7.322-11.162c-3.852-2.621-8.494-3.585-13.07-2.715l-40.132,7.63L376.58,11.675
              c-1.547-4.394-4.714-7.923-8.916-9.936c-4.201-2.013-8.934-2.27-13.33-0.721L24.839,117.065C11.003,117.898,0,129.413,0,143.455
              v342.084c0,14.581,11.863,26.444,26.444,26.444h441.108c14.581,0,26.444-11.863,26.444-26.444V367.947h0.563
              c9.618,0,17.442-7.824,17.442-17.442v-72.018C512,268.871,504.176,261.046,494.558,261.046z M359.94,16.938
              c0.055-0.019,0.218-0.078,0.43,0.024c0.21,0.1,0.268,0.267,0.287,0.321l14.094,40.016l-16.807,3.195
              c-4.579,0.871-7.586,5.289-6.715,9.868c0.871,4.579,5.286,7.587,9.868,6.715l73.711-14.015c0.056-0.01,0.228-0.044,0.422,0.088
              c0.194,0.132,0.226,0.304,0.236,0.36l10.172,53.503H151.043l174.055-33.092c4.579-0.87,7.586-5.288,6.715-9.868
              c-0.871-4.579-5.287-7.588-9.868-6.715l-228.4,43.425L359.94,16.938z M477.117,485.538c0,5.274-4.291,9.565-9.565,9.565H26.444
              c-5.274,0-9.565-4.291-9.565-9.565v-9.565h18.567c4.661,0,8.44-3.779,8.44-8.44s-3.779-8.44-8.44-8.44H16.879V169.899h18.567
              c4.661,0,8.44-3.779,8.44-8.44s-3.779-8.44-8.44-8.44H16.879v-9.565c0-5.274,4.291-9.565,9.565-9.565h441.108
              c5.274,0,9.565,4.291,9.565,9.565v117.591h-54.576c-29.472,0-53.451,23.978-53.451,53.451c0,29.472,23.978,53.451,53.451,53.451
              h54.576V485.538z M495.121,350.505c0,0.309-0.252,0.563-0.563,0.563h-72.018c-20.165,0-36.571-16.406-36.571-36.571
              c0-20.166,16.406-36.571,36.571-36.571h72.018c0.311,0,0.563,0.253,0.563,0.563V350.505z"/>
          </g>
        </g>
        <g>
          <g>
            <path d="M89.459,459.094H71.455c-4.661,0-8.44,3.779-8.44,8.44s3.779,8.44,8.44,8.44h18.004c4.661,0,8.44-3.779,8.44-8.44
              S94.12,459.094,89.459,459.094z"/>
          </g>
        </g>
        <g>
          <g>
            <path d="M89.459,153.02H71.455c-4.661,0-8.44,3.779-8.44,8.44s3.779,8.44,8.44,8.44h18.004c4.661,0,8.44-3.779,8.44-8.44
              S94.12,153.02,89.459,153.02z"/>
          </g>
        </g>
        <g>
          <g>
            <path d="M143.473,459.094h-18.004c-4.661,0-8.44,3.779-8.44,8.44s3.779,8.44,8.44,8.44h18.004c4.661,0,8.44-3.779,8.44-8.44
              S148.133,459.094,143.473,459.094z"/>
          </g>
        </g>
        <g>
          <g>
            <path d="M143.473,153.02h-18.004c-4.661,0-8.44,3.779-8.44,8.44s3.779,8.44,8.44,8.44h18.004c4.661,0,8.44-3.779,8.44-8.44
              S148.133,153.02,143.473,153.02z"/>
          </g>
        </g>
        <g>
          <g>
            <path d="M197.486,459.094h-18.004c-4.661,0-8.44,3.779-8.44,8.44s3.779,8.44,8.44,8.44h18.004c4.661,0,8.44-3.779,8.44-8.44
              S202.147,459.094,197.486,459.094z"/>
          </g>
        </g>
        <g>
          <g>
            <path d="M197.486,153.02h-18.004c-4.661,0-8.44,3.779-8.44,8.44s3.779,8.44,8.44,8.44h18.004c4.661,0,8.44-3.779,8.44-8.44
              S202.147,153.02,197.486,153.02z"/>
          </g>
        </g>
        <g>
          <g>
            <path d="M251.499,459.094h-18.004c-4.661,0-8.44,3.779-8.44,8.44s3.779,8.44,8.44,8.44h18.004c4.661,0,8.44-3.779,8.44-8.44
              S256.16,459.094,251.499,459.094z"/>
          </g>
        </g>
        <g>
          <g>
            <path d="M251.499,153.02h-18.004c-4.661,0-8.44,3.779-8.44,8.44s3.779,8.44,8.44,8.44h18.004c4.661,0,8.44-3.779,8.44-8.44
              S256.16,153.02,251.499,153.02z"/>
          </g>
        </g>
        <g>
          <g>
            <path d="M305.512,459.094h-18.004c-4.661,0-8.44,3.779-8.44,8.44s3.779,8.44,8.44,8.44h18.004c4.661,0,8.44-3.779,8.44-8.44
              S310.173,459.094,305.512,459.094z"/>
          </g>
        </g>
        <g>
          <g>
            <path d="M305.512,153.02h-18.004c-4.661,0-8.44,3.779-8.44,8.44s3.779,8.44,8.44,8.44h18.004c4.661,0,8.44-3.779,8.44-8.44
              S310.173,153.02,305.512,153.02z"/>
          </g>
        </g>
        <g>
          <g>
            <path d="M359.525,459.094h-18.004c-4.661,0-8.44,3.779-8.44,8.44s3.779,8.44,8.44,8.44h18.004c4.661,0,8.44-3.779,8.44-8.44
              S364.186,459.094,359.525,459.094z"/>
          </g>
        </g>
        <g>
          <g>
            <path d="M359.525,153.02h-18.004c-4.661,0-8.44,3.779-8.44,8.44s3.779,8.44,8.44,8.44h18.004c4.661,0,8.44-3.779,8.44-8.44
              S364.186,153.02,359.525,153.02z"/>
          </g>
        </g>
        <g>
          <g>
            <path d="M413.538,459.094h-18.004c-4.661,0-8.44,3.779-8.44,8.44s3.779,8.44,8.44,8.44h18.004c4.661,0,8.44-3.779,8.44-8.44
              S418.199,459.094,413.538,459.094z"/>
          </g>
        </g>
        <g>
          <g>
            <path d="M413.538,153.02h-18.004c-4.661,0-8.44,3.779-8.44,8.44s3.779,8.44,8.44,8.44h18.004c4.661,0,8.44-3.779,8.44-8.44
              S418.199,153.02,413.538,153.02z"/>
          </g>
        </g>
        <g>
          <g>
            <path d="M449.547,441.09c-4.661,0-8.44,3.779-8.44,8.44v18.004c0,4.662,3.779,8.44,8.44,8.44c4.661,0,8.44-3.779,8.44-8.44V449.53
              C457.987,444.869,454.208,441.09,449.547,441.09z"/>
          </g>
        </g>
        <g>
          <g>
            <path d="M449.547,153.02c-4.661,0-8.44,3.779-8.44,8.44v18.004c0,4.662,3.779,8.44,8.44,8.44c4.661,0,8.44-3.779,8.44-8.44
              v-18.004C457.987,156.798,454.208,153.02,449.547,153.02z"/>
          </g>
        </g>
        <g>
          <g>
            <path d="M449.547,207.033c-4.661,0-8.44,3.779-8.44,8.44v18.004c0,4.662,3.779,8.44,8.44,8.44c4.661,0,8.44-3.779,8.44-8.44
              v-18.004C457.987,210.812,454.208,207.033,449.547,207.033z"/>
          </g>
        </g>
        <g>
          <g>
            <path d="M449.547,387.077c-4.661,0-8.44,3.779-8.44,8.44v18.004c0,4.662,3.779,8.44,8.44,8.44c4.661,0,8.44-3.779,8.44-8.44
              v-18.004C457.987,390.856,454.208,387.077,449.547,387.077z"/>
          </g>
        </g>
        <g>
          <g>
            <path d="M422.541,297.055c-9.618,0-17.442,7.824-17.442,17.442c0,9.618,7.824,17.442,17.442,17.442
              c9.618,0,17.442-7.824,17.442-17.442C439.982,304.879,432.158,297.055,422.541,297.055z"/>
          </g>
        </g>
        <g>
          <g>
            <path d="M241.934,308.053v-65.798c27.575,2.217,46.136,15.045,46.136,26.668c0,4.661,3.779,8.44,8.44,8.44s8.44-3.779,8.44-8.44
              c0-22.851-27.068-41.094-63.015-43.584v-9.866c0-4.661-3.779-8.44-8.44-8.44s-8.44,3.779-8.44,8.44v9.866
              c-35.947,2.491-63.015,20.734-63.015,43.584c0,30.612,29.107,42.558,63.015,52.017v65.798
              c-27.575-2.216-46.136-15.044-46.136-26.668c0-4.661-3.779-8.44-8.44-8.44s-8.44,3.779-8.44,8.44
              c0,22.851,27.068,41.094,63.015,43.584v9.866c0,4.661,3.779,8.44,8.44,8.44s8.44-3.779,8.44-8.44v-9.866
              c35.947-2.491,63.015-20.734,63.015-43.584C304.949,329.458,275.842,317.512,241.934,308.053z M225.055,303.36
              c-34.23-10.112-46.136-19.297-46.136-34.437c0-11.623,18.561-24.451,46.136-26.668V303.36z M241.934,386.738v-61.105
              c34.23,10.113,46.136,19.298,46.136,34.437C288.07,371.693,269.509,384.521,241.934,386.738z"/>
          </g>
        </g>
        </svg>
      </div>
    );
  }
  if (name === "rialWallet") {
    return (
      <div>
        <svg className={`w-8 fill-zi-text-light dark:fill-zi-text-dark ${classname}`} viewBox="0 0 800 800" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_839_10)">
          <path d="M772.747 407.884H771.867V224.148C771.867 201.365 753.331 182.83 730.548 182.83H723.156L706.325 94.3045C704.966 87.153 700.903 80.9592 694.884 76.8639C688.866 72.7686 681.613 71.2624 674.463 72.6217L611.756 84.5436L588.406 18.242C585.989 11.3764 581.041 5.86236 574.475 2.71704C567.911 -0.428269 560.516 -0.829831 553.647 1.59048L38.8109 182.914C17.1922 184.215 0 202.208 0 224.148V758.655C0 781.437 18.5359 799.973 41.3188 799.973H730.55C753.333 799.973 771.869 781.437 771.869 758.655V574.917H772.748C787.777 574.917 800.002 562.692 800.002 547.664V435.136C800 420.111 787.775 407.884 772.747 407.884ZM562.406 26.4655C562.492 26.4358 562.747 26.3436 563.078 26.503C563.406 26.6592 563.497 26.9202 563.527 27.0045L585.548 89.5295L559.288 94.5217C552.133 95.8827 547.434 102.786 548.795 109.94C550.156 117.095 557.055 121.795 564.214 120.433L679.388 98.5342C679.475 98.5186 679.744 98.4655 680.047 98.6717C680.35 98.878 680.4 99.1467 680.416 99.2342L696.309 182.833H236.005L507.966 131.126C515.12 129.767 519.819 122.864 518.458 115.708C517.097 108.553 510.197 103.851 503.039 105.215L146.164 173.067L562.406 26.4655ZM745.495 758.653C745.495 766.894 738.791 773.598 730.55 773.598H41.3188C33.0781 773.598 26.3734 766.894 26.3734 758.653V743.708H55.3844C62.6672 743.708 68.5719 737.803 68.5719 730.52C68.5719 723.237 62.6672 717.333 55.3844 717.333H26.3734V265.467H55.3844C62.6672 265.467 68.5719 259.562 68.5719 252.28C68.5719 244.997 62.6672 239.092 55.3844 239.092H26.3734V224.147C26.3734 215.906 33.0781 209.201 41.3188 209.201H730.55C738.791 209.201 745.495 215.906 745.495 224.147V407.883H660.22C614.17 407.883 576.703 445.348 576.703 491.4C576.703 537.45 614.169 574.917 660.22 574.917H745.495V758.653ZM773.627 547.664C773.627 548.147 773.233 548.544 772.747 548.544H660.219C628.711 548.544 603.077 522.909 603.077 491.401C603.077 459.892 628.711 434.259 660.219 434.259H772.747C773.233 434.259 773.627 434.655 773.627 435.139V547.664Z" />
          <path d="M139.78 717.334H111.648C104.366 717.334 98.4609 723.239 98.4609 730.521C98.4609 737.804 104.366 743.709 111.648 743.709H139.78C147.063 743.709 152.967 737.804 152.967 730.521C152.967 723.239 147.063 717.334 139.78 717.334Z" />
          <path d="M139.78 239.094H111.648C104.366 239.094 98.4609 244.998 98.4609 252.281C98.4609 259.564 104.366 265.469 111.648 265.469H139.78C147.063 265.469 152.967 259.564 152.967 252.281C152.967 244.998 147.063 239.094 139.78 239.094Z" />
          <path d="M224.177 717.334H196.045C188.763 717.334 182.858 723.239 182.858 730.521C182.858 737.804 188.763 743.709 196.045 743.709H224.177C231.459 743.709 237.364 737.804 237.364 730.521C237.364 723.239 231.458 717.334 224.177 717.334Z" />
          <path d="M224.177 239.094H196.045C188.763 239.094 182.858 244.998 182.858 252.281C182.858 259.564 188.763 265.469 196.045 265.469H224.177C231.459 265.469 237.364 259.564 237.364 252.281C237.364 244.998 231.458 239.094 224.177 239.094Z" />
          <path d="M308.572 717.334H280.441C273.158 717.334 267.253 723.239 267.253 730.521C267.253 737.804 273.158 743.709 280.441 743.709H308.572C315.855 743.709 321.759 737.804 321.759 730.521C321.759 723.239 315.855 717.334 308.572 717.334Z" />
          <path d="M308.572 239.094H280.441C273.158 239.094 267.253 244.998 267.253 252.281C267.253 259.564 273.158 265.469 280.441 265.469H308.572C315.855 265.469 321.759 259.564 321.759 252.281C321.759 244.998 315.855 239.094 308.572 239.094Z" />
          <path d="M392.967 717.334H364.836C357.553 717.334 351.648 723.239 351.648 730.521C351.648 737.804 357.553 743.709 364.836 743.709H392.967C400.25 743.709 406.155 737.804 406.155 730.521C406.155 723.239 400.25 717.334 392.967 717.334Z" />
          <path d="M392.967 239.094H364.836C357.553 239.094 351.648 244.998 351.648 252.281C351.648 259.564 357.553 265.469 364.836 265.469H392.967C400.25 265.469 406.155 259.564 406.155 252.281C406.155 244.998 400.25 239.094 392.967 239.094Z" />
          <path d="M477.362 717.334H449.231C441.948 717.334 436.044 723.239 436.044 730.521C436.044 737.804 441.948 743.709 449.231 743.709H477.362C484.645 743.709 490.55 737.804 490.55 730.521C490.55 723.239 484.645 717.334 477.362 717.334Z" />
          <path d="M477.362 239.094H449.231C441.948 239.094 436.044 244.998 436.044 252.281C436.044 259.564 441.948 265.469 449.231 265.469H477.362C484.645 265.469 490.55 259.564 490.55 252.281C490.55 244.998 484.645 239.094 477.362 239.094Z" />
          <path d="M561.758 717.334H533.626C526.344 717.334 520.439 723.239 520.439 730.521C520.439 737.804 526.344 743.709 533.626 743.709H561.758C569.041 743.709 574.945 737.804 574.945 730.521C574.945 723.239 569.041 717.334 561.758 717.334Z" />
          <path d="M561.758 239.094H533.626C526.344 239.094 520.439 244.998 520.439 252.281C520.439 259.564 526.344 265.469 533.626 265.469H561.758C569.041 265.469 574.945 259.564 574.945 252.281C574.945 244.998 569.041 239.094 561.758 239.094Z" />
          <path d="M646.153 717.334H618.022C610.739 717.334 604.834 723.239 604.834 730.521C604.834 737.804 610.739 743.709 618.022 743.709H646.153C653.436 743.709 659.341 737.804 659.341 730.521C659.341 723.239 653.436 717.334 646.153 717.334Z" />
          <path d="M646.153 239.094H618.022C610.739 239.094 604.834 244.998 604.834 252.281C604.834 259.564 610.739 265.469 618.022 265.469H646.153C653.436 265.469 659.341 259.564 659.341 252.281C659.341 244.998 653.436 239.094 646.153 239.094Z" />
          <path d="M702.417 689.203C695.134 689.203 689.23 695.108 689.23 702.391V730.522C689.23 737.806 695.134 743.709 702.417 743.709C709.7 743.709 715.605 737.805 715.605 730.522V702.391C715.605 695.108 709.7 689.203 702.417 689.203Z" />
          <path d="M702.417 239.094C695.134 239.094 689.23 244.998 689.23 252.281V280.413C689.23 287.697 695.134 293.6 702.417 293.6C709.7 293.6 715.605 287.695 715.605 280.413V252.281C715.605 244.997 709.7 239.094 702.417 239.094Z" />
          <path d="M702.417 323.489C695.134 323.489 689.23 329.394 689.23 336.677V364.808C689.23 372.092 695.134 377.996 702.417 377.996C709.7 377.996 715.605 372.091 715.605 364.808V336.677C715.605 329.394 709.7 323.489 702.417 323.489Z" />
          <path d="M702.417 604.808C695.134 604.808 689.23 610.712 689.23 617.995V646.126C689.23 653.411 695.134 659.314 702.417 659.314C709.7 659.314 715.605 653.409 715.605 646.126V617.995C715.605 610.712 709.7 604.808 702.417 604.808Z" />
          <path d="M660.22 464.148C645.192 464.148 632.967 476.373 632.967 491.402C632.967 506.43 645.192 518.655 660.22 518.655C675.249 518.655 687.474 506.43 687.474 491.402C687.472 476.373 675.247 464.148 660.22 464.148Z" />
          <path d="M234.9 629.4C219.9 629.4 205.9 627 192.9 622.2C180.1 617.4 169.7 610.2 161.7 600.6C153.9 591 150 578.9 150 564.3C150 561.3 150.3 557.1 150.9 551.7C151.7 546.1 153.3 539.4 155.7 531.6C158.1 523.8 161.9 515.2 167.1 505.8L187.8 516C184.8 522.2 182.3 527.9 180.3 533.1C178.3 538.1 176.8 542.8 175.8 547.2C175 551.4 174.6 555.6 174.6 559.8C174.6 570 177.3 578.4 182.7 585C188.3 591.8 195.7 596.8 204.9 600C214.3 603.2 224.6 604.8 235.8 604.8C254 604.8 268.3 601.2 278.7 594C289.1 587 296.4 576.8 300.6 563.4C304.8 549.8 306.5 533.5 305.7 514.5L300 358.8H324.9L329.7 510.9C330.1 526.5 328.9 541.4 326.1 555.6C323.3 569.8 318.3 582.4 311.1 593.4C303.9 604.6 294 613.4 281.4 619.8C269 626.2 253.5 629.4 234.9 629.4ZM418.2 629.1C413.8 629.1 410.1 627.6 407.1 624.6C404.1 621.6 402.6 618 402.6 613.8C402.6 609.4 404.1 605.6 407.1 602.4C410.1 599.4 413.8 597.9 418.2 597.9C422.4 597.9 426 599.4 429 602.4C432 605.6 433.5 609.4 433.5 613.8C433.5 618 432 621.6 429 624.6C426 627.6 422.4 629.1 418.2 629.1ZM456.9 629.1C452.5 629.1 448.8 627.6 445.8 624.6C442.8 621.6 441.3 618 441.3 613.8C441.3 609.4 442.8 605.6 445.8 602.4C448.8 599.4 452.5 597.9 456.9 597.9C461.1 597.9 464.7 599.4 467.7 602.4C470.7 605.6 472.2 609.4 472.2 613.8C472.2 618 470.7 621.6 467.7 624.6C464.7 627.6 461.1 629.1 456.9 629.1ZM245.1 537.3C234.9 537.3 226.7 535.4 220.5 531.6C214.5 527.6 210.1 522.4 207.3 516C204.5 509.6 203.1 502.8 203.1 495.6C203.1 486.4 205.6 475.9 210.6 464.1C215.6 452.3 223.9 440.6 235.5 429L253.2 442.5C246.4 449.7 240.4 457.8 235.2 466.8C230.2 475.6 227.7 484 227.7 492C227.7 498 229.4 502.7 232.8 506.1C236.2 509.5 241.1 511.2 247.5 511.2C252.5 511.2 257.5 510.1 262.5 507.9C267.7 505.5 273.5 501.8 279.9 496.8C286.3 491.8 293.9 485.2 302.7 477C311.5 468.8 322.2 458.9 334.8 447.3C350 433.3 362.5 422.2 372.3 414C382.1 405.6 390.6 399.6 397.8 396C405.2 392.2 412.6 390.3 420 390.3C430.2 390.3 439.3 393.5 447.3 399.9C455.5 406.1 461 416.2 463.8 430.2L443.4 438.3C441.8 433.7 439.9 429.7 437.7 426.3C435.7 422.9 433.2 420.3 430.2 418.5C427.4 416.7 423.9 415.8 419.7 415.8C415.5 415.8 411.2 416.8 406.8 418.8C402.4 420.8 397.4 423.9 391.8 428.1C386.4 432.3 380 437.8 372.6 444.6C365.4 451.4 356.7 459.5 346.5 468.9C331.1 483.3 318.2 495 307.8 504C297.6 512.8 288.9 519.7 281.7 524.7C274.5 529.5 268.1 532.8 262.5 534.6C256.9 536.4 251.1 537.3 245.1 537.3ZM420.3 574.5C405.1 574.5 393.2 572.9 384.6 569.7C376 566.5 369.9 561.1 366.3 553.5C362.7 545.9 360.7 535.7 360.3 522.9L354.3 358.8H378.9L384.9 513.3C385.3 520.7 385.9 526.8 386.7 531.6C387.5 536.2 389.1 539.9 391.5 542.7C393.9 545.3 397.6 547.2 402.6 548.4C407.6 549.4 414.4 549.9 423 549.9C434.2 549.9 442.6 549.3 448.2 548.1C454 546.7 457.9 544.2 459.9 540.6C462.1 536.8 463.2 531.3 463.2 524.1C463.2 516.5 461.4 507 457.8 495.6C454.4 484 450.5 472.5 446.1 461.1L470.4 452.1C473 458.5 475.4 465.8 477.6 474C480 482.2 482 490.3 483.6 498.3C485.2 506.3 486 513.3 486 519.3C486 529.3 484.6 537.8 481.8 544.8C479.2 551.8 475.2 557.5 469.8 561.9C464.4 566.3 457.6 569.5 449.4 571.5C441.2 573.5 431.5 574.5 420.3 574.5Z" />
          </g>
          <defs>
          <clipPath id="clip0_839_10">
          </clipPath>
          </defs>
        </svg>
      </div>
    );
  }
  if (name === "shaparak") {
    return (
      <div>
        <svg className={`w-11 fill-cyan-600 ${classname}`} viewBox="0 0 800 528" xmlns="http://www.w3.org/2000/svg">
          <path d="M197.3 482.733C198.482 480.803 199.561 478.811 200.533 476.767C200.91 475.093 201.458 473.462 202.167 471.9C202.167 470.833 202.167 470.833 201.633 470.833C201.633 470.833 201.067 471.367 200 473C199.213 474.334 198.1 475.446 196.767 476.233C194.848 477.751 192.634 478.852 190.267 479.467C187.567 480.567 183.8 481.633 180.533 482.733C176.849 483.792 173.034 484.331 169.2 484.333C165.606 484.764 161.986 484.942 158.367 484.867C149.2 484.867 142.7 483.8 138.367 481.633C136.2 480.567 135.133 479.467 135.133 477.867C135.133 476.233 135.133 475.167 134.6 474.6C134.6 474.067 134.067 473.533 134.067 473.533C133.5 473.533 133.5 474.067 132.967 474.067C132.967 474.6 132.433 475.7 132.433 477.3C131.9 478.967 131.9 480.567 131.367 482.733C131.367 484.333 130.8 485.967 130.8 486.5C130.8 488.667 131.367 490.833 132.967 491.9C134.6 493.533 137.3 494.6 141.633 495.7C144.3 496.233 147.567 496.233 151.9 496.233C155.667 496.233 160 496.233 164.333 495.7C168.667 495.167 173 494.6 177.3 493C179.928 492.429 182.471 491.522 184.867 490.3C187.567 489.2 190.267 487.6 192.433 486.5C194.445 485.85 196.167 484.518 197.3 482.733ZM218.933 465.967C218.652 465.982 218.386 466.098 218.184 466.294C217.981 466.49 217.857 466.753 217.833 467.033C217.3 468.133 216.767 469.733 215.667 471.9C214.6 474.067 213.5 476.767 212.433 478.933C211.367 481.1 210.267 482.733 209.2 484.333C207.685 485.894 206.059 487.342 204.333 488.667C202.167 490.3 200 491.367 198.367 492.433C196.767 493.533 195.7 494.1 195.133 495.167C194.6 495.7 194.6 495.7 194.6 496.233L195.133 496.767C195.667 496.767 196.2 496.767 197.833 496.233C199.467 495.7 201.067 495.7 203.8 494.6C205.675 494.082 207.487 493.355 209.2 492.433C210.267 491.367 211.367 490.3 211.867 488.667C213.264 486.49 214.362 484.135 215.133 481.667C216.2 478.4 217.3 475.667 217.833 473C218.367 470.3 218.933 468.667 218.933 467.6C220 466.5 219.467 466.5 218.933 465.933V465.967ZM243.267 466.5C241.74 465.765 240.061 465.399 238.367 465.433H236.767C260.533 443.267 272.967 430.833 273.5 429.2C276.2 423.267 276.767 421.1 275.167 421.633C273.5 424.333 265.933 431.9 252.433 444.867C239.433 457.3 232.433 464.333 230.267 466.533C230.267 464.333 230.8 461.633 231.367 458.4C232.433 451.9 232.433 447.6 232.967 445.4C232.967 444.867 232.967 444.867 232.433 444.867C232.433 444.867 231.9 444.867 231.9 445.433C230.267 450.3 228.633 453.533 228.1 455.167C227.033 461.633 225.933 467.033 225.433 472.433C224.867 477.867 224.333 481.633 224.333 484.867C224.333 488.667 224.867 491.9 226.5 494.067C227.006 495.058 227.781 495.887 228.736 496.458C229.691 497.03 230.787 497.322 231.9 497.3C233.498 497.352 235.053 496.778 236.233 495.7C237.746 494.717 239.03 493.421 240 491.9C241.633 489.733 242.7 486.5 244.333 483.233C245.386 480.107 245.926 476.832 245.933 473.533C246.5 469.733 245.4 467.6 243.267 466.533V466.5ZM240 483.8C238.933 484.867 236.767 484.867 235.133 484.867C233.5 484.867 232.433 484.333 231.367 483.8C230.267 482.733 229.7 481.633 229.7 480.567C229.7 479.467 230.267 478.4 231.9 477.3C233.5 476.233 234.567 476.233 236.233 476.233C237.833 476.233 238.9 476.233 240.567 477.3C242.167 478.4 242.7 479.467 242.7 480.567C242.142 481.889 241.202 483.015 240 483.8ZM158.367 468.667C158.653 468.977 159.046 469.168 159.467 469.2C160.533 469.2 162.133 467.033 164.333 463.267C165.4 463.8 165.933 464.867 167 465.933C168.1 467.033 168.667 467.6 169.2 467.6C169.733 467.6 170.8 466.5 171.867 464.867C173.533 462.733 174.067 461.1 174.067 460C174.038 459.243 173.826 458.505 173.448 457.849C173.071 457.193 172.54 456.638 171.9 456.233C170.8 454.6 169.733 454.067 168.633 454.067C168.1 454.067 167.567 455.167 167.033 456.233C165.933 457.867 165.4 458.933 164.333 460.567C163.6 459.35 162.69 458.249 161.633 457.3C160.533 456.233 159.467 455.7 158.933 455.7C158.367 455.7 157.833 457.3 156.2 460.033C155.181 461.49 154.457 463.132 154.067 464.867L155.667 466.533C156.767 467.033 157.833 468.133 158.367 468.667ZM277.3 462.733C278.367 463.8 279.467 464.333 280 464.867C280.272 465.182 280.653 465.384 281.067 465.433C282.167 465.433 283.8 463.267 285.933 459.467C287.033 460 287.567 461.1 288.633 462.167C289.733 463.267 290.3 463.8 290.8 463.8C291.367 463.8 292.433 462.733 293.5 461.1C295.167 458.933 295.667 457.3 295.667 456.233C295.643 455.471 295.434 454.726 295.056 454.064C294.678 453.401 294.144 452.841 293.5 452.433C292.433 451.367 291.367 450.3 290.267 450.3C289.733 450.3 289.2 450.833 288.633 452.433C287.567 454.1 287.033 455.167 285.967 456.767C285.206 455.57 284.287 454.482 283.233 453.533C282.167 452.433 281.067 451.9 280.567 451.9C280 451.9 279.467 453.533 277.833 456.233C276.799 457.698 276.063 459.351 275.667 461.1L277.3 462.733ZM369.2 444.867C368.633 445.967 368.1 446.533 367.567 447.6L365.933 450.833C365.265 451.978 364.898 453.274 364.867 454.6C364.333 455.7 364.333 456.767 364.333 458.4C364.333 460.567 363.8 463.267 364.333 467.067V475.7C364.333 477.867 363.8 480.033 363.233 482.167C362.7 484.333 362.7 485.433 362.7 485.433V485.967C362.7 485.967 363.233 485.967 363.8 485.433C364.333 484.867 364.333 484.333 364.867 483.8C365.4 482.733 365.933 481.1 367.033 478.933C368.135 476.179 368.679 473.233 368.633 470.267C368.633 468.667 369.2 467.033 369.2 464.867V444.867C369.2 444.333 369.2 444.333 368.633 444.333C369.733 443.8 369.2 444.333 369.2 444.867ZM408.633 514.067C408.1 514.067 407.567 515.167 405.967 517.867C405.073 519.219 404.345 520.674 403.8 522.2C403.8 522.733 403.8 522.733 404.333 523.267L405.933 524.867L407.567 526.533L408.633 527.6C409.2 527.6 409.733 526.5 411.367 524.867C412.433 522.733 412.967 521.633 412.967 520C412.967 518.933 412.433 517.867 411.367 516.233C410.267 515.167 409.7 514.067 408.633 514.067ZM423.233 461.633C422.7 463.267 421.633 464.333 421.067 464.333C420.254 464.994 419.357 465.543 418.4 465.967C416.733 466.5 415.667 467.6 415.133 467.6C413.767 468.542 412.505 469.626 411.367 470.833C410.8 471.9 409.2 474.067 408.1 477.3C406.5 480.567 405.933 482.733 405.433 482.733C404.333 483.8 403.233 485.4 401.1 487.067C401.1 487.067 400.533 487.6 398.367 488.667C395.7 490.3 394.033 491.367 392.967 491.9C391.9 492.433 391.367 493 391.367 493.533C390.267 494.067 390.267 494.6 390.267 495.167C390.267 495.7 391.367 495.7 391.9 495.7C392.967 495.7 394.567 495.7 396.767 495.167C398.367 494.6 400 494.6 401.1 494.067C403.512 493.006 405.439 491.079 406.5 488.667C407.033 487.033 408.1 484.333 409.167 481.667C409.651 480.271 410.398 478.982 411.367 477.867C411.367 477.3 411.9 477.3 412.967 476.767C413.5 476.233 415.667 475.167 418.933 473.533C421.067 472.433 423.267 468.667 425.4 461.633C425.933 460.567 425.4 459.467 425.4 459.467C424.333 459.467 423.8 460.033 423.233 461.633ZM412.967 500.567C412.433 500.567 411.9 501.633 410.8 503.233C410.267 504.333 409.2 505.967 408.633 507.033C408.085 505.715 407.156 504.589 405.967 503.8C404.867 502.733 403.8 502.167 403.233 502.167C402.7 502.167 402.167 503.8 400.567 506.5C398.9 509.2 398.367 511.367 398.367 511.367L401.067 514.067C401.867 514.918 402.788 515.648 403.8 516.233C404.867 516.233 406.467 514.067 408.133 509.733C409.116 510.742 410.199 511.646 411.367 512.433C412.433 513.533 412.967 514.1 413.5 514.1C414.067 514.1 415.167 513 416.2 511.367C417.3 509.2 418.367 507.6 418.367 505.967C418.343 505.204 418.134 504.46 417.756 503.797C417.378 503.135 416.844 502.575 416.2 502.167C414.6 501.1 413.533 500.567 412.967 500.567ZM475.667 498.4C475.133 498.4 474.6 498.933 474.067 500.567C472.967 502.167 472.433 503.233 471.367 504.9C470.8 503.8 469.7 502.733 468.633 501.633C467.567 500.567 466.5 500 465.967 500C465.4 500 464.867 501.667 463.233 504.333C462.199 505.798 461.463 507.451 461.067 509.2L462.733 510.833C463.8 511.9 464.867 512.433 465.4 513C465.686 513.311 466.079 513.501 466.5 513.533C467.567 513.533 469.167 511.367 471.367 507.6C472.433 508.133 472.967 509.2 474.033 510.267C475.133 511.367 475.7 511.933 476.2 511.933C476.767 511.933 477.867 510.833 478.933 509.2C480.533 507.033 481.067 505.433 481.067 504.333C481.042 503.58 480.835 502.844 480.463 502.188C480.092 501.532 479.567 500.975 478.933 500.567C477.267 499.467 476.2 498.4 475.667 498.4ZM391.9 475.167C391.9 470.3 389.733 466.5 384.867 463.267C383.8 462.733 383.233 462.733 383.233 463.8C381.633 467.6 380 470.8 378.9 473C378.367 474.067 378.9 474.6 379.467 475.167C383.8 478.4 385.933 481.1 385.933 483.267C385.933 483.8 384.867 485.433 382.7 487.6C380.533 489.733 377.833 491.933 375.133 494.067C373.5 495.167 372.967 495.7 372.967 496.233C372.967 496.233 372.967 496.767 373.5 496.767H375.167C378.982 495.867 382.504 494.008 385.4 491.367C387.097 489.586 388.553 487.591 389.733 485.433C390.8 481.633 391.9 478.933 391.9 475.167ZM347.567 437.3C348.1 437.3 349.2 436.233 350.267 434.067C351.144 432.576 351.7 430.918 351.9 429.2C351.9 428.133 350.8 427.033 349.733 425.433C348.1 423.8 347.033 423.267 346.5 423.8C345.933 423.8 345.4 425.433 343.8 428.133C342.133 430.8 341.633 432.467 341.633 433.533C341.633 434.067 341.633 434.6 342.167 434.6C342.7 435.167 343.8 435.7 344.833 436.767C346.5 436.767 347.033 437.3 347.567 437.3ZM132.967 391.9C132.967 391.9 134.067 390.833 135.133 388.667C137.3 388.667 139.467 387.033 141.633 383.8C143.745 380.793 144.874 377.207 144.867 373.533C144.867 372.433 144.867 371.9 144.333 371.9C143.8 371.9 143.8 372.433 143.233 374.067C142.929 375.243 142.384 376.344 141.633 377.3C141.067 378.4 140 378.967 139.467 378.967C138.933 378.967 138.367 378.967 136.767 378.4H135.667C135.133 378.4 134.6 379.467 134.067 381.633C132.967 383.8 132.433 384.867 131.367 384.867H127.033C125.111 385.933 123.448 387.413 122.167 389.2C120.093 391.052 117.378 392.021 114.6 391.9C112.433 391.9 110.267 391.367 109.2 390.3C107.695 389.461 106.537 388.114 105.933 386.5C105.4 384.333 104.867 382.733 104.867 381.633V377.3C104.867 376.767 104.867 375.167 105.4 371.9C105.933 368.667 106.5 362.733 107.567 353.533C108.633 344.333 109.2 338.4 109.733 335.167C109.733 334.6 109.733 334.6 109.2 334.6C109.2 334.6 108.633 334.6 108.1 335.167C105.433 341.633 103.767 345.967 103.233 348.667C101.633 357.333 100.567 365.433 99.4667 372.433C98.3667 380 98.3667 385.433 98.3667 389.2C98.3667 394.067 99.4667 397.867 100.533 401.1C102.167 404.333 104.867 405.967 108.633 405.967C111.9 405.967 115.133 403.8 117.833 400C119.404 397.493 121.427 395.3 123.8 393.533C124.867 393 125.4 393 126.467 393C127.033 393 128.133 393 129.2 393.533C130.8 394.6 131.867 393.533 132.967 391.9ZM355.667 455.167C354.6 455.7 354.067 455.7 353 455.7C351.478 455.389 350.015 454.838 348.667 454.067C346.5 453 344.333 453 343.233 453C341.728 453.031 340.248 453.396 338.9 454.067C337.622 454.753 336.664 455.914 336.233 457.3C335.551 458.036 335.16 458.996 335.133 460C334.6 461.1 334.6 461.667 335.133 461.667C335.133 461.667 335.667 461.667 336.2 461.1C336.767 460 337.3 458.933 338.367 458.4C339.103 457.718 340.063 457.327 341.067 457.3C341.633 457.3 342.733 457.3 343.233 457.867C343.8 457.867 343.8 457.867 344.333 458.4C344.867 458.4 344.867 458.4 345.4 458.933C346.5 459.467 347.033 459.467 347.567 460C348.1 460 348.633 460.567 349.2 461.1C348.633 461.633 348.1 462.733 347.033 463.8C346.5 464.333 344.867 465.967 341.633 468.667C338.875 471.086 335.775 473.085 332.433 474.6C330.534 475.397 328.54 475.946 326.5 476.233H324.833C324.833 474.6 324.833 473.533 324.333 474.067C323.8 474.6 322.167 476.233 319.467 477.867C316.729 479.446 313.822 480.709 310.8 481.633C307.81 482.609 304.744 483.334 301.633 483.8C298.599 484.391 295.523 484.748 292.433 484.867C289.2 484.867 286.5 485.433 283.767 485.433C280.533 485.433 276.767 485.433 272.433 484.867C268.927 484.645 265.471 483.927 262.167 482.733C260 481.633 258.933 480 258.367 477.3C258.367 475.7 257.833 474.633 257.3 474.633C256.767 474.633 256.2 476.233 256.2 478.967C255.667 481.633 255.667 484.333 255.667 486.5C255.667 490.3 256.767 493 259.467 494.6C260.533 495.7 263.233 496.233 266.467 496.233C269.733 496.767 272.433 496.767 275.133 496.767C278.933 496.767 283.233 496.767 288.133 496.233C292.433 495.7 296.767 495.167 300 494.067C303.8 493 306.5 491.9 309.733 490.833C312.958 489.639 315.907 487.802 318.4 485.433C320.533 484.333 322.167 482.167 324.333 479.467L328.1 480.567L332.433 481.633C333.5 481.633 334.6 481.633 335.667 480.567C336.276 479.887 337.012 479.332 337.833 478.933L339.467 477.3L348.133 469.2C349.733 467.6 350.8 467.033 351.367 465.967C352.505 464.759 353.767 463.675 355.133 462.733L358.367 460.567C359.467 460 360 458.933 360 458.4C360 457.867 360.533 457.3 360.533 456.767C360.533 456.233 360.533 455.7 361.067 455.167C361.633 454.067 361.067 454.067 361.067 454.067C357.3 454.067 356.2 454.6 355.667 455.167ZM487 460.567C487.714 460.588 488.424 460.453 489.081 460.171C489.737 459.888 490.324 459.466 490.8 458.933C491.735 457.606 492.466 456.145 492.967 454.6C493.5 453 494.067 451.933 494.067 451.367V449.733C494.067 449.2 494.067 449.2 493.5 449.2C493.5 449.2 492.967 449.733 492.967 450.3C491.9 451.9 490.8 452.967 490.8 452.967C490.267 453.533 488.633 453.533 487.033 452.967C486.08 453.186 485.169 453.558 484.333 454.067C483.233 454.6 482.167 455.7 481.067 457.867C480.336 458.894 479.364 459.726 478.236 460.289C477.109 460.853 475.86 461.132 474.6 461.1C472.851 461.055 471.155 460.486 469.733 459.467C468.1 457.867 467.033 455.133 467.033 451.367C467.033 449.733 467.567 446.5 468.1 441.633C468.1 440 468.633 437.867 469.2 434.067C469.2 433.533 469.733 433 469.2 432.433H468.633C467.53 434.131 466.634 435.955 465.967 437.867C465.4 438.933 465.4 440 464.867 442.2C464.333 443.8 464.333 445.433 463.8 447.033C463.233 449.2 463.233 451.367 462.7 453.533L462.167 459.467V462.167C462.167 463.267 461.633 464.333 460.533 465.967C460 467.033 459.467 468.133 458.367 469.733L456.767 472.433C455.822 473.947 455.093 475.585 454.6 477.3C454.067 478.967 453.5 480.567 453.5 481.633C453.5 483.267 455.133 484.867 457.833 486.5C460.533 487.6 461.633 488.667 461.633 489.2C461.633 492.433 460 495.7 456.2 498.4C451.889 501.759 446.528 503.483 441.067 503.267C438.201 503.459 435.353 502.697 432.967 501.1C431.536 499.928 430.399 498.437 429.646 496.747C428.894 495.057 428.547 493.215 428.633 491.367C428.633 488.667 429.733 485.433 431.367 481.1C432.433 478.4 434.033 474.6 436.767 468.1C437.3 467.6 437.3 466.5 437.3 465.967C437.3 465.433 437.3 464.867 436.767 464.867C436.2 464.867 436.2 465.433 435.667 466.533C435.133 467.033 435.133 467.6 434.6 468.133C434.067 468.667 434.067 469.733 433.5 470.3C432.967 471.367 432.433 472.967 431.9 473.533C431.367 474.6 431.367 475.167 430.8 475.167C430.267 476.767 429.2 478.933 428.133 481.633C426.823 484.381 425.903 487.298 425.4 490.3C424.333 493.533 424.333 496.233 424.333 498.4C424.333 503.267 425.4 507.067 427.567 510.3C428.773 512.03 430.393 513.431 432.28 514.374C434.166 515.317 436.259 515.773 438.367 515.7C440.533 515.7 442.167 515.167 444.333 514.6C445.933 514.067 447.567 513 449.2 511.933C454.067 508.667 457.3 503.8 460 498.4C461.308 495.419 462.389 492.344 463.233 489.2C463.8 486.533 464.333 484.333 464.333 481.633C464.333 480 464.333 478.4 463.8 477.867C463.233 477.3 462.7 476.233 462.133 475.7C461.067 475.167 460.533 474.6 459.467 474.067C458.367 473.533 458.367 473 458.367 472.433C458.367 471.9 459.467 470.3 460.533 468.1C461.067 467.6 461.633 467.033 461.633 466.5C462.167 467.033 462.167 468.133 462.7 468.667C464.333 470.833 466.5 472.433 469.2 472.433C471.867 472.433 474.6 470.833 476.767 467.033C478.933 463.267 480.533 461.1 482.7 460.567C484.867 460 485.933 460 487.033 460.567H487ZM131.333 249.233C123.024 257.721 114.172 265.66 104.833 273C100.533 276.767 96.7667 280 92.9667 282.733C89.7333 285.4 84.8667 289.2 79.4667 293.533C74.0667 297.867 69.7333 301.633 67.5667 303.8C66.146 305.287 64.8836 306.918 63.8 308.667C62.7 311.367 61.6333 313.533 61.0667 315.167C61.0667 315.7 62.1667 315.167 63.2333 314.067C63.8 313.533 64.8667 313 65.4 312.433C65.9333 311.9 67.0333 311.367 67.5667 310.833L78.3667 302.167L84.8667 297.3C87.0333 295.7 89.2 294.067 90.8 292.967C92.4333 291.367 95.6667 289.2 100 285.967C104.333 282.733 108.1 278.967 112.433 275.7C116.2 272.433 120 269.2 123.233 265.433C127.033 261.633 130.267 257.867 133.5 254.1C136.767 250.3 138.933 245.967 140.533 241.1C141.067 240 141.067 238.933 140.533 239.467C139.467 241.1 136.2 244.333 131.367 249.2L131.333 249.233ZM118.367 473C117.3 471.367 115.7 470.3 114.033 468.667L113.5 469.733C114.6 470.3 115.167 471.367 115.667 472.433L117.3 475.7C117.9 476.873 118.263 478.153 118.367 479.467C118.367 481.1 118.933 482.167 118.933 483.8C118.933 485.967 118.933 487.6 118.367 489.733C117.874 491.448 117.145 493.086 116.2 494.6C115.133 496.233 114.6 497.3 112.967 498.4L113.5 498.933C115.203 497.773 116.673 496.303 117.833 494.6C119.066 492.986 119.982 491.154 120.533 489.2C121.067 487.6 121.067 485.433 121.067 483.267C121.067 481.1 120.533 478.933 120.533 477.3C120.533 476.233 119.467 474.667 118.367 473ZM96.7667 355.667C96.2 355.667 95.6667 356.767 94.6 358.4C93.5 360.567 92.4333 361.633 91.9 362.733C90.6444 363.777 89.1594 364.508 87.5667 364.867C85.4 365.967 83.8 367.033 82.7 367.6C80.9734 368.923 79.3467 370.371 77.8333 371.933C76.7667 373.533 75.1667 376.233 72.9667 381.1C70.8 385.967 69.7333 388.667 69.2 388.667C67.3708 390.838 65.1698 392.666 62.7 394.067C62.7 394.067 61.6333 394.6 58.9333 396.767C55.6667 398.933 52.9667 400.567 51.9 401.633C50.8 402.733 49.7333 403.267 49.2 403.8C48.1 404.867 47.5667 405.433 47.5667 405.967C48.1 406.5 48.6333 407.033 50.2667 407.033C51.9 407.033 54.0667 406.5 56.7667 405.967C59.4333 405.433 61.6333 404.867 63.2333 404.333C66.5015 402.687 69.1542 400.035 70.8 396.767C71.9 394.6 72.9667 390.833 75.1333 386.5C75.9655 384.564 77.0529 382.748 78.3667 381.1C78.9831 380.428 79.7174 379.874 80.5333 379.467C81.6333 378.933 84.3333 377.3 88.6333 375.133C91.9 373.533 94.6 368.133 97.3 358.933C97.3 356.767 97.3 355.667 96.7667 355.667ZM82.1667 426.5C81.6333 426.5 80.5333 428.133 78.3667 431.9C77.0348 433.931 75.9494 436.113 75.1333 438.4C75.1333 438.933 75.6667 439.467 76.2 440C76.7667 440.567 77.8667 441.1 78.3667 442.167L80.5333 444.333C81.0667 444.867 81.6333 445.433 82.1667 445.433C82.7 445.433 83.8 444.333 85.4 441.633C87.0333 438.967 88.1 436.767 88.1 435.167C88.1 433.5 87.5667 431.9 85.9333 429.733C84.3333 427.6 83.2667 426.5 82.1667 426.5ZM4.83333 377.833C4.33333 377.833 3.8 378.4 3.8 379.5C2.45447 384.998 1.54058 390.593 1.06667 396.233C1.06667 400 2.16667 402.733 4.33333 404.333C7 406.5 11.3333 407.6 17.8333 407.6C24.8333 407.6 30.8333 405.933 35.6667 403.267C38.9333 401.633 41.0667 399.467 43.8 397.3C46.4667 394.633 49.2 390.3 51.9 385.433C54.5667 380.567 56.7667 373.533 58.3667 364.867C59.4667 358.4 60 352.433 60 347.033C60 344.867 60 340.567 60.5333 333.533C60.5333 331.367 60.5333 328.667 61.0667 325.967C61.6333 322.733 61.6333 321.1 61.6333 320C61.6333 318.933 61.6333 317.867 62.1667 317.333V315.667H61.0667C60.5333 316.767 59.4667 319.467 57.3 323.8C55.6667 327.6 54.6 330.3 53.5 331.9C53.5 332.433 52.9667 334.6 52.9667 337.867C52.9667 339.467 52.9667 345.433 52.4333 354.6C52.4333 362.733 51.9 368.133 51.3667 371.933C51.0639 374.625 50.1272 377.207 48.6333 379.467C45.8184 383.775 41.64 387.014 36.7667 388.667C32.9667 390.3 28.1 390.833 23.2333 390.833C21.6333 390.833 19.4667 390.833 16.7667 390.3C14.7594 389.825 12.7693 389.28 10.8 388.667C9.14362 388.084 7.72134 386.979 6.7474 385.518C5.77345 384.057 5.30058 382.32 5.4 380.567V378.4C5.93333 378.4 5.4 377.867 4.86667 377.867L4.83333 377.833ZM26.5 368.133H24.8333C23.8 368.133 23.8 368.667 23.8 369.2C23.8 370.833 24.8667 371.367 26.4667 371.367C29.2 371.367 30.8 370.833 31.9 369.2C32.9667 367.6 32.9667 366.533 32.4333 365.433C31.9 364.333 31.9 363.267 31.9 362.733C32.4333 361.633 33.5 361.067 35.1333 361.067C36.7667 361.067 37.8333 360.567 37.8333 358.933C37.8333 357.867 37.3 357.3 36.2 357.3C34.593 357.266 33.0369 357.865 31.8667 358.967C31.3058 359.513 30.9087 360.205 30.7203 360.965C30.5318 361.724 30.5594 362.522 30.8 363.267C31.3667 364.867 31.3667 365.933 30.2667 366.5C29.7943 367.028 29.2129 367.448 28.5626 367.73C27.9123 368.012 27.2086 368.15 26.5 368.133ZM121.067 320C119.675 322.187 118.587 324.553 117.833 327.033C117.833 327.6 118.933 328.667 121.067 330.3C123.233 331.9 124.867 332.967 124.867 332.967C126.5 332.967 128.633 330.3 131.367 324.333C132.433 324.867 134.033 326.5 135.7 328.133C136.767 329.2 137.833 329.733 138.367 329.733C138.933 329.733 140.533 328.133 142.167 325.967C143.8 323.267 144.833 321.1 144.833 318.967C144.833 317.3 143.8 315.7 142.167 313.533C140.533 311.9 138.933 310.833 137.833 310.833C137.3 310.833 136.767 311.9 135.167 314.6C134.067 316.233 132.967 317.867 131.9 320C131.04 318.397 129.938 316.935 128.633 315.667C127.033 314.067 125.967 313.533 124.867 313.533C124.333 314.067 123.233 316.233 121.067 320ZM92.4333 422.733C93.8605 420.627 94.7843 418.22 95.1333 415.7C95.1333 414.067 94.0667 412.433 92.4333 410.3C90.8 408.667 89.2 407.6 88.1 407.6C87.5667 407.6 87.0333 408.667 85.4333 411.367C84.3333 413 83.2333 415.167 82.1667 416.767C81.3167 415.165 80.2263 413.704 78.9333 412.433C77.2667 410.833 75.6667 410.3 75.1333 410.3C74.6 410.3 73.5 412.433 71.3667 416.767C69.2 421.1 68.1 423.267 68.1 423.8C68.1 424.333 69.2 425.433 71.3667 427.033C72.4183 428.188 73.7018 429.108 75.1333 429.733C76.7667 429.733 78.9333 427.067 81.6333 421.067C82.7 422.167 84.3 423.267 85.9667 424.867C87.0333 425.967 88.1 427.033 88.6333 427.033C89.2 427.033 90.3 425.467 92.4333 422.733ZM83.2333 470.833C82.7 470.833 82.7 470.833 82.1667 471.367C82.1667 471.367 81.6333 471.9 81.6333 473L80.5333 475.167C80.5333 475.167 80.5333 475.7 81.0667 475.7C81.6333 475.7 81.6333 476.233 81.6333 476.233C81.6333 476.233 81.6333 476.767 81.0667 476.767L80 477.867L78.3667 479.467C77.8333 480 77.3 481.1 76.7667 481.633C76.0842 482.37 75.6932 483.33 75.6667 484.333C75.1333 485.433 75.1333 485.967 75.1333 486.5C75.1333 487.033 75.1333 487.6 75.6667 488.133C75.6667 488.667 76.2 488.667 76.7667 489.2C77.8333 489.733 78.3667 490.3 78.9333 490.3L79.4667 490.833C79.2436 491.775 78.8723 492.675 78.3667 493.5C77.7715 494.658 76.8425 495.61 75.7 496.233C74.6 496.767 74.0333 497.3 72.9667 497.3C71.9 497.3 70.8 497.867 69.7333 497.867C68.1 497.867 66.5 497.3 65.9333 496.233C64.8557 495.053 64.2816 493.498 64.3333 491.9C64.3333 490.833 64.3333 489.733 64.8667 488.667C64.8667 488.133 65.4 486.5 66.5 483.8C67.0333 482.167 67.5667 481.1 67.5667 480.567V479.467C67.5667 479.467 67.0333 480 66.5 481.1C65.9333 481.633 65.9333 482.733 65.4 483.267C64.3333 485.433 63.8 487.6 62.7333 489.2C62.1509 491.143 61.782 493.144 61.6333 495.167C61.6333 497.833 62.1667 500 63.2333 501.1C63.7059 501.806 64.3538 502.377 65.1135 502.756C65.8732 503.136 66.7185 503.312 67.5667 503.267C71.3667 503.267 74.5667 501.633 76.7667 497.867C77.8333 496.233 78.3667 494.6 79.4333 492.433C80 490.3 80.5333 488.667 80.5333 487.033V485.433C80.5333 484.867 80 484.867 79.4667 484.333C78.9333 483.8 78.3667 483.8 77.8333 483.267C77.3 482.733 76.7667 482.733 76.7667 482.167C76.7667 481.633 76.7667 481.633 77.8333 481.1L78.9333 480C79.7477 479.351 80.6444 478.813 81.6 478.4C82.1667 478.4 82.7 477.867 84.3333 476.767C84.8667 476.233 85.4 475.7 86.5 475.167C87.0333 474.067 87.5667 473.5 87.5667 473C87.5667 472.433 87.0333 471.9 86.5 471.367C85.4 471.367 84.3333 471.367 83.2333 470.833ZM111.367 477.3C110.8 478.4 110.267 478.967 110.267 478.967H109.733C109.2 479.467 109.2 479.467 109.2 480C108.1 480 108.1 480.567 107.567 480.567H106.5C105.933 480.567 104.833 481.1 103.8 482.733C103.119 483.337 102.554 484.06 102.133 484.867C102.133 484.333 101.633 484.333 101.633 483.8C101.067 483.267 100.533 482.733 99.4667 482.733C98.9333 482.733 98.3667 482.733 97.8333 483.267L96.7667 484.333L95.6667 485.433C95.1333 485.967 94.6 485.967 93.5 485.967C92.5079 485.932 91.5613 485.542 90.8333 484.867C90.2667 483.8 90.2667 482.733 90.2667 481.633V479.467C90.2667 478.4 90.2667 477.3 90.8 476.233L91.9 469.733V467.033C91.3667 467.6 91.3667 468.667 90.8 469.733C90.2667 470.833 90.2667 471.9 89.7333 471.9C89.7333 473.533 89.2 476.233 88.6333 479.467C88.1 482.733 88.1 484.867 88.1 484.867C88.1 486.533 88.6333 488.133 89.2 489.2C89.4513 489.691 89.8332 490.103 90.3037 490.392C90.7741 490.68 91.315 490.833 91.8667 490.833C92.4333 490.833 92.9667 490.833 93.5333 490.3C93.8139 490.276 94.0765 490.152 94.2726 489.95C94.4686 489.747 94.5849 489.481 94.6 489.2C95.1333 488.667 95.6667 488.133 96.2 487.033C96.7667 485.967 97.8667 485.433 98.3667 485.433C98.9333 485.433 99.4667 485.433 100 485.967C100.533 486.5 100.533 487.033 100.533 487.6V490.833C100.533 490.833 100.533 491.367 101.067 491.367C101.067 491.367 101.633 490.833 101.633 489.733C102.167 488.133 102.7 487.067 103.233 485.4C103.233 484.867 103.8 484.333 104.333 483.8C104.867 482.733 105.4 482.733 105.933 482.167H108.1L108.633 481.633L109.2 481.1C109.733 480.567 109.733 480.567 110.267 480.567C110.8 480.567 111.367 480 111.9 478.933C112.433 477.867 112.967 477.3 112.967 476.233V475.7C111.367 476.767 111.367 476.767 111.367 477.3ZM62.7 480.567C62.7 480 63.2333 479.467 63.2333 479.467V478.933H62.1667C62.1667 478.933 61.0667 478.933 60 478.4C59.4667 478.4 58.9333 477.867 58.9333 477.867C58.3667 477.867 57.8333 478.4 56.7667 478.933C56.0945 479.55 55.5409 480.284 55.1333 481.1L52.4333 485.433C51.4296 485.407 50.4698 485.016 49.7333 484.333C49.2 483.8 48.6333 482.733 48.6333 481.1V478.933C48.6333 477.867 48.6333 476.767 49.2 475.7L50.2667 469.2V466.5C49.7333 467.033 49.7333 468.133 49.2 469.2L48.1 471.367C48.1 473 47.5667 475.7 47.0333 478.933C46.5 482.167 46.5 484.333 46.5 484.333C46.5 485.967 47.0333 487.033 47.5667 488.133C48.0458 488.66 48.6339 489.076 49.2902 489.352C49.9465 489.629 50.6551 489.759 51.3667 489.733C52.9667 489.733 54.0333 489.2 55.7 488.667C56.9785 487.98 57.9361 486.819 58.3667 485.433C58.3667 485.433 58.9333 484.333 60 483.267C60.5333 482.733 60.5333 482.167 61.0667 481.633L61.6333 481.1C61.6333 480.567 62.1667 480.567 62.1667 480.567C62.1667 481.633 62.7 481.1 62.7 480.567ZM57.3 484.333C56.7667 484.867 56.2 484.867 55.6667 485.433C55.6667 485.433 55.1333 485.433 54.6 485.967H52.9667L55.1333 482.733C55.6667 482.167 55.6667 481.633 56.2 481.633C56.7667 481.1 57.3 481.1 57.8667 481.1H58.9333C59.4667 481.1 60 481.633 60 481.633C59.3906 482.783 58.45 483.724 57.3 484.333ZM59.4667 464.867C58.9333 464.867 58.9333 464.867 59.4667 464.867L58.9333 464.333C58.9333 464.333 58.9333 464.867 58.3667 464.867C57.8333 465.433 57.8333 465.967 57.3 466.533C57.3 467.033 56.7667 467.6 56.2 468.133C56.2 468.133 56.2 468.667 55.6667 469.2C55.6667 469.2 55.6667 469.733 56.2 469.733C56.2 469.733 56.7667 470.3 57.3 470.3L58.3667 471.367L58.9333 471.9C58.9333 471.9 59.4667 471.9 59.4667 471.367C60 470.833 60.5333 470.3 60.5333 469.733C60.5333 469.2 61.0667 468.667 61.0667 468.133V467.033C61.0667 466.5 61.0667 466.5 60.5333 465.967L59.4667 464.867ZM7.03333 473.533C8.1 471.9 8.63333 470.833 10.2667 469.733L9.73333 469.2C8.03046 470.361 6.56057 471.83 5.4 473.533C4.33333 475.167 3.23333 476.767 2.73333 478.933C2.16667 481.1 2.16667 482.733 2.16667 484.867C2.16667 487.033 2.16667 489.2 2.7 490.833C3.04042 492.863 3.98082 494.743 5.4 496.233C6.5 497.867 8.1 498.933 9.73333 500.567L10.2667 500C9.2 499.467 8.63333 498.4 8.1 497.333L6.5 494.067C5.88817 492.896 5.51431 491.616 5.4 490.3C5.4 488.667 4.86667 487.6 4.86667 485.967C4.86667 483.8 4.86667 482.167 5.4 480C5.93333 476.767 6.5 475.167 7.03333 473.533ZM43.2333 471.367C42.7 471.367 42.1667 471.367 42.1667 471.9L40.5333 473.533C40 474.067 39.4667 475.167 38.3667 475.7C37.8333 476.767 37.3 477.3 36.7667 478.367H34.6C34.0667 478.367 33.5 478.933 32.9667 479.467C32.9667 480 32.4333 481.1 32.4333 481.633V485.433C32.4333 485.967 32.4333 487.033 31.9 487.033C31.9 487.6 31.9 488.133 31.3667 489.2C30.8 490.3 30.2667 491.9 29.7 492.433C29.2 493 28.6333 493.533 27.5667 494.6C28.1 495.167 27.0333 495.7 26.5 496.233C25.9333 496.767 24.8333 496.767 24.3333 497.3C23.2333 497.3 22.1667 497.867 20 497.867C18.4918 497.826 17.0116 497.45 15.6667 496.767C15.1442 496.291 14.7308 495.708 14.4546 495.058C14.1784 494.408 14.0461 493.706 14.0667 493C14.0667 491.9 14.0667 490.833 14.6 489.733C14.6 489.2 15.1333 488.667 15.1333 487.6L16.7667 484.333C16.7667 483.8 17.3 483.267 17.3 482.733V482.167L16.7667 482.733C16.7667 482.733 16.7667 483.267 16.2 483.8C15.6667 484.867 15.1333 485.433 14.6 486.5C14.6 487.033 14.0667 487.6 13.5 488.667C12.9667 489.733 12.9667 491.367 12.4333 492.433C12.4333 493.533 11.9 494.6 11.9 495.7C11.9 498.367 12.4333 501.1 14.5667 502.167C15.7422 503.256 17.2976 503.843 18.9 503.8C20 503.8 21.0667 503.8 22.1667 503.267C23.5853 502.875 24.8813 502.129 25.9333 501.1C27.7862 499.67 29.2717 497.819 30.2667 495.7C31.3667 494.067 31.9 492.433 32.9667 489.733C33.5 488.133 34.0667 486.5 34.0667 485.4C34.0667 484.867 34.6 484.333 34.6 483.8V482.733C34.6 482.167 34.6 482.167 35.1333 482.167H36.2C36.7667 482.167 37.3 482.167 38.3667 481.633C39.928 481.264 41.2881 480.309 42.1667 478.967C42.7 477.867 43.2333 477.3 43.8 475.7C44.3982 474.706 44.7629 473.589 44.8667 472.433C44.8667 471.9 44.8667 471.367 44.3333 470.833C44.3333 471.9 43.8 471.367 43.2333 471.367ZM42.7 476.233C42.1667 476.767 41.6333 477.3 41.0667 477.3C40.5333 477.867 40 477.867 39.4667 477.867H38.3333C38.3333 477.867 38.3333 477.3 38.9 477.3C39.4333 476.767 39.9667 476.233 39.9667 475.7C40.5 474.6 41.6 474.067 42.1333 474.067C42.6667 474.067 43.2 474.067 43.2 474.6C43.7667 474.6 43.7667 475.167 43.7667 475.167C43.7667 475.7 43.2 475.7 42.6667 476.233H42.7ZM125.933 309.733C127.033 310.3 128.1 311.367 129.2 312.433C129.98 313.28 130.878 314.009 131.867 314.6C132.433 314.6 133.533 313 135.133 310.267C136.442 308.157 137.188 305.747 137.3 303.267C137.3 301.633 136.2 299.467 134.6 297.867C132.967 296.233 131.367 295.167 130.267 295.167C129.733 295.167 128.633 297.3 126.5 301.1C124.833 304.867 123.8 307.033 123.8 307.6L125.933 309.733ZM277.833 167.067H218.367L211.9 170.3H164.333L157.3 167.033H63.2333C49.7333 167.033 50.8 176.767 50.8 176.767C50.8 185.433 62.7 185.433 62.7 185.433H174.6L176.2 182.733H191.867L194.067 184.867H276.733C296.733 184.867 313.5 181.633 313.5 181.633H800V172.967H314.067C290.8 166.5 277.833 167.067 277.833 167.067ZM306.5 216.767H134.067C121.067 216.233 122.167 225.967 122.167 225.967C122.7 234.633 133.5 233.533 133.5 233.533H304.833C316.767 233.533 338.933 230.833 338.933 230.833H800V221.633H341.067C322.167 218.4 306.5 216.767 306.5 216.767ZM227.567 191.9H89.2C76.2 191.367 76.7667 201.633 76.7667 201.633C76.2 211.367 87.0333 210.3 87.0333 210.3H226.5C242.167 209.733 259.467 206.5 259.467 206.5H800V197.833H261.067C241.633 191.367 227.567 191.9 227.567 191.9ZM360.567 265.967H274.567L259.467 268.667H235.133L223.8 265.967H162.133C149.2 265.433 150.267 274.633 150.267 274.633C150.267 284.867 161.067 283.8 161.067 283.8H223.233L239.467 280H257.833L273.5 283.267H353.5C366.5 283.267 385.933 279.467 385.933 279.467H800V270.3H386.5C370.833 265.967 360.533 265.967 360.533 265.967H360.567ZM340 241.1H248.667L243.233 244.333H219.467L216.2 241.1H167.567C155.133 240.567 156.233 249.2 156.233 249.2C156.233 260 168.1 258.4 168.1 258.4H213.5L216.2 256.767H248.1L250.267 258.933H337.267C351.367 259.467 370.267 255.7 370.267 255.7H800V246.5H371.333C350.267 241.633 340 241.1 340 241.1ZM215.133 339.467C205.4 340 205.933 346.5 205.933 346.5C205.933 357.3 217.833 355.167 217.833 355.167C222.167 355.167 228.633 351.367 228.633 351.367H800V342.7H227.567C221.067 339.467 215.133 339.467 215.133 339.467ZM367.033 290.3H309.667C292.933 290.3 277.8 295.167 277.8 295.167H258.333C248.485 293.452 238.563 292.184 228.6 291.367H167.567C155.667 291.367 156.233 300.033 156.233 300.033C156.233 309.2 167.033 308.133 167.033 308.133H227.567C237.3 308.133 260 303.267 260 303.267H276.2C287.033 307.6 308.1 308.133 308.1 308.133H360.533C372.094 307.358 383.632 306.268 395.133 304.867H800V295.7H396.767C385.933 292.433 367.033 290.3 367.033 290.3ZM368.633 315.7C352.967 315.167 332.433 320.567 332.433 320.567H258.367L225.4 314.6H185.4C172.967 314.6 174.6 323.8 174.6 323.8C174.6 333 185.933 331.9 184.867 331.9H223.233L256.767 326.5H332.967C349.733 332.433 367.033 331.9 367.033 331.9C378.933 331.9 400 327.567 400 327.567H800V318.4H393C382.167 315.7 368.667 315.7 368.667 315.7H368.633ZM0 0.0333309V8.66667H800V0L0 0.0333309ZM376.767 21.6333H323.767C312.433 22.1667 298.367 25.4333 298.367 25.4333H0V34.1H297.833C308.1 37.3 319.467 38.4 319.467 38.4H377.3C389.733 37.8667 403.8 34.6 403.8 34.6H800V25.4667H401.633C393.418 23.7583 385.117 22.4565 376.767 21.6333ZM791.333 382.167C787 385.967 784.3 389.2 782.133 390.833C778.963 394.008 775.529 396.908 771.867 399.5C766.467 403.8 761.6 407.6 757.267 411.367C753.552 414.296 749.949 417.365 746.467 420.567C745.367 421.633 744.8 422.733 743.767 424.333C742.667 425.967 742.1 427.6 741.6 428.667C741.6 429.2 742.133 428.667 743.2 427.6C743.767 427.033 744.3 427.033 744.833 426.5L746.467 424.867L754.567 418.933C757.233 416.767 760.5 414.6 763.767 411.933C765.9 410.267 768.6 408.133 771.333 405.433C773.467 403.8 775.1 402.167 776.733 401.1C778.333 400 779.4 398.4 780.5 397.867C783.2 395.167 785.367 393.533 786.467 392.433C787.638 391.261 788.719 390.002 789.7 388.667C791.129 387.187 792.392 385.555 793.467 383.8C794.802 382.358 795.905 380.716 796.733 378.933C797.8 376.767 798.333 375.167 798.9 374.067V373C799.967 374.067 797.233 376.767 791.333 382.167ZM375.133 45.9667H269.733C257.3 45.9667 243.233 50.3 243.233 50.3H0V58.4H240.533C248.633 61.0667 264.867 63.2667 264.867 63.2667H373.533C385.4 63.2667 398.933 58.4 398.933 58.4H800V50.8H395.667C388.969 48.6119 382.101 47.0174 375.133 45.9667ZM368.133 70.8333H236.733C228.62 71.3988 220.617 73.0352 212.933 75.7H100.533C93.0849 73.6136 85.515 71.9883 77.8667 70.8333H12.9333C6.46667 70.8333 6.46667 79.5 6.46667 79.5C6.46667 88.1333 12.9333 87.6 12.9333 87.6H74.0333C87 86.5 101.033 82.7333 101.033 82.7333H212.4C222.133 84.8667 234.567 87.0667 234.567 87.0667H364.833C377.267 86.5 389.167 83.2667 389.167 83.2667H800V74.6H390.267C376.767 70.8333 368.133 70.8333 368.133 70.8333ZM509.2 401.633C511.867 398.967 514.067 397.3 515.133 396.233C515.667 395.7 516.767 394.6 518.367 392.433C520 390.833 521.067 389.2 522.167 387.6C523.491 386.156 524.581 384.514 525.4 382.733C526.5 380.567 527.567 378.933 527.567 377.867V376.767L518.9 385.433C515.133 389.2 511.9 391.9 509.733 394.1C506.562 397.264 503.127 400.152 499.467 402.733C496.767 404.867 494.6 406.5 491.9 408.667C489.733 410.833 487.033 412.433 484.333 414.6C480.589 417.506 476.974 420.576 473.5 423.8C472.433 424.867 471.9 425.967 470.833 427.6C470.267 428.667 469.167 430.267 468.633 431.933C468.633 431.933 469.2 431.933 470.3 430.833C471.261 429.816 472.335 428.91 473.5 428.133L481.633 421.633C483.172 420.688 484.622 419.606 485.967 418.4C487.567 417.3 489.2 416.233 490.3 415.167C492.967 413 495.667 410.833 497.833 408.667C504.333 405.433 507.567 402.733 509.167 401.667L509.2 401.633ZM342.167 120H208.1C197.833 119.467 185.433 123.8 185.433 123.8H161.1C150.8 120 142.167 120 142.167 120H28.6333C19.4667 120 20.5333 128.667 20.5333 128.667C20.5333 136.767 27.5667 136.233 27.5667 136.233H138.9C149.2 136.767 161.633 132.433 161.633 132.433H186.5C194.067 136.233 207.033 136.767 207.033 136.767H338.933C355.133 136.767 364.333 133 364.333 133H800V124.867H365.4C349.2 119.467 342.167 120 342.167 120ZM358.933 95.6667H221.067C206.5 95.1667 196.733 99.4667 196.733 99.4667H138.4C122.733 95.7 115.667 95.1333 115.667 95.1333H22.7C14.0333 95.1333 14.6 103.267 14.6 103.267C14.6 111.933 21.6 110.833 21.6 110.833H111.9C119.739 110.231 127.511 108.959 135.133 107.033H195.133C203.233 110.3 216.767 111.9 216.767 111.9H356.767C368.1 111.367 378.933 107.567 378.933 107.567H800V100H379.467C367.567 95.6667 358.933 95.6667 358.933 95.6667ZM323.267 144.867C323.267 144.867 216.2 144.333 206.5 144.867C200.473 145.229 194.493 146.144 188.633 147.6H172.967C167.567 145.933 160 144.333 160 144.333H43.8C31.9 144.333 33.5 153 33.5 153C33.5 161.1 42.7 161.1 42.7 161.1H156.2C161.649 160.442 167.065 159.541 172.433 158.4H188.633C195.133 161.067 203.233 161.633 203.233 161.633H320C330.267 161.633 344.867 157.867 344.867 157.867H800V149.2H345.4C336.2 145.433 323.233 144.867 323.233 144.867H323.267ZM672.433 400.533C673.754 399.099 674.845 397.469 675.667 395.7C676.767 393.533 677.3 391.9 677.833 390.833V389.733C677.833 389.733 675.167 393 669.167 398.4C667.567 400 665.4 401.633 664.333 403.267L660.533 407.033C657.363 410.208 653.929 413.108 650.267 415.7C647.567 417.867 645.4 419.467 642.7 421.633L635.133 427.6C629.733 431.933 626.467 435.167 624.333 436.767C623.257 437.899 622.348 439.178 621.633 440.567C621.067 441.633 620 443.233 619.467 444.9C619.467 444.9 620 444.9 621.067 443.8C621.633 443.267 622.167 443.267 622.733 442.733C623.233 442.167 623.8 441.633 624.333 441.633L632.433 435.7C633.973 434.744 635.424 433.651 636.767 432.433C638.515 431.35 640.146 430.087 641.633 428.667C644.3 426.5 647.033 424.333 649.2 422.167C651.367 420.567 652.967 418.933 654.6 417.833C656.2 416.767 657.267 415.167 658.367 414.6C661.067 411.933 663.233 410.267 664.333 409.2C665.505 408.028 666.586 406.769 667.567 405.433C669.449 404.095 671.095 402.449 672.433 400.567V400.533ZM660 422.733C658.965 424.198 658.229 425.851 657.833 427.6C657.833 428.133 658.367 428.133 658.933 428.667C659.467 429.2 660.533 429.733 661.6 430.833C662.253 431.469 662.994 432.008 663.8 432.433C664.333 432.433 665.4 431.367 666.467 429.2C667.355 427.712 667.923 426.054 668.133 424.333C668.133 423.267 667.567 421.667 665.933 420C664.867 418.933 663.8 417.867 662.7 417.867C661.615 419.379 660.708 421.012 660 422.733ZM531.9 430.3C532.178 430.603 532.557 430.793 532.967 430.833C534.067 430.833 535.667 428.667 537.833 424.867C538.933 425.433 539.467 426.533 540.533 427.6C541.633 428.667 542.167 429.2 542.7 429.2C543.233 429.2 544.333 428.133 545.4 426.533C547.033 424.333 547.567 422.733 547.567 421.633C547.538 420.877 547.326 420.139 546.948 419.482C546.571 418.826 546.04 418.272 545.4 417.867C544.333 416.233 543.233 415.7 542.167 415.7C541.633 415.7 541.067 416.767 540.533 417.867C539.467 419.467 538.933 420.533 537.867 422.2C537.3 421.1 536.2 420 535.133 418.933C534.067 417.867 532.967 417.3 532.433 417.3C531.9 417.3 531.367 418.967 529.733 421.633C528.699 423.098 527.963 424.751 527.567 426.5L529.2 428.133C530.187 428.725 531.119 429.455 531.9 430.3ZM581.633 451.9C581.067 453 580.533 453.533 580 454.6L578.367 457.867C577.694 459.01 577.327 460.307 577.3 461.633C576.767 462.733 576.767 464.333 576.767 465.433C576.767 467.6 576.2 470.3 576.767 474.1V482.733C576.767 484.867 576.2 487.067 575.667 489.2C575.133 491.367 575.133 492.433 575.133 492.433V493C575.133 493 575.667 493 576.2 492.433C576.767 491.9 576.767 491.367 577.3 490.833C577.833 489.733 578.367 488.133 579.467 485.967C580.569 483.212 581.112 480.266 581.067 477.3C581.067 475.7 581.067 474.067 581.633 471.9V451.9C581.633 451.367 581.633 451.367 581.067 451.367C582.167 451.367 581.633 451.367 581.633 451.9ZM568.633 414.6C567.567 415.7 567.033 416.767 565.967 418.4C564.867 420 564.3 421.633 563.8 422.733C563.8 423.267 564.333 422.733 565.4 421.633C565.933 421.1 567.033 420 568.633 418.967C585.4 406.5 601.633 392.967 616.2 378.4C617.3 377.3 618.367 375.167 620 372.433C621.633 369.767 622.167 368.1 621.067 368.667C607.567 381.667 589.733 396.767 568.633 414.6ZM491.9 423.267C491.367 423.267 490.8 424.867 489.2 427.6C488.1 430.267 487.033 431.933 487.033 433C487.033 433.533 487.033 434.067 487.567 434.067C488.1 434.6 489.2 435.167 490.267 436.233C491.367 437.3 492.433 437.3 492.433 437.3C492.967 437.3 494.067 436.233 495.133 434.067C496.01 432.576 496.567 430.918 496.767 429.2C496.767 428.133 495.667 427.033 494.6 425.433C494.067 423.267 492.967 422.733 491.9 423.267ZM497.3 493C498.135 492.491 499.047 492.12 500 491.9C501.008 490.917 501.913 489.834 502.7 488.667C503.8 487.033 504.867 484.333 506.5 480.567C507.033 480 507.033 478.933 507.567 477.867C507.567 476.767 508.1 476.233 508.1 475.7C508.1 475.167 508.1 474.067 508.633 473.533V470.833C508.598 469.088 508.041 467.392 507.033 465.967C505.933 464.867 504.867 463.8 503.233 463.8C502.167 463.8 501.633 464.333 500.567 465.433C499.467 466.5 498.9 468.1 497.833 469.767C497.018 470.887 496.46 472.173 496.2 473.533C495.667 474.6 495.667 475.167 495.667 475.7C495.667 476.767 495.667 477.867 496.767 478.367C497.833 479.467 498.933 479.467 500 479.467H500.533C501.067 479.467 501.067 479.467 501.067 478.933H502.167C501.674 480.648 500.945 482.286 500 483.8C498.933 485.433 497.833 485.967 496.767 487.033C495.667 487.6 493.5 489.2 490.267 491.367C488.1 494.6 486.5 495.7 486.5 496.233H487.033C487.567 496.233 489.2 495.7 491.9 495.167C494.567 494.067 496.233 493.5 497.3 493ZM575.133 421.667V421.1C575.133 421.1 574.6 421.633 574.067 421.633C572.967 422.733 572.433 424.333 571.367 426.5C570.584 427.847 570.021 429.309 569.7 430.833C569.2 431.9 569.2 433 569.2 434.6C569.2 436.233 568.633 437.867 568.633 438.4V447.6C568.633 449.2 568.1 450.833 567.033 451.367C566.557 451.899 565.971 452.322 565.314 452.604C564.658 452.886 563.947 453.021 563.233 453C561.633 453 560.567 452.433 560 451.367C559.148 449.136 558.784 446.749 558.933 444.367C558.933 443.267 558.933 442.167 559.467 441.1C559.467 440 560 438.4 560.533 435.167L562.7 424.333V423.267C562.7 423.267 562.167 422.733 562.167 423.267L558.933 429.733C558.933 430.3 558.367 430.833 557.833 431.9C557.19 433.122 556.644 434.392 556.2 435.7C555.667 436.233 555.667 437.3 555.667 438.933C555.667 440.567 555.133 442.167 555.133 443.8C555.133 444.867 554.6 446.5 554.6 449.2V459.467C554.573 460.47 554.182 461.43 553.5 462.167L552.433 463.267C551.9 463.8 550.267 463.8 548.1 463.8C545.433 463.8 543.233 463.8 540.533 464.333H539.467C538.933 464.333 538.367 464.333 538.367 464.867C536.2 465.967 533.5 467.033 530.8 469.2C528.133 471.367 525.4 473.533 522.7 477.3C521.633 478.4 519.467 481.633 516.2 486.5C515.133 488.133 514.6 489.2 513.533 490.833C511.367 494.067 509.2 497.3 507.033 499.5C504.967 501.94 502.604 504.112 500 505.967C498.051 507.45 496.073 508.895 494.067 510.3C492.889 511.075 491.795 511.968 490.8 512.967C490.267 513.533 490.267 514.067 490.267 514.067C490.8 514.6 491.367 514.6 491.9 514.067C492.433 514.067 492.433 514.067 492.967 513.533H493.5C495.167 513 496.767 511.9 498.367 511.367L503.233 508.133C504.867 507.033 507.033 504.867 509.733 502.167C512.433 499.5 515.133 496.233 517.833 493C520.533 489.2 522.7 486.5 524.333 483.8C526.29 481.417 528.662 479.407 531.333 477.867C533.5 476.767 534.6 476.233 535.667 476.233C536.767 475.7 537.833 475.7 538.933 475.7H544.867C545.4 475.7 545.933 475.7 546.5 475.167C547.732 474.456 548.828 473.53 549.733 472.433C550.8 471.367 551.9 469.767 552.967 468.667C553.5 468.133 554.6 467.033 555.667 465.433C556.767 464.333 557.3 463.8 557.833 463.8C558.933 465.433 560 465.967 561.633 465.967C563.233 465.967 564.867 464.867 566.5 462.733C568.1 460.567 569.167 458.4 570.833 455.167C571.9 452.433 572.433 449.733 572.967 448.133C574.043 443.884 574.592 439.517 574.6 435.133C574.6 430.8 574.6 427.033 575.667 423.8C575.133 422.733 575.133 421.667 575.133 421.667ZM654.067 455.667C654.067 455.667 653.5 456.233 652.967 457.333C652.471 458.159 652.11 459.06 651.9 460C651.367 460.567 650.8 460.567 650.267 460.567C649.733 460.567 649.2 460 649.2 460.567C648.1 463.8 647.033 464.9 645.933 464.9C645.933 464.9 645.4 464.9 644.867 464.333C644.333 464.333 643.8 464.867 643.233 466.5C642.167 468.133 641.633 468.667 640 468.667L637.833 468.133C636.894 468.346 635.994 468.706 635.167 469.2C634.067 469.733 632.967 470.833 631.9 473C631.166 474.032 630.189 474.867 629.055 475.431C627.921 475.995 626.666 476.27 625.4 476.233C623.651 476.189 621.955 475.62 620.533 474.6C618.933 473 617.867 470.267 617.867 466.5V464.333C617.867 462.733 617.867 461.1 618.367 458.4C618.933 453.533 618.933 450.3 619.467 448.133V447.033C618.933 447.033 618.933 447.033 618.933 447.6L616.767 453L614.6 458.4C614.067 458.933 614.067 460.567 614.067 462.167C614.067 464.333 614.067 465.967 613.5 467.033V470.833C613.5 476.233 612.967 479.5 612.967 480.567C612.967 481.633 612.433 482.733 612.433 483.233C612.046 484.664 611.301 485.972 610.267 487.033C609.2 488.133 608.1 488.133 606.5 488.133C604.867 488.133 604.333 487.6 603.8 487.6C602.7 487.6 602.133 487.033 601.633 487.033C600.146 487.204 598.689 487.574 597.3 488.133C594.975 489.279 592.945 490.944 591.367 493C590.15 494.532 589.057 496.16 588.1 497.867C587.567 498.933 587.567 499.467 588.1 499.467H589.2C591.822 497.929 594.83 497.177 597.867 497.3C598.367 497.3 599.467 497.867 601.067 497.867C602.167 497.867 603.8 497.867 605.4 497.3C607.25 496.613 608.916 495.506 610.267 494.067L613.5 489.2C615.167 486.533 615.667 484.867 616.2 484.867H616.767C618.367 487.033 620 488.133 622.7 488.133C625.4 488.133 628.1 486.5 630.267 482.733C632.433 478.933 634.067 477.3 636.2 476.233H638.933C640 476.233 641.6 474.6 644.333 471.9C644.867 471.367 645.933 471.367 646.5 470.833C647.033 470.833 648.1 470.3 648.633 469.2C649.2 468.667 650.3 467.6 651.367 467.033C652.433 466.5 652.967 464.867 653.5 463.8L655.167 458.933C654.6 456.767 654.6 456.2 654.067 455.667C654.6 455.667 654.6 455.667 654.067 455.667ZM622.733 512.433C622.167 512.433 621.633 514.1 620 516.767C618.933 519.467 617.833 521.1 617.833 521.633C617.833 522.167 617.833 522.733 618.367 522.733C618.933 523.267 620 523.8 621.067 524.867C621.625 525.493 622.398 525.886 623.233 525.967C623.8 525.967 624.867 524.867 625.933 522.733C626.81 521.242 627.367 519.585 627.567 517.867C627.567 516.767 626.5 515.7 625.4 514.067C625.149 513.575 624.767 513.163 624.296 512.875C623.826 512.587 623.285 512.434 622.733 512.433ZM683.233 467.6C683.519 467.911 683.912 468.101 684.333 468.133C685.4 468.133 687 465.967 689.2 462.167C690.267 462.733 690.8 463.8 691.867 464.867C692.967 465.967 693.533 466.533 694.067 466.533C694.6 466.533 695.667 465.433 696.733 463.8C698.4 461.633 698.933 460 698.933 458.933C698.905 458.177 698.693 457.439 698.315 456.782C697.938 456.126 697.406 455.572 696.767 455.167C695.667 454.067 694.6 453 693.5 453C692.967 453 692.433 453.533 691.9 455.167C690.8 456.767 690.267 457.833 689.2 459.5C688.462 458.287 687.552 457.187 686.5 456.233C685.4 455.167 684.333 454.6 683.8 454.6C683.233 454.6 682.7 456.233 681.067 458.933C680.044 460.4 679.319 462.054 678.933 463.8L680.533 465.433C681.529 466.028 682.437 466.757 683.233 467.6ZM787.567 416.767C787.567 416.767 786.5 417.867 785.4 419.467C784.333 420.567 783.8 422.167 782.733 423.267C782.167 422.167 781.067 421.1 780 420C778.367 418.933 777.833 418.4 776.767 418.4C776.2 418.4 775.133 420 773.5 422.733C771.9 425.967 770.833 427.6 770.833 428.133L773.5 430.8C775.167 432.467 776.2 433 776.767 433C777.833 433 780 430.833 782.167 426.5C783.37 427.237 784.46 428.147 785.4 429.2C786.5 430.3 787.033 430.833 787.567 430.833C788.1 430.833 789.2 429.733 790.8 427.6C792.433 425.433 792.967 423.8 792.967 422.167C792.938 421.41 792.726 420.672 792.348 420.016C791.971 419.359 791.44 418.805 790.8 418.4C789.919 417.532 788.788 416.961 787.567 416.767ZM788.1 449.767C787.567 449.767 787.567 450.3 787.033 450.833C786.5 451.367 785.933 452.433 785.4 453C784.333 453 783.233 453 782.167 453.533C781.067 454.067 779.467 454.6 778.367 456.233C777.3 457.867 776.2 458.933 775.7 459.467C774.6 460.567 774.033 461.633 774.033 462.167C772.967 463.267 772.433 463.8 771.367 463.8H769.2C767.567 463.8 765.933 463.8 764.867 464.333H763.8C763.233 464.333 762.7 464.333 762.7 464.867C760.533 465.967 757.833 467.033 755.133 469.2C752.433 471.367 749.733 473.533 747.033 477.3C745.933 478.4 743.8 481.633 740.533 486.5C739.467 488.133 738.933 489.2 737.867 490.833C735.667 494.067 733.533 497.3 731.367 499.5C729.301 501.94 726.938 504.112 724.333 505.967C722.167 507.6 720 509.2 718.367 510.3C717.201 511.076 716.117 511.97 715.133 512.967C714.6 513.533 714.6 514.067 714.6 514.067C715.133 514.6 715.667 514.6 716.2 514.067C716.767 514.067 716.767 514.067 717.3 513.533H717.833C719.467 513 721.067 511.9 722.7 511.367L727.567 508.133C729.2 507.033 731.367 504.867 734.067 502.167C736.733 499.5 739.467 496.233 742.167 493C744.833 489.2 747.033 486.5 748.633 483.8C750.6 481.414 752.983 479.403 755.667 477.867C757.833 476.767 758.933 476.233 760 476.233C761.067 475.7 762.167 475.7 763.233 475.7H765.4C767.567 475.7 769.2 475.167 770.267 474.067C771.367 473 773.5 469.733 776.767 464.333C777.833 462.733 778.367 462.167 779.433 461.667C780.037 461.083 780.805 460.7 781.633 460.567C782.167 460.567 783.233 460 783.8 460C784.867 460 786.467 457.867 788.133 454.067C788.633 452.433 788.633 451.9 788.633 451.367C788.633 449.733 788.633 449.2 788.1 449.733V449.767ZM780.533 417.867C781.633 418.933 782.7 419.467 782.7 419.467C783.233 419.467 784.333 418.4 785.4 416.233C786.5 414.067 787.567 412.433 787.567 410.833C787.567 409.2 787.033 408.133 785.4 406.5C783.8 405.433 782.733 404.333 781.633 404.333C781.067 404.333 780 405.967 778.933 408.667C777.997 410.185 777.268 411.821 776.767 413.533C776.767 414.067 777.3 414.6 777.833 414.6C778.367 416.233 779.467 416.767 780.533 417.867ZM718.933 485.433C719.467 484.867 720 484.333 720.533 483.267C721.205 482.65 721.759 481.916 722.167 481.1C723.233 480 723.8 478.933 724.833 477.867C725.933 476.767 726.5 476.767 727.567 476.233C728.633 476.233 729.733 475.7 730.8 475.7H731.9C732.967 475.7 733.5 475.167 734.567 474.067C735.785 472.841 736.718 471.361 737.3 469.733C738.245 468.22 738.974 466.582 739.467 464.867C740.129 462.956 740.489 460.955 740.533 458.933C740.533 456.767 741.067 450.833 741.633 441.1C741.633 439.467 741.633 437.3 742.167 435.7V429.2C742.167 428.667 741.633 428.667 741.633 429.2L739.467 435.167L736.767 443.267V458.933C736.767 460 736.767 461.633 736.2 463.267C736.2 464.867 735.667 465.933 735.667 467.033C735.133 468.667 734.6 469.2 733.5 468.667C732.433 468.133 731.9 468.133 730.833 468.133C729.244 468.52 727.763 469.261 726.5 470.3C725.933 470.833 725.4 471.9 724.333 472.967C723.233 474.067 722.7 474.633 722.7 475.167C721.56 476.475 720.049 477.406 718.367 477.833C716.767 478.933 714.6 479.5 711.9 480.567C707.567 481.633 704.333 482.733 701.633 483.233C698.933 483.8 695.133 483.8 690.8 484.333H678.933C674.6 484.333 671.367 483.8 669.2 483.267C667.033 482.733 665.4 482.167 664.333 481.1C663.8 480.624 663.378 480.037 663.096 479.381C662.814 478.724 662.679 478.014 662.7 477.3C662.7 475.7 662.167 474.633 661.633 474.633C661.067 474.633 660.533 476.233 660.533 478.967C660 481.633 660 483.8 660 486.5C660 490.3 661.067 493 663.8 494.6C665.918 495.831 668.356 496.4 670.8 496.233C673.5 496.767 676.2 496.767 679.467 496.767C687.567 496.767 695.133 496.233 701.633 494.6C708.1 493 713.5 490.833 716.767 488.667C716.767 487.6 717.833 486.5 718.933 485.433ZM663.267 439.467C664.333 440 664.867 441.1 666.5 442.167C667.567 443.267 668.1 443.8 668.633 443.8C669.2 443.8 670.3 442.733 671.367 441.1C672.433 438.933 673.5 437.3 673.5 435.7C673.48 434.941 673.276 434.198 672.904 433.536C672.532 432.873 672.005 432.312 671.367 431.9C669.7 430.833 668.633 429.733 668.1 429.733C668.1 429.733 667.033 430.833 665.933 432.433C665.4 433.533 664.333 435.167 663.8 436.233C663.233 434.906 662.281 433.779 661.067 433C660 431.9 658.933 431.367 658.4 431.367C657.833 431.367 656.733 433 655.667 435.7C654.735 437.221 654.007 438.857 653.5 440.567L656.2 443.233C657.867 444.9 658.933 445.433 659.467 445.433C659.467 445.967 661.067 443.8 663.233 439.467H663.267Z"/>
        </svg>
      </div>
    );
  }
  if (name === "grid") {
    return (
      <svg className={classname} style={style} width="20" height="20" viewBox="0 0 20 20" fill="currentColor" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
      <rect width="20" height="20" rx="10" stroke="none"/>
      <path d="M6.5 11.8845C6.5 11.3769 6.5 11.123 6.65771 10.9653C6.81543 10.8076 7.06926 10.8076 7.57692 10.8076H8.11538C8.62305 10.8076 8.87688 10.8076 9.03459 10.9653C9.1923 11.123 9.1923 11.3769 9.1923 11.8845V12.423C9.1923 12.9307 9.1923 13.1845 9.03459 13.3422C8.87688 13.4999 8.62305 13.4999 8.11538 13.4999C7.35389 13.4999 6.97313 13.4999 6.73657 13.2634C6.5 13.0268 6.5 12.646 6.5 11.8845Z" fill="none"/>
      <path d="M6.5 8.11538C6.5 7.35389 6.5 6.97314 6.73657 6.73657C6.97313 6.5 7.35389 6.5 8.11538 6.5C8.62305 6.5 8.87688 6.5 9.03459 6.65771C9.1923 6.81543 9.1923 7.06926 9.1923 7.57692V8.11538C9.1923 8.62305 9.1923 8.87688 9.03459 9.03459C8.87688 9.19231 8.62305 9.19231 8.11538 9.19231H7.57692C7.06926 9.19231 6.81543 9.19231 6.65771 9.03459C6.5 8.87688 6.5 8.62305 6.5 8.11538Z" fill="none"/>
      <path d="M10.8077 11.8845C10.8077 11.3769 10.8077 11.123 10.9654 10.9653C11.1231 10.8076 11.3769 10.8076 11.8846 10.8076H12.4231C12.9307 10.8076 13.1846 10.8076 13.3423 10.9653C13.5 11.123 13.5 11.3769 13.5 11.8845C13.5 12.646 13.5 13.0268 13.2634 13.2634C13.0268 13.4999 12.6461 13.4999 11.8846 13.4999C11.3769 13.4999 11.1231 13.4999 10.9654 13.3422C10.8077 13.1845 10.8077 12.9307 10.8077 12.423V11.8845Z" fill="none"/>
      <path d="M10.8077 7.57692C10.8077 7.06926 10.8077 6.81543 10.9654 6.65771C11.1231 6.5 11.3769 6.5 11.8846 6.5C12.6461 6.5 13.0268 6.5 13.2634 6.73657C13.5 6.97314 13.5 7.35389 13.5 8.11538C13.5 8.62305 13.5 8.87688 13.3423 9.03459C13.1846 9.19231 12.9307 9.19231 12.4231 9.19231H11.8846C11.3769 9.19231 11.1231 9.19231 10.9654 9.03459C10.8077 8.87688 10.8077 8.62305 10.8077 8.11538V7.57692Z" fill="none"/>
      </svg>
    );
  }
  if (name === "list") {
    return (
      <svg className={classname} style={style} width="20" height="20" viewBox="0 0 20 20" fill="currentColor" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
      <rect width="20" height="20" rx="10" stroke="none"/>
      <path d="M11.05 10H6.49999" fill="none" stroke-linecap="round"/>
      <path d="M13.5 10H13.15" fill="none" stroke-linecap="round"/>
      <path d="M13.5 7.55005H13.15" fill="none" stroke-linecap="round"/>
      <path d="M13.5 12.45H13.15" fill="none" stroke-linecap="round"/>
      <path d="M11.05 7.55005H6.49999" fill="none" stroke-linecap="round"/>
      <path d="M11.05 12.45H6.49999" fill="none" stroke-linecap="round"/>
      </svg>
    );
  }
}

export default memo(SVG);
